import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeUtc: { input: any; output: any; }
  Email: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AbacString = {
  __typename?: 'ABACString';
  is_accessible?: Maybe<Scalars['Boolean']['output']>;
  is_presented?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AtsRecordActor = {
  __typename?: 'ATSRecordActor';
  avatar?: Maybe<Avatar>;
  first_name: Scalars['String']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
};

export type AtsRecordComment = TalentLogRecordInterface & {
  __typename?: 'ATSRecordComment';
  actor?: Maybe<AtsRecordActor>;
  company_id?: Maybe<Scalars['ID']['output']>;
  date: Scalars['DateTimeUtc']['output'];
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type: AtsRecordTypeEnum;
};

export type AtsRecordJobMatchAction = TalentLogRecordInterface & {
  __typename?: 'ATSRecordJobMatchAction';
  actor?: Maybe<AtsRecordActor>;
  company_id?: Maybe<Scalars['ID']['output']>;
  date: Scalars['DateTimeUtc']['output'];
  id: Scalars['ID']['output'];
  job_match_action?: Maybe<JobMatchAction>;
  type: AtsRecordTypeEnum;
};

export const AtsRecordTypeEnum = {
  CompanyUserCommented: 'COMPANY_USER_COMMENTED',
  JobMatchAction: 'JOB_MATCH_ACTION'
} as const;

export type AtsRecordTypeEnum = typeof AtsRecordTypeEnum[keyof typeof AtsRecordTypeEnum];
export type AtsRecordsUnion = AtsRecordComment | AtsRecordJobMatchAction;

export const AccountType = {
  CompanyUser: 'COMPANY_USER',
  Talent: 'TALENT'
} as const;

export type AccountType = typeof AccountType[keyof typeof AccountType];
export const AccountTypeEnum = {
  Free: 'FREE',
  Matcher: 'MATCHER',
  MatcherComplementary: 'MATCHER_COMPLEMENTARY',
  Member: 'MEMBER',
  Recruiter: 'RECRUITER'
} as const;

export type AccountTypeEnum = typeof AccountTypeEnum[keyof typeof AccountTypeEnum];
export type AvailableJobForTalent = {
  __typename?: 'AvailableJobForTalent';
  is_applied: Scalars['Boolean']['output'];
  is_invited: Scalars['Boolean']['output'];
  job?: Maybe<Job>;
};

export type Avatar = {
  __typename?: 'Avatar';
  avatar: Scalars['String']['output'];
  hash?: Maybe<Scalars['String']['output']>;
};

export const BooleanOperatorsEnum = {
  And: 'AND',
  Not: 'NOT',
  Or: 'OR'
} as const;

export type BooleanOperatorsEnum = typeof BooleanOperatorsEnum[keyof typeof BooleanOperatorsEnum];
export const BroadbeanJobStatusEnum = {
  Draft: 'DRAFT',
  Posted: 'POSTED'
} as const;

export type BroadbeanJobStatusEnum = typeof BroadbeanJobStatusEnum[keyof typeof BroadbeanJobStatusEnum];
export type BroadbeanJobSubmission = {
  __typename?: 'BroadbeanJobSubmission';
  broadbean_url?: Maybe<Scalars['String']['output']>;
};

export const CanHelpWithEnum = {
  KnowCompaniesThatBenefits: 'KNOW_COMPANIES_THAT_BENEFITS',
  KnowTheCeo: 'KNOW_THE_CEO',
  PeopleInRecruitment: 'PEOPLE_IN_RECRUITMENT',
  PeopleLookingForTalentPooling: 'PEOPLE_LOOKING_FOR_TALENT_POOLING'
} as const;

export type CanHelpWithEnum = typeof CanHelpWithEnum[keyof typeof CanHelpWithEnum];
export type ChatMessage = {
  __typename?: 'ChatMessage';
  company_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['ID']['output']>;
  talent_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

/** A paginated list of ChatMessage items. */
export type ChatMessagePaginator = {
  __typename?: 'ChatMessagePaginator';
  /** A list of ChatMessage items. */
  data: Array<ChatMessage>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CommonAppInfo = {
  __typename?: 'CommonAppInfo';
  total_ot_approved_freelancers_count: Scalars['Int']['output'];
  total_ot_freelancers_count: Scalars['Int']['output'];
  total_ot_freelancers_countries_count: Scalars['Int']['output'];
  total_ot_pool_active_talents_count: Scalars['Int']['output'];
  total_ot_recruiters_count: Scalars['Int']['output'];
  total_ot_recruiters_countries_count: Scalars['Int']['output'];
  total_unique_companies_count: Scalars['Int']['output'];
  total_unique_skills_count: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  about?: Maybe<Scalars['String']['output']>;
  account_type?: Maybe<CompanyAccountTypeEnum>;
  address?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<CurrencyEnum>;
  id: Scalars['ID']['output'];
  is_broadbean_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_vonage_enabled?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<CompanyLogo>;
  name: Scalars['String']['output'];
  onboarding_countries?: Maybe<Array<Country>>;
  primary_branding_color?: Maybe<Scalars['String']['output']>;
  primary_user?: Maybe<User>;
  region?: Maybe<RegionEnum>;
  secondary_branding_color?: Maybe<Scalars['String']['output']>;
  sign_up_landing_link?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type_of_activity?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export const CompanyAccountTypeEnum = {
  Enterprise: 'ENTERPRISE',
  Free: 'FREE',
  None: 'NONE',
  Paid: 'PAID'
} as const;

export type CompanyAccountTypeEnum = typeof CompanyAccountTypeEnum[keyof typeof CompanyAccountTypeEnum];
export type CompanyLogo = {
  __typename?: 'CompanyLogo';
  hash?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** A paginated list of Company items. */
export type CompanyPaginator = {
  __typename?: 'CompanyPaginator';
  /** A list of Company items. */
  data: Array<Company>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export const CompanyPoolingTypeEnum = {
  Company: 'COMPANY',
  Opentalent: 'OPENTALENT',
  Recruiter: 'RECRUITER'
} as const;

export type CompanyPoolingTypeEnum = typeof CompanyPoolingTypeEnum[keyof typeof CompanyPoolingTypeEnum];
export type CompanyPublicInfo = {
  __typename?: 'CompanyPublicInfo';
  talents_count?: Maybe<Scalars['Int']['output']>;
};

export type CompanySimpleSearchResult = {
  __typename?: 'CompanySimpleSearchResult';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanyUserAccountSettings = {
  __typename?: 'CompanyUserAccountSettings';
  locale?: Maybe<LocaleEnum>;
  pref_date_format?: Maybe<DateFormatEnum>;
  pref_lang?: Maybe<Scalars['String']['output']>;
  receive_chat_messages?: Maybe<Scalars['Boolean']['output']>;
  receive_company_and_product_updates?: Maybe<Scalars['Boolean']['output']>;
  receive_job_invitation_responses?: Maybe<Scalars['Boolean']['output']>;
  receive_talent_join_notifications?: Maybe<Scalars['Boolean']['output']>;
  receive_talent_proposal_notifications?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyUserAccountSettingsInput = {
  locale?: InputMaybe<LocaleEnum>;
  pref_date_format?: InputMaybe<DateFormatEnum>;
  pref_lang?: InputMaybe<Scalars['String']['input']>;
  receive_chat_messages?: InputMaybe<Scalars['Boolean']['input']>;
  receive_company_and_product_updates?: InputMaybe<Scalars['Boolean']['input']>;
  receive_job_invitation_responses?: InputMaybe<Scalars['Boolean']['input']>;
  receive_talent_join_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  receive_talent_proposal_notifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Company user onboarding flow types */
export const CompanyUserOnboardingTypeEnum = {
  Main: 'MAIN',
  RecruiterOnboarding: 'RECRUITER_ONBOARDING',
  Simple: 'SIMPLE'
} as const;

export type CompanyUserOnboardingTypeEnum = typeof CompanyUserOnboardingTypeEnum[keyof typeof CompanyUserOnboardingTypeEnum];
/** Company user recruiter employment type */
export const CompanyUserRecruiterEmploymentTypeEnum = {
  Agency: 'AGENCY',
  Company: 'COMPANY'
} as const;

export type CompanyUserRecruiterEmploymentTypeEnum = typeof CompanyUserRecruiterEmploymentTypeEnum[keyof typeof CompanyUserRecruiterEmploymentTypeEnum];
/** Company user roles */
export const CompanyUserRoleEnum = {
  AccountAdmin: 'ACCOUNT_ADMIN',
  AccountUser: 'ACCOUNT_USER'
} as const;

export type CompanyUserRoleEnum = typeof CompanyUserRoleEnum[keyof typeof CompanyUserRoleEnum];
export type Country = {
  __typename?: 'Country';
  id: Scalars['ID']['output'];
  is_europe: Scalars['Boolean']['output'];
  is_us: Scalars['Boolean']['output'];
  is_used_for_jobs: Scalars['Boolean']['output'];
  is_used_for_recruiter_profiles: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CreateFieldGlassCandidateIntroductionInput = {
  additional_invoice_currency?: InputMaybe<Scalars['String']['input']>;
  answers: Scalars['JSON']['input'];
  calculate_rate_using?: InputMaybe<Scalars['String']['input']>;
  candidate_cv_hash?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  creator_username?: InputMaybe<Scalars['String']['input']>;
  cv_attachment_hash?: InputMaybe<Scalars['String']['input']>;
  date_available: Scalars['DateTime']['input'];
  date_of_birth?: InputMaybe<Scalars['DateTime']['input']>;
  display_candidate_workforce_record_to_the_buyer: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['Email']['input']>;
  external_job_seeker_id?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  job_id?: InputMaybe<Scalars['ID']['input']>;
  job_posting_id: Scalars['String']['input'];
  job_seeker_code?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  location_code: Scalars['String']['input'];
  number_of_tiers?: InputMaybe<Scalars['Int']['input']>;
  payment_currency?: InputMaybe<Scalars['String']['input']>;
  primary_location_code?: InputMaybe<Scalars['String']['input']>;
  qualifications: Scalars['JSON']['input'];
  rate_change_matrix_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  register_on_behalf_of_worker?: InputMaybe<Scalars['Boolean']['input']>;
  remit_to_address_code?: InputMaybe<Scalars['String']['input']>;
  security_id: Scalars['String']['input'];
  select_rates?: InputMaybe<Scalars['String']['input']>;
  site_code: Scalars['String']['input'];
  standard_bill_rate?: InputMaybe<Scalars['Float']['input']>;
  standard_pay_rate?: InputMaybe<Scalars['Float']['input']>;
  submitted_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  submitted_to_other_job_postings: Scalars['Boolean']['input'];
  supplier_email?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  worker_country_of_origin?: InputMaybe<Scalars['String']['input']>;
  worker_pay_type: Scalars['String']['input'];
};

export const CurrencyEnum = {
  Eur: 'EUR',
  Usd: 'USD'
} as const;

export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
export type CurrentTalentJobBoardSearchResult = Job | TalentJobConnection;

export type CurrentUserAccounts = {
  __typename?: 'CurrentUserAccounts';
  company_user_accounts?: Maybe<Array<Maybe<User>>>;
  talent_accounts?: Maybe<Array<Maybe<Talent>>>;
};

export type CvCompanyExtraction = {
  __typename?: 'CvCompanyExtraction';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CvDataExtraction = {
  __typename?: 'CvDataExtraction';
  about?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type DashboardAnalyticsItem = {
  __typename?: 'DashboardAnalyticsItem';
  children?: Maybe<Array<Maybe<DashboardAnalyticsItem>>>;
  key?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Date format enum for preferred date format settings */
export const DateFormatEnum = {
  /** AUS Date Format: DD/MM/YYYY, h:mm AM/PM */
  Aus: 'AUS',
  /** US Date Format: MM/DD/YYYY, h:mm AM/PM */
  Us: 'US'
} as const;

export type DateFormatEnum = typeof DateFormatEnum[keyof typeof DateFormatEnum];
export type ExternalJob = {
  __typename?: 'ExternalJob';
  application_active: Scalars['Boolean']['output'];
  category?: Maybe<TalentCategory>;
  company_name?: Maybe<Scalars['String']['output']>;
  company_url?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  deleted: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  employment_type?: Maybe<ExternalJobEmploymentTypeEnum>;
  external_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_saved: Scalars['Boolean']['output'];
  last_updated?: Maybe<Scalars['DateTime']['output']>;
  linkedin_job_id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  match_quality?: Maybe<MatchQualityEnum>;
  salary?: Maybe<Scalars['Float']['output']>;
  seniority?: Maybe<ExternalJobSeniorityLevelEnum>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export const ExternalJobEmploymentTypeEnum = {
  Contract: 'CONTRACT',
  FullTime: 'FULL_TIME',
  Internship: 'INTERNSHIP',
  Other: 'OTHER',
  PartTime: 'PART_TIME',
  Temporary: 'TEMPORARY',
  Volunteer: 'VOLUNTEER'
} as const;

export type ExternalJobEmploymentTypeEnum = typeof ExternalJobEmploymentTypeEnum[keyof typeof ExternalJobEmploymentTypeEnum];
/** A paginated list of ExternalJob items. */
export type ExternalJobPaginator = {
  __typename?: 'ExternalJobPaginator';
  /** A list of ExternalJob items. */
  data: Array<ExternalJob>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export const ExternalJobSeniorityLevelEnum = {
  Associate: 'ASSOCIATE',
  Director: 'DIRECTOR',
  EntryLevel: 'ENTRY_LEVEL',
  Executive: 'EXECUTIVE',
  Internship: 'INTERNSHIP',
  MidSeniorLevel: 'MID_SENIOR_LEVEL',
  NotApplicable: 'NOT_APPLICABLE'
} as const;

export type ExternalJobSeniorityLevelEnum = typeof ExternalJobSeniorityLevelEnum[keyof typeof ExternalJobSeniorityLevelEnum];
export type FieldGlassCandidateIntroduction = {
  __typename?: 'FieldGlassCandidateIntroduction';
  additional_invoice_currency?: Maybe<Scalars['String']['output']>;
  answers?: Maybe<Scalars['JSON']['output']>;
  api_response?: Maybe<Scalars['JSON']['output']>;
  calculate_rate_using?: Maybe<Scalars['String']['output']>;
  candidate_cv_hash?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  creator_username?: Maybe<Scalars['String']['output']>;
  cv_attachment?: Maybe<File>;
  date_available?: Maybe<Scalars['DateTime']['output']>;
  date_of_birth?: Maybe<Scalars['DateTime']['output']>;
  display_candidate_workforce_record_to_the_buyer?: Maybe<Scalars['Boolean']['output']>;
  double_pay_rate?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  external_job_seeker_id?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  job_match_id: Scalars['ID']['output'];
  job_posting_id?: Maybe<Scalars['String']['output']>;
  job_seeker_code?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location_code?: Maybe<Scalars['String']['output']>;
  number_of_tiers?: Maybe<Scalars['Int']['output']>;
  overtime_pay_rate?: Maybe<Scalars['Float']['output']>;
  payment_currency?: Maybe<Scalars['String']['output']>;
  primary_location_code?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Scalars['JSON']['output']>;
  rate_change_matrix_start_date?: Maybe<Scalars['DateTime']['output']>;
  register_on_behalf_of_worker?: Maybe<Scalars['Boolean']['output']>;
  remit_to_address_code?: Maybe<Scalars['String']['output']>;
  security_id?: Maybe<Scalars['String']['output']>;
  select_rates?: Maybe<Scalars['String']['output']>;
  site_code?: Maybe<Scalars['String']['output']>;
  standard_bill_rate?: Maybe<Scalars['Float']['output']>;
  standard_pay_rate?: Maybe<Scalars['Float']['output']>;
  submission_status?: Maybe<FieldGlassCandidateIntroductionSubmissionStatusEnum>;
  submitted_at?: Maybe<Scalars['DateTime']['output']>;
  submitted_by_user_id?: Maybe<Scalars['ID']['output']>;
  submitted_to_other_job_postings?: Maybe<Scalars['Boolean']['output']>;
  supplier_email?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  worker_country_of_origin?: Maybe<Scalars['String']['output']>;
  worker_pay_type?: Maybe<Scalars['String']['output']>;
};

export const FieldGlassCandidateIntroductionSubmissionStatusEnum = {
  Failed: 'FAILED',
  New: 'NEW',
  Processing: 'PROCESSING',
  Submitted: 'SUBMITTED'
} as const;

export type FieldGlassCandidateIntroductionSubmissionStatusEnum = typeof FieldGlassCandidateIntroductionSubmissionStatusEnum[keyof typeof FieldGlassCandidateIntroductionSubmissionStatusEnum];
export type File = {
  __typename?: 'File';
  content_type: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  file_type?: Maybe<FileTypeEnum>;
  hash: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type FileInput = {
  file: Scalars['Upload']['input'];
  file_type: FileTypeEnum;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
};

export const FileTypeEnum = {
  CandidateIntroductionCv: 'CANDIDATE_INTRODUCTION_CV',
  CompanyLogo: 'COMPANY_LOGO',
  CompanyUserAvatar: 'COMPANY_USER_AVATAR',
  MotivationLetter: 'MOTIVATION_LETTER',
  ScreeningQuestionnaire: 'SCREENING_QUESTIONNAIRE',
  SuggestionCv: 'SUGGESTION_CV',
  TalentAvatar: 'TALENT_AVATAR',
  TalentDocument: 'TALENT_DOCUMENT'
} as const;

export type FileTypeEnum = typeof FileTypeEnum[keyof typeof FileTypeEnum];
export type Industry = {
  __typename?: 'Industry';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Order by clause for the `orderBy` argument on the query `posts`. */
export const InstantMatchesNotificationsScoreEnum = {
  Score_50: 'SCORE_50',
  Score_70: 'SCORE_70',
  Score_90: 'SCORE_90'
} as const;

export type InstantMatchesNotificationsScoreEnum = typeof InstantMatchesNotificationsScoreEnum[keyof typeof InstantMatchesNotificationsScoreEnum];
export type InvitationLink = {
  __typename?: 'InvitationLink';
  id: Scalars['ID']['output'];
  inviting_talent?: Maybe<Talent>;
  is_used: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type InvitationLinkInfo = {
  __typename?: 'InvitationLinkInfo';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inviting_person_name?: Maybe<Scalars['String']['output']>;
  is_used: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Job = {
  __typename?: 'Job';
  broadbean_response?: Maybe<Scalars['JSONObject']['output']>;
  broadbean_status?: Maybe<BroadbeanJobStatusEnum>;
  campaign_duration?: Maybe<Scalars['Int']['output']>;
  campaign_end_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  campaign_owner?: Maybe<User>;
  campaign_start_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  campaign_talent_pool?: Maybe<Array<Maybe<SourceTypeEnum>>>;
  capacity?: Maybe<Scalars['String']['output']>;
  category?: Maybe<TalentCategory>;
  city?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  finders_fee?: Maybe<Scalars['Float']['output']>;
  hours_per_week?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instant_matches_count: Scalars['Int']['output'];
  invitations?: Maybe<Array<Maybe<JobInvitation>>>;
  is_applied?: Maybe<Scalars['Boolean']['output']>;
  is_applied_as_matcher?: Maybe<Scalars['Boolean']['output']>;
  is_archived: Scalars['Boolean']['output'];
  is_assigned_as_matcher?: Maybe<Scalars['Boolean']['output']>;
  /** Determines whether the job campaign saved as draft */
  is_draft?: Maybe<Scalars['Boolean']['output']>;
  is_instant_campaign_start?: Maybe<Scalars['Boolean']['output']>;
  is_instant_matching_in_progress?: Maybe<Scalars['Boolean']['output']>;
  is_old_format: Scalars['Boolean']['output'];
  is_rate_negotiable?: Maybe<Scalars['Boolean']['output']>;
  is_remote_an_option: Scalars['Boolean']['output'];
  is_salary_negotiable?: Maybe<Scalars['Boolean']['output']>;
  /** Context related attributes. Presented only if there is talent context */
  is_saved?: Maybe<Scalars['Boolean']['output']>;
  /** Applications made by matchers to source for the job */
  job_matcher_applications?: Maybe<Array<JobMatcherApplication>>;
  job_source_type?: Maybe<JobSourceType>;
  link_to_details?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  location_type?: Maybe<JobLocationTypeEnum>;
  /** Talent matchers who was assigned to job */
  matchers?: Maybe<Array<Maybe<Talent>>>;
  matches?: Maybe<Array<Maybe<JobMatch>>>;
  matches_count: Scalars['Int']['output'];
  matches_with_application_count: Scalars['Int']['output'];
  max_project_budget?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Number of hours in office for 'hybrid' jobs */
  office_hours_per_month?: Maybe<Scalars['Float']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  permanent_capacity_type?: Maybe<PermanentJobCapacityTypeEnum>;
  pitch?: Maybe<Scalars['String']['output']>;
  posted_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Propose to talent matchers */
  propose_to_matchers?: Maybe<Scalars['Boolean']['output']>;
  rate_max?: Maybe<Scalars['Float']['output']>;
  rate_min?: Maybe<Scalars['Float']['output']>;
  salary_max?: Maybe<Scalars['Float']['output']>;
  salary_min?: Maybe<Scalars['Float']['output']>;
  saved_matches?: Maybe<Array<Maybe<JobMatch>>>;
  /** Type of service provided for this job by Opentalent */
  service_type?: Maybe<JobServiceTypeEnum>;
  skills?: Maybe<Array<Maybe<JobSkill>>>;
  skills_boolean_filter?: Maybe<JobSkillsBooleanFilter>;
  start_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Stream chat id */
  stream_chat_subject_id?: Maybe<Scalars['String']['output']>;
  striive_job?: Maybe<StriiveJob>;
  subcategory?: Maybe<Subcategory>;
  type?: Maybe<JobTypeEnum>;
};

export type JobApplication = {
  __typename?: 'JobApplication';
  created_at: Scalars['DateTimeUtc']['output'];
  cv_hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  job: Job;
  job_id: Scalars['ID']['output'];
  pitch?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  talent_id: Scalars['ID']['output'];
};

export type JobApplicationInput = {
  cv_hash?: InputMaybe<Scalars['String']['input']>;
  job_id: Scalars['ID']['input'];
  pitch?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

export type JobBoardInfo = {
  __typename?: 'JobBoardInfo';
  talent_matches_count: Scalars['Int']['output'];
  talent_matches_count_archived: Scalars['Int']['output'];
  talent_responses_count: Scalars['Int']['output'];
  talent_responses_count_archived: Scalars['Int']['output'];
};

export type JobCommunitiesFilterInput = {
  company_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  include_external_jobs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobDeclination = {
  __typename?: 'JobDeclination';
  id: Scalars['ID']['output'];
  job_match_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<JobMatchDeclinationReasonsEnum>;
};

export type JobInvitation = {
  __typename?: 'JobInvitation';
  application?: Maybe<JobApplication>;
  id: Scalars['ID']['output'];
  is_accepted: Scalars['Boolean']['output'];
  is_declined?: Maybe<Scalars['Boolean']['output']>;
  job: Job;
  job_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  talent_id: Scalars['ID']['output'];
};

export const JobLocationTypeEnum = {
  Hybrid: 'HYBRID',
  OnSite: 'ON_SITE',
  Remote: 'REMOTE'
} as const;

export type JobLocationTypeEnum = typeof JobLocationTypeEnum[keyof typeof JobLocationTypeEnum];
export type JobMatch = {
  __typename?: 'JobMatch';
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  cv_skills_keywords?: Maybe<Array<Maybe<Skill>>>;
  id: Scalars['ID']['output'];
  is_applied: Scalars['Boolean']['output'];
  is_instant_match: Scalars['Boolean']['output'];
  is_invited: Scalars['Boolean']['output'];
  is_new: Scalars['Boolean']['output'];
  is_shortlist: Scalars['Boolean']['output'];
  is_talent_notified: Scalars['Boolean']['output'];
  job: Job;
  job_application?: Maybe<JobApplication>;
  job_invitation?: Maybe<JobInvitation>;
  job_match_declination?: Maybe<JobDeclination>;
  job_suggestion?: Maybe<JobSuggestion>;
  match_percent: Scalars['Int']['output'];
  match_quality?: Maybe<MatchQualityEnum>;
  match_type: JobMatchTypeEnum;
  matched_skills?: Maybe<Array<Maybe<Skill>>>;
  stage?: Maybe<JobMatchStageEnum>;
  suggesting_stage?: Maybe<SuggestingStageEnum>;
  talent?: Maybe<Talent>;
  talent_invitation?: Maybe<TalentInvitation>;
};

export type JobMatchAction = Node & {
  __typename?: 'JobMatchAction';
  action_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  job_match?: Maybe<JobMatch>;
  job_match_action_type: JobMatchActionTypeEnum;
  job_match_type_after?: Maybe<JobMatchTypeEnum>;
  job_match_type_before?: Maybe<JobMatchTypeEnum>;
};

export const JobMatchActionTypeEnum = {
  Application: 'APPLICATION',
  DirectIntake: 'DIRECT_INTAKE',
  /** finalizing types */
  Hired: 'HIRED',
  InitialInvitationMadeByCompanyUser: 'INITIAL_INVITATION_MADE_BY_COMPANY_USER',
  InitialInvitationMadeByTalent: 'INITIAL_INVITATION_MADE_BY_TALENT',
  InitialTalentApplication: 'INITIAL_TALENT_APPLICATION',
  /** generative types */
  InstantMatchCreated: 'INSTANT_MATCH_CREATED',
  /** transforming types */
  Invitation: 'INVITATION',
  InvitationAccepted: 'INVITATION_ACCEPTED',
  Rejected: 'REJECTED',
  Withdrawn: 'WITHDRAWN'
} as const;

export type JobMatchActionTypeEnum = typeof JobMatchActionTypeEnum[keyof typeof JobMatchActionTypeEnum];
export const JobMatchAppearanceStatusEnum = {
  New: 'NEW',
  Ordinary: 'ORDINARY',
  Recent: 'RECENT'
} as const;

export type JobMatchAppearanceStatusEnum = typeof JobMatchAppearanceStatusEnum[keyof typeof JobMatchAppearanceStatusEnum];
export const JobMatchDeclinationReasonsEnum = {
  CandidateWithdrewApplication: 'CANDIDATE_WITHDREW_APPLICATION',
  CulturalFitConcernsOrOther: 'CULTURAL_FIT_CONCERNS_OR_OTHER',
  DoesntMeetExperience: 'DOESNT_MEET_EXPERIENCE',
  DoesntMeetQualifications: 'DOESNT_MEET_QUALIFICATIONS',
  DoesntMeetSalary: 'DOESNT_MEET_SALARY',
  DoesntMeetVisa: 'DOESNT_MEET_VISA',
  DuplicationOfCandidate: 'DUPLICATION_OF_CANDIDATE',
  None: 'NONE',
  NotEnoughSkills: 'NOT_ENOUGH_SKILLS',
  OtherCandidatesAreBetterMatch: 'OTHER_CANDIDATES_ARE_BETTER_MATCH',
  PositionClosed: 'POSITION_CLOSED',
  PositionFilled: 'POSITION_FILLED'
} as const;

export type JobMatchDeclinationReasonsEnum = typeof JobMatchDeclinationReasonsEnum[keyof typeof JobMatchDeclinationReasonsEnum];
export const JobMatchDeclinationReasonsUsEnum = {
  AcceptedOtherPosition: 'ACCEPTED_OTHER_POSITION',
  BillRateExceedsMaxRate: 'BILL_RATE_EXCEEDS_MAX_RATE',
  CancelledJobPosting: 'CANCELLED_JOB_POSTING',
  CandidateWithdrew: 'CANDIDATE_WITHDREW',
  DoesNotMeetRequirements: 'DOES_NOT_MEET_REQUIREMENTS',
  DuplicateSubmittal: 'DUPLICATE_SUBMITTAL',
  IncorrectSubmittal: 'INCORRECT_SUBMITTAL',
  InterviewNoShowOrNonResponsive: 'INTERVIEW_NO_SHOW_OR_NON_RESPONSIVE',
  IssueWithPostingRecreated: 'ISSUE_WITH_POSTING_RECREATED',
  None: 'NONE',
  RejectedContactProgramOffice: 'REJECTED_CONTACT_PROGRAM_OFFICE',
  RejectionNewRole: 'REJECTION_NEW_ROLE',
  RejectionUnsuitable: 'REJECTION_UNSUITABLE',
  UnsuccessfulAtInterview: 'UNSUCCESSFUL_AT_INTERVIEW'
} as const;

export type JobMatchDeclinationReasonsUsEnum = typeof JobMatchDeclinationReasonsUsEnum[keyof typeof JobMatchDeclinationReasonsUsEnum];
export const JobMatchStageEnum = {
  Application: 'APPLICATION',
  ClientInterview: 'CLIENT_INTERVIEW',
  InstantMatch: 'INSTANT_MATCH',
  InternalInterview: 'INTERNAL_INTERVIEW',
  Offer: 'OFFER',
  Onboarding: 'ONBOARDING',
  Placement: 'PLACEMENT',
  Rejected: 'REJECTED',
  ShortList: 'SHORT_LIST',
  Submittal: 'SUBMITTAL'
} as const;

export type JobMatchStageEnum = typeof JobMatchStageEnum[keyof typeof JobMatchStageEnum];
export const JobMatchTypeEnum = {
  Hired: 'HIRED',
  InstantMatch: 'INSTANT_MATCH',
  Intake: 'INTAKE',
  Invited: 'INVITED',
  OpentalentSuggestion: 'OPENTALENT_SUGGESTION',
  Rejected: 'REJECTED',
  TalentApplication: 'TALENT_APPLICATION',
  Withdrawn: 'WITHDRAWN'
} as const;

export type JobMatchTypeEnum = typeof JobMatchTypeEnum[keyof typeof JobMatchTypeEnum];
export type JobMatcher = {
  __typename?: 'JobMatcher';
  job: Job;
  talent: Talent;
};

export type JobMatcherApplication = {
  __typename?: 'JobMatcherApplication';
  id: Scalars['ID']['output'];
  job: Job;
  matcher: Talent;
  message?: Maybe<Scalars['String']['output']>;
  status: JobMatcherApplicationStatusEnum;
};

export const JobMatcherApplicationStatusEnum = {
  Approved: 'APPROVED',
  Canceled: 'CANCELED',
  Rejected: 'REJECTED',
  Requested: 'REQUESTED',
  Unknown: 'UNKNOWN'
} as const;

export type JobMatcherApplicationStatusEnum = typeof JobMatcherApplicationStatusEnum[keyof typeof JobMatcherApplicationStatusEnum];
export const JobMatcherJobsFilterEnum = {
  AllAvailableForMatchersJobs: 'ALL_AVAILABLE_FOR_MATCHERS_JOBS',
  IsApplied: 'IS_APPLIED',
  IsAppliedOrAssigned: 'IS_APPLIED_OR_ASSIGNED',
  IsAssigned: 'IS_ASSIGNED',
  IsNotAppliedOrAssigned: 'IS_NOT_APPLIED_OR_ASSIGNED'
} as const;

export type JobMatcherJobsFilterEnum = typeof JobMatcherJobsFilterEnum[keyof typeof JobMatcherJobsFilterEnum];
export type JobOrderByClause = {
  /** The column that is used for ordering. */
  column: JobOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Order by clause for the `orderBy` argument on the query `posts`. */
export const JobOrderByColumn = {
  CampaignStart: 'CAMPAIGN_START',
  CreatedAt: 'CREATED_AT',
  RateMax: 'RATE_MAX',
  RateMin: 'RATE_MIN'
} as const;

export type JobOrderByColumn = typeof JobOrderByColumn[keyof typeof JobOrderByColumn];
/** A paginated list of Job items. */
export type JobPaginator = {
  __typename?: 'JobPaginator';
  /** A list of Job items. */
  data: Array<Job>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type JobRecommendation = {
  __typename?: 'JobRecommendation';
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  match_quality?: Maybe<MatchQualityEnum>;
  talent?: Maybe<Talent>;
};

/** A paginated list of JobRecommendation items. */
export type JobRecommendationPaginator = {
  __typename?: 'JobRecommendationPaginator';
  /** A list of JobRecommendation items. */
  data: Array<JobRecommendation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type JobResponse = {
  __typename?: 'JobResponse';
  created_at: Scalars['DateTimeUtc']['output'];
  job: Job;
  talent: Talent;
};

export type JobResponseCompany = {
  __typename?: 'JobResponseCompany';
  created_at: Scalars['DateTimeUtc']['output'];
  job: Job;
  skills?: Maybe<Array<Maybe<Skill>>>;
  talent: Talent;
};

export type JobRole = {
  __typename?: 'JobRole';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export const JobServiceTypeEnum = {
  DedicatedSearch: 'DEDICATED_SEARCH',
  SelfService: 'SELF_SERVICE'
} as const;

export type JobServiceTypeEnum = typeof JobServiceTypeEnum[keyof typeof JobServiceTypeEnum];
/** Job requested skill */
export type JobSkill = {
  __typename?: 'JobSkill';
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  id: Scalars['ID']['output'];
  job_skill_pivot?: Maybe<JobSkillPivot>;
  name: Scalars['String']['output'];
  skill_type: SkillTypeEnum;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

export type JobSkillPivot = {
  __typename?: 'JobSkillPivot';
  is_required?: Maybe<Scalars['Boolean']['output']>;
};

export type JobSkillsBooleanFilter = {
  __typename?: 'JobSkillsBooleanFilter';
  boolean_skills_filter_items?: Maybe<Array<Maybe<JobSkillsBooleanFilterItem>>>;
  not_skills?: Maybe<Array<Maybe<Skill>>>;
};

export type JobSkillsBooleanFilterItem = {
  __typename?: 'JobSkillsBooleanFilterItem';
  all_of_skills?: Maybe<Array<Maybe<Skill>>>;
  boolean_operator?: Maybe<BooleanOperatorsEnum>;
  one_of_skills?: Maybe<Array<Maybe<Skill>>>;
};

export const JobSourceType = {
  Coresignal: 'CORESIGNAL',
  Internal: 'INTERNAL',
  Striive: 'STRIIVE'
} as const;

export type JobSourceType = typeof JobSourceType[keyof typeof JobSourceType];
export const JobStatusEnum = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Draft: 'DRAFT'
} as const;

export type JobStatusEnum = typeof JobStatusEnum[keyof typeof JobStatusEnum];
export type JobSuggestion = {
  __typename?: 'JobSuggestion';
  cv_attachment?: Maybe<File>;
  email?: Maybe<Scalars['Email']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_suggested_by_matcher?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<Job>;
  last_name?: Maybe<Scalars['String']['output']>;
  motivation_letter_attachment?: Maybe<File>;
  rate?: Maybe<Scalars['Int']['output']>;
  salary?: Maybe<Scalars['Int']['output']>;
  screening_questionnaire_attachment?: Maybe<File>;
  suggested_by_talent?: Maybe<Talent>;
  talent?: Maybe<Talent>;
};

export const JobTypeEnum = {
  Freelance: 'FREELANCE',
  Permanent: 'PERMANENT',
  Project: 'PROJECT'
} as const;

export type JobTypeEnum = typeof JobTypeEnum[keyof typeof JobTypeEnum];
export type JobsCountByStatus = {
  __typename?: 'JobsCountByStatus';
  count: Scalars['Int']['output'];
  type: JobStatusEnum;
};

export const JoinReasonEnum = {
  Candidates: 'CANDIDATES',
  Freelance: 'FREELANCE',
  Networking: 'NETWORKING',
  PerksAndBenefits: 'PERKS_AND_BENEFITS',
  PermanentWork: 'PERMANENT_WORK',
  VentureBuilding: 'VENTURE_BUILDING'
} as const;

export type JoinReasonEnum = typeof JoinReasonEnum[keyof typeof JoinReasonEnum];
/** Locale enum for preferred locale settings */
export const LocaleEnum = {
  EnAu: 'EN_AU',
  EnUs: 'EN_US'
} as const;

export type LocaleEnum = typeof LocaleEnum[keyof typeof LocaleEnum];
export const MatchQualityEnum = {
  Fair: 'FAIR',
  Good: 'GOOD',
  Poor: 'POOR'
} as const;

export type MatchQualityEnum = typeof MatchQualityEnum[keyof typeof MatchQualityEnum];
export type Mutation = {
  __typename?: 'Mutation';
  /** Talent user pooling actions - accept company pool invitation */
  acceptCompanyPoolInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Talent user pooling actions - apply to company pool */
  applyCurrentTalentToCompanyPool?: Maybe<Scalars['Boolean']['output']>;
  /** Talent flow - create a job application */
  applyForJob: Scalars['Boolean']['output'];
  /** Approve action for company user who owns the job */
  approveJobMatcherApplication?: Maybe<JobMatcherApplication>;
  /** Company user pooling action - approve talent */
  approveTalentCompanyPoolApplication?: Maybe<Scalars['Boolean']['output']>;
  /** Talent flow - cancel existing application */
  cancelApplicationForJob: Scalars['Boolean']['output'];
  cancelCurrentCompanyUserCompanySubscription?: Maybe<StripeSubscription>;
  cancelCurrentTalentSubscription?: Maybe<StripeSubscription>;
  /** Cancel invitation */
  cancelInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Company User - change stage of job match */
  changeJobMatchStage?: Maybe<Scalars['Boolean']['output']>;
  changeNotificationReadStatus: Scalars['Boolean']['output'];
  /** Company User - change stage of suggesting for job match */
  changeSuggestingStatusForJobMatch?: Maybe<Scalars['Boolean']['output']>;
  /** Invite form for * (particular company, name is hidden for safety reason) - Deprecated */
  companyInviteFormSubmit: Scalars['Boolean']['output'];
  /** Create announcement for talent */
  createAnnouncement: Scalars['Boolean']['output'];
  createChatMessage?: Maybe<ChatMessage>;
  /** Create chief's program application. Return true in case of successful creation */
  createChiefsProgramApplication: Scalars['Boolean']['output'];
  createCompany?: Maybe<Company>;
  createCompanyAccountAccessRequest?: Maybe<Scalars['Boolean']['output']>;
  /** [Deprecated] Create new company and attach it to current company user */
  createCompanyForCurrentUser?: Maybe<Company>;
  /** create new company and attach it to current company user */
  createCompanyForUser?: Maybe<Company>;
  /** Create new company user account */
  createCompanyUserProfile?: Maybe<User>;
  createFieldGlassCandidateIntroduction: FieldGlassCandidateIntroduction;
  /** Create invitation */
  createInvitation?: Maybe<TalentInvitation>;
  /** Create invitation link */
  createInvitationLink?: Maybe<InvitationLink>;
  /** Create job (for company user flow) */
  createJob: Scalars['ID']['output'];
  /** Create job matcher application for the job (for current talent) */
  createJobMatcherApplication?: Maybe<JobMatcherApplication>;
  createJobRole?: Maybe<JobRole>;
  /** Talent/Matcher/Company_User flow - create a suggestion of a talent for a job */
  createJobSuggestion: Scalars['Boolean']['output'];
  /** [Deprecated] Matcher flow - suggest a talent for a job */
  createMatcherSuggestionForJobFromTalentInvitation?: Maybe<Array<Maybe<JobMatch>>>;
  /** Create report */
  createReport?: Maybe<Report>;
  createSMS?: Maybe<Sms>;
  /** Add new skill to catalog */
  createSkill: Skill;
  createTag?: Maybe<Tag>;
  /** Create talent account from invitation link */
  createTalentAccountFromInvitationLink?: Maybe<Scalars['Boolean']['output']>;
  /** Create 'Talent by Talent' invitation */
  createTalentByTalentInvitation?: Maybe<Talent>;
  /** Create talent profile */
  createTalentProfile?: Maybe<Scalars['ID']['output']>;
  /** Create untrusted talent profile */
  createUntrustedTalentProfile?: Maybe<Scalars['ID']['output']>;
  currentUserNotificationsMarkAllAsRead: Scalars['Boolean']['output'];
  /** Talent flow - decline job invitation */
  declineJobInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Decline job match */
  declineJobMatch?: Maybe<Scalars['Boolean']['output']>;
  /** [Deprecated] Verify talent account */
  declineTalentAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteCompanyUserProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Delete external job from favorites */
  deleteExternalJobFromFavorites?: Maybe<Scalars['Boolean']['output']>;
  /** Talent flow - delete job from favorites */
  deleteJobFromFavorites?: Maybe<Scalars['Boolean']['output']>;
  deleteMatchFromShortList?: Maybe<Scalars['Boolean']['output']>;
  deleteNotification: Scalars['Boolean']['output'];
  deleteTag?: Maybe<Scalars['Boolean']['output']>;
  editTag?: Maybe<Tag>;
  /** Export talent data by email */
  exportTalentDataByEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Extract data from CV */
  extractDataFromCv?: Maybe<TempDataItem>;
  /** Hire job match */
  hireJobMatch?: Maybe<Scalars['Boolean']['output']>;
  /** Intake job match */
  intakeJobMatch?: Maybe<Scalars['Boolean']['output']>;
  inviteCompanyToOpentalent?: Maybe<Scalars['Boolean']['output']>;
  inviteCompanyUser?: Maybe<Scalars['Boolean']['output']>;
  /** Invite form for company's public invitation form */
  inviteFormSubmit: Scalars['Boolean']['output'];
  /** Company user pooling action - invite talent to company pool of current company user */
  inviteTalentToCompanyPool?: Maybe<Scalars['Boolean']['output']>;
  /** Company user flow - invite talent to job  */
  inviteToJob?: Maybe<Scalars['Boolean']['output']>;
  /** Talent user pooling actions - leave from company pool */
  leaveCurrentTalentFromCompanyPool?: Maybe<Scalars['Boolean']['output']>;
  markNewJobMatchesAsRead?: Maybe<Scalars['Boolean']['output']>;
  notifyTalentAboutJobMatch?: Maybe<Scalars['Boolean']['output']>;
  /** Talent user pooling actions - reject company pool invitation */
  rejectCompanyPoolInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Reject action for company user who owns the job */
  rejectJobMatcherApplication?: Maybe<JobMatcherApplication>;
  /** Company user pooling action - reject talent */
  rejectTalentCompanyPoolApplication?: Maybe<Scalars['Boolean']['output']>;
  /** Remind talent to activate account */
  remindToActivateTalentAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Cancel matcher rights for the job */
  removeJobMatcherFromJob?: Maybe<Scalars['Boolean']['output']>;
  /** Company user pooling action - remove connected talent from pool */
  removeTalentFromCompanyPool?: Maybe<Scalars['Boolean']['output']>;
  renewCurrentCompanyUserCompanySubscription?: Maybe<StripeSubscription>;
  renewCurrentTalentSubscription?: Maybe<StripeSubscription>;
  /** Request contract */
  requestOTContract: Scalars['Boolean']['output'];
  /** Resend invitation notification email (if not accepted and has email) */
  resendInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Restore talent account by delete key */
  restoreDeletedAccountByDeleteKey?: Maybe<RestoreDeletedAccountInfo>;
  /** Company user pooling action - revoke talent invitation to company pool */
  revokeCompanyPoolApplication?: Maybe<Scalars['Boolean']['output']>;
  /** Company user pooling action - revoke talent invitation to company pool */
  revokeCompanyPoolInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Save external job to favorites */
  saveExternalJobToFavorites?: Maybe<Scalars['Boolean']['output']>;
  saveFieldGlassCandidateIntroduction: FieldGlassCandidateIntroduction;
  /** Talent flow - save job to favorite */
  saveJobToFavorites?: Maybe<Scalars['Boolean']['output']>;
  saveMatchToShortList?: Maybe<Scalars['Boolean']['output']>;
  /** Delete talent account by delete key */
  selfDeleteAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Delete talent document. Can be only initiated by the talent */
  selfDeleteTalentProfilePermanently?: Maybe<Scalars['Boolean']['output']>;
  /** Add company-specific tag to talent (can be added only by company user) */
  setTagsToTalent?: Maybe<Scalars['Boolean']['output']>;
  /** Save temp data for user/talent (unauthenticated onboarding). Rate limited: 10 req/min per device. Data size limit: 500KB. Device ID must be UUID v4. */
  setTempDataItem?: Maybe<Scalars['Boolean']['output']>;
  submitFieldGlassCandidateIntroduction?: Maybe<Scalars['Boolean']['output']>;
  /** Submit job to Broadbean */
  submitJobToBroadbean?: Maybe<BroadbeanJobSubmission>;
  submitTalentAsFreeMatcher?: Maybe<Scalars['Boolean']['output']>;
  /** Suggest a skill to add to the list of skills */
  suggestSkill: Skill;
  updateCompany?: Maybe<Company>;
  /** Update company user email */
  updateCompanyUserEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Update company user profile */
  updateCompanyUserProfile?: Maybe<User>;
  /** Update job (for company user flow) */
  updateJob: Job;
  updateNotification: Notification;
  /** Update talent email */
  updateTalentEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Update talent profile */
  updateTalentProfile?: Maybe<Scalars['ID']['output']>;
  /** Upload talent avatar */
  uploadCompanyLogo?: Maybe<CompanyLogo>;
  /** Upload file */
  uploadFile?: Maybe<File>;
  uploadFileTest?: Maybe<File>;
  /** Upload multiple files */
  uploadFiles?: Maybe<Array<Maybe<File>>>;
  /** Upload talent avatar */
  uploadTalentAvatar?: Maybe<Avatar>;
  /** Upload talent documents */
  uploadTalentDocument?: Maybe<Array<Maybe<TalentDocument>>>;
  /** Upload user avatar */
  uploadUserAvatar?: Maybe<Avatar>;
  /** [Deprecated] Verify talent account */
  verifyTalentAccount?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptCompanyPoolInvitationArgs = {
  company_id: Scalars['ID']['input'];
};


export type MutationApplyCurrentTalentToCompanyPoolArgs = {
  company_id: Scalars['ID']['input'];
};


export type MutationApplyForJobArgs = {
  job_application_data: JobApplicationInput;
};


export type MutationApproveJobMatcherApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveTalentCompanyPoolApplicationArgs = {
  talent_id: Scalars['ID']['input'];
};


export type MutationCancelApplicationForJobArgs = {
  job_id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeJobMatchStageArgs = {
  declination_reason?: InputMaybe<JobMatchDeclinationReasonsUsEnum>;
  job_match_id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  new_stage: JobMatchStageEnum;
};


export type MutationChangeNotificationReadStatusArgs = {
  new_status: Scalars['Boolean']['input'];
  notification_id: Scalars['ID']['input'];
};


export type MutationChangeSuggestingStatusForJobMatchArgs = {
  job_match_id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  new_suggesting_stage: SuggestingStageEnum;
};


export type MutationCompanyInviteFormSubmitArgs = {
  email: Scalars['Email']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
};


export type MutationCreateAnnouncementArgs = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_important: Scalars['Boolean']['input'];
  need_response: Scalars['Boolean']['input'];
  send_email?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  talents_ids: Array<InputMaybe<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateChatMessageArgs = {
  message: Scalars['String']['input'];
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  talent_id: Scalars['ID']['input'];
};


export type MutationCreateChiefsProgramApplicationArgs = {
  talent_id: Scalars['ID']['input'];
};


export type MutationCreateCompanyArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type_of_activity?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCompanyAccountAccessRequestArgs = {
  company_id?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['Email']['input'];
  first_name: Scalars['String']['input'];
  is_recruiter?: InputMaybe<Scalars['Boolean']['input']>;
  last_name: Scalars['String']['input'];
  new_company_name?: InputMaybe<Scalars['String']['input']>;
  recruiter_employment_type?: InputMaybe<CompanyUserRecruiterEmploymentTypeEnum>;
  referral_key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCompanyForCurrentUserArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type_of_activity?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCompanyForUserArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  primary_company_user_id?: InputMaybe<Scalars['ID']['input']>;
  type_of_activity?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCompanyUserProfileArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['Email']['input'];
  first_name: Scalars['String']['input'];
  is_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  last_name: Scalars['String']['input'];
  onboarding_type?: InputMaybe<CompanyUserOnboardingTypeEnum>;
  position?: InputMaybe<Scalars['String']['input']>;
  referral_key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFieldGlassCandidateIntroductionArgs = {
  introduction: CreateFieldGlassCandidateIntroductionInput;
  job_match_id: Scalars['ID']['input'];
};


export type MutationCreateInvitationArgs = {
  company_id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  inviter_company_user_id?: InputMaybe<Scalars['ID']['input']>;
  inviter_talent_id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  tags_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCreateInvitationLinkArgs = {
  inviting_talent_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateJobArgs = {
  campaign_end_date: Scalars['DateTimeUtc']['input'];
  campaign_owner_id: Scalars['ID']['input'];
  campaign_start_date: Scalars['DateTimeUtc']['input'];
  campaign_talent_pool?: InputMaybe<Array<InputMaybe<SourceTypeEnum>>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  finders_fee?: InputMaybe<Scalars['Float']['input']>;
  hard_skills_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hours_per_week?: InputMaybe<Scalars['Int']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  is_rate_negotiable?: InputMaybe<Scalars['Boolean']['input']>;
  is_remote_an_option?: InputMaybe<Scalars['Boolean']['input']>;
  is_salary_negotiable?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_type?: InputMaybe<JobLocationTypeEnum>;
  max_project_budget?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  office_hours_per_month?: InputMaybe<Scalars['Float']['input']>;
  permanent_capacity_type?: InputMaybe<PermanentJobCapacityTypeEnum>;
  pitch?: InputMaybe<Scalars['String']['input']>;
  propose_to_matchers?: InputMaybe<Scalars['Boolean']['input']>;
  rate_max?: InputMaybe<Scalars['Float']['input']>;
  rate_min?: InputMaybe<Scalars['Float']['input']>;
  salary_max?: InputMaybe<Scalars['Float']['input']>;
  salary_min?: InputMaybe<Scalars['Float']['input']>;
  service_type?: InputMaybe<JobServiceTypeEnum>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  skills_boolean_filter?: InputMaybe<TalentsBooleanSkillsFilterInput>;
  solutions_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  subcategory_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<JobTypeEnum>;
};


export type MutationCreateJobMatcherApplicationArgs = {
  job_id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateJobRoleArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateJobSuggestionArgs = {
  cv_attachment?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  job_id: Scalars['ID']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  motivation_letter_attachment?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  salary?: InputMaybe<Scalars['Int']['input']>;
  screening_questionnaire_attachment?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMatcherSuggestionForJobFromTalentInvitationArgs = {
  talent_invitation_id: Scalars['ID']['input'];
};


export type MutationCreateReportArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: ReportReasonsEnum;
  reported_talent_id: Scalars['ID']['input'];
};


export type MutationCreateSmsArgs = {
  company_id: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  talent_id: Scalars['ID']['input'];
};


export type MutationCreateSkillArgs = {
  name: Scalars['String']['input'];
  skill_type: SkillTypeEnum;
};


export type MutationCreateTagArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTalentAccountFromInvitationLinkArgs = {
  email: Scalars['Email']['input'];
  key: Scalars['String']['input'];
};


export type MutationCreateTalentByTalentInvitationArgs = {
  email: Scalars['Email']['input'];
  inviting_talent_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateTalentProfileArgs = {
  email: Scalars['Email']['input'];
  general_info: TalentGeneralInfoInput;
  is_ot_pool?: InputMaybe<Scalars['Boolean']['input']>;
  job_application_data?: InputMaybe<JobApplicationInput>;
  origin?: InputMaybe<TalentOriginEnum>;
  tags_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCreateUntrustedTalentProfileArgs = {
  available_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  available_now?: InputMaybe<Scalars['Boolean']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<InputMaybe<TalentDocumentInput>>>;
  email: Scalars['Email']['input'];
  employee_name_who_referred?: InputMaybe<Scalars['String']['input']>;
  general_info: TalentGeneralInfoInput;
  invitation_uid?: InputMaybe<Scalars['String']['input']>;
  is_agree_to_marketing_materials?: InputMaybe<Scalars['Boolean']['input']>;
  is_agree_to_sms?: InputMaybe<Scalars['Boolean']['input']>;
  is_agree_to_terms_and_conditions?: InputMaybe<Scalars['Boolean']['input']>;
  is_bilingual?: InputMaybe<Scalars['Boolean']['input']>;
  job_application_data?: InputMaybe<JobApplicationInput>;
  languages?: InputMaybe<Array<InputMaybe<TalentLanguageEnum>>>;
  marketing_source?: InputMaybe<TalentMarketingSourceEnum>;
  origin?: InputMaybe<TalentOriginEnum>;
  recruiter_info?: InputMaybe<RecruiterInfoInput>;
  source_company_id?: InputMaybe<Scalars['ID']['input']>;
  stid?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  talent_id?: InputMaybe<Scalars['ID']['input']>;
  work_type?: InputMaybe<Array<InputMaybe<TalentWorkTypeEnum>>>;
};


export type MutationDeclineJobInvitationArgs = {
  job_invitation_id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeclineJobMatchArgs = {
  job_match_id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<JobMatchDeclinationReasonsEnum>;
};


export type MutationDeclineTalentAccountArgs = {
  talent_id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyUserProfileArgs = {
  company_user_id: Scalars['ID']['input'];
};


export type MutationDeleteExternalJobFromFavoritesArgs = {
  external_job_id: Scalars['ID']['input'];
};


export type MutationDeleteJobFromFavoritesArgs = {
  job_id: Scalars['ID']['input'];
};


export type MutationDeleteMatchFromShortListArgs = {
  match_id: Scalars['ID']['input'];
};


export type MutationDeleteNotificationArgs = {
  notification_id: Scalars['ID']['input'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEditTagArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExtractDataFromCvArgs = {
  device_id: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationHireJobMatchArgs = {
  job_match_id: Scalars['ID']['input'];
  with_contract?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationIntakeJobMatchArgs = {
  job_match_id: Scalars['ID']['input'];
};


export type MutationInviteCompanyToOpentalentArgs = {
  company_email: Scalars['String']['input'];
  company_name: Scalars['String']['input'];
  contact_person: Scalars['String']['input'];
};


export type MutationInviteCompanyUserArgs = {
  email: Scalars['Email']['input'];
};


export type MutationInviteFormSubmitArgs = {
  company_id: Scalars['ID']['input'];
  email: Scalars['Email']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
};


export type MutationInviteTalentToCompanyPoolArgs = {
  talent_id: Scalars['ID']['input'];
};


export type MutationInviteToJobArgs = {
  job_id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  talent_id: Scalars['ID']['input'];
};


export type MutationLeaveCurrentTalentFromCompanyPoolArgs = {
  company_id: Scalars['ID']['input'];
};


export type MutationMarkNewJobMatchesAsReadArgs = {
  job_matches_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationNotifyTalentAboutJobMatchArgs = {
  match_id: Scalars['ID']['input'];
};


export type MutationRejectCompanyPoolInvitationArgs = {
  company_id: Scalars['ID']['input'];
};


export type MutationRejectJobMatcherApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRejectTalentCompanyPoolApplicationArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  talent_id: Scalars['ID']['input'];
};


export type MutationRemindToActivateTalentAccountArgs = {
  talent_id: Scalars['ID']['input'];
};


export type MutationRemoveJobMatcherFromJobArgs = {
  job_id: Scalars['ID']['input'];
  matcher_id: Scalars['ID']['input'];
};


export type MutationRemoveTalentFromCompanyPoolArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  talent_id: Scalars['ID']['input'];
};


export type MutationResendInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreDeletedAccountByDeleteKeyArgs = {
  delete_key: Scalars['String']['input'];
};


export type MutationRevokeCompanyPoolApplicationArgs = {
  talent_id: Scalars['ID']['input'];
};


export type MutationRevokeCompanyPoolInvitationArgs = {
  talent_id: Scalars['ID']['input'];
};


export type MutationSaveExternalJobToFavoritesArgs = {
  external_job_id: Scalars['ID']['input'];
};


export type MutationSaveFieldGlassCandidateIntroductionArgs = {
  introduction: SaveFieldGlassCandidateIntroductionInput;
  introduction_id: Scalars['ID']['input'];
};


export type MutationSaveJobToFavoritesArgs = {
  job_id: Scalars['ID']['input'];
};


export type MutationSaveMatchToShortListArgs = {
  match_id: Scalars['ID']['input'];
};


export type MutationSelfDeleteAccountArgs = {
  delete_key: Scalars['String']['input'];
};


export type MutationSetTagsToTalentArgs = {
  tags_ids: Array<Scalars['ID']['input']>;
  talent_id: Scalars['ID']['input'];
};


export type MutationSetTempDataItemArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  device_id: Scalars['String']['input'];
  email?: InputMaybe<Scalars['Email']['input']>;
};


export type MutationSubmitFieldGlassCandidateIntroductionArgs = {
  introduction_id: Scalars['ID']['input'];
};


export type MutationSubmitJobToBroadbeanArgs = {
  job_id: Scalars['ID']['input'];
};


export type MutationSubmitTalentAsFreeMatcherArgs = {
  talent_id: Scalars['ID']['input'];
};


export type MutationSuggestSkillArgs = {
  name: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  skill_type: SkillTypeEnum;
};


export type MutationUpdateCompanyArgs = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['ID']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  type_of_activity?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCompanyUserEmailArgs = {
  email: Scalars['Email']['input'];
};


export type MutationUpdateCompanyUserProfileArgs = {
  account_settings?: InputMaybe<CompanyUserAccountSettingsInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  company_user_id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['Email']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateJobArgs = {
  campaign_end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  campaign_owner_id?: InputMaybe<Scalars['ID']['input']>;
  campaign_start_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  campaign_talent_pool?: InputMaybe<Array<InputMaybe<SourceTypeEnum>>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  finders_fee?: InputMaybe<Scalars['Float']['input']>;
  hard_skills_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hours_per_week?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  is_rate_negotiable?: InputMaybe<Scalars['Boolean']['input']>;
  is_remote_an_option?: InputMaybe<Scalars['Boolean']['input']>;
  is_salary_negotiable?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_type?: InputMaybe<JobLocationTypeEnum>;
  max_project_budget?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  office_hours_per_month?: InputMaybe<Scalars['Float']['input']>;
  permanent_capacity_type?: InputMaybe<PermanentJobCapacityTypeEnum>;
  pitch?: InputMaybe<Scalars['String']['input']>;
  propose_to_matchers?: InputMaybe<Scalars['Boolean']['input']>;
  rate_max?: InputMaybe<Scalars['Float']['input']>;
  rate_min?: InputMaybe<Scalars['Float']['input']>;
  salary_max?: InputMaybe<Scalars['Float']['input']>;
  salary_min?: InputMaybe<Scalars['Float']['input']>;
  service_type?: InputMaybe<JobServiceTypeEnum>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  skills_boolean_filter?: InputMaybe<TalentsBooleanSkillsFilterInput>;
  solutions_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  subcategory_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<JobTypeEnum>;
  update_auto_matching?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateNotificationArgs = {
  id: Scalars['ID']['input'];
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateTalentEmailArgs = {
  email: Scalars['Email']['input'];
};


export type MutationUpdateTalentProfileArgs = {
  about?: InputMaybe<Scalars['String']['input']>;
  account_info?: InputMaybe<TalentAccountVerificationInput>;
  account_settings?: InputMaybe<TalentAccountSettingsInput>;
  available_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  available_now?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  currently_works_for_one_of_the_companies?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Array<InputMaybe<TalentDocumentInput>>>;
  employee_name_who_referred?: InputMaybe<Scalars['String']['input']>;
  general_info?: InputMaybe<TalentGeneralInfoInput>;
  hours_per_week?: InputMaybe<Scalars['Int']['input']>;
  is_agree_to_marketing_materials?: InputMaybe<Scalars['Boolean']['input']>;
  is_agree_to_sms?: InputMaybe<Scalars['Boolean']['input']>;
  is_agree_to_terms_and_conditions?: InputMaybe<Scalars['Boolean']['input']>;
  is_bilingual?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<InputMaybe<TalentLanguageEnum>>>;
  marketing_source?: InputMaybe<TalentMarketingSourceEnum>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  talent_id: Scalars['ID']['input'];
  work_history?: InputMaybe<Array<InputMaybe<WorkHistoryInput>>>;
  work_type?: InputMaybe<Array<InputMaybe<TalentWorkTypeEnum>>>;
};


export type MutationUploadCompanyLogoArgs = {
  company_id: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
  file_type: FileTypeEnum;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUploadFileTestArgs = {
  file: Scalars['Upload']['input'];
  file_type: FileTypeEnum;
  owner_id: Scalars['ID']['input'];
};


export type MutationUploadFilesArgs = {
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
};


export type MutationUploadTalentAvatarArgs = {
  file: Scalars['Upload']['input'];
  talent_id: Scalars['ID']['input'];
};


export type MutationUploadTalentDocumentArgs = {
  files: Array<Scalars['Upload']['input']>;
  talent_id: Scalars['ID']['input'];
};


export type MutationUploadUserAvatarArgs = {
  file: Scalars['Upload']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationVerifyTalentAccountArgs = {
  talent_id: Scalars['ID']['input'];
};

/** Any object implementing this type can be found by ID through `Query.node`. */
export type Node = {
  /** Global identifier that can be used to resolve any Node implementation. */
  id: Scalars['ID']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  buttons?: Maybe<Array<Maybe<NotificationButton>>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_important: Scalars['Boolean']['output'];
  is_read: Scalars['Boolean']['output'];
  message: NotificationMessage;
  recipient_id: Scalars['ID']['output'];
  recipient_type: NotificationRecipientTypeEnum;
  related_job_id?: Maybe<Scalars['ID']['output']>;
  reply_to?: Maybe<User>;
  subject?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NotificationActionInterface = {
  type?: Maybe<NotificationActionTypeEnum>;
};

export type NotificationActionRedirect = NotificationActionInterface & {
  __typename?: 'NotificationActionRedirect';
  target_route_id: Scalars['ID']['output'];
  target_route_type?: Maybe<RedirectTargetRouteTypeEnum>;
  type?: Maybe<NotificationActionTypeEnum>;
};

export const NotificationActionTypeEnum = {
  Confirm: 'CONFIRM',
  Redirect: 'REDIRECT'
} as const;

export type NotificationActionTypeEnum = typeof NotificationActionTypeEnum[keyof typeof NotificationActionTypeEnum];
export type NotificationButton = {
  __typename?: 'NotificationButton';
  action: NotificationActionInterface;
  text: Scalars['String']['output'];
};

export type NotificationMessage = {
  __typename?: 'NotificationMessage';
  template?: Maybe<Scalars['String']['output']>;
  template_actions?: Maybe<Array<Maybe<NotificationTemplateAction>>>;
};

/** A paginated list of Notification items. */
export type NotificationPaginator = {
  __typename?: 'NotificationPaginator';
  /** A list of Notification items. */
  data: Array<Notification>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export const NotificationRecipientTypeEnum = {
  CompanyUser: 'COMPANY_USER',
  Talent: 'TALENT'
} as const;

export type NotificationRecipientTypeEnum = typeof NotificationRecipientTypeEnum[keyof typeof NotificationRecipientTypeEnum];
export type NotificationTemplateAction = {
  __typename?: 'NotificationTemplateAction';
  action?: Maybe<NotificationActionInterface>;
  key?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type OtContract = {
  __typename?: 'OTContract';
  id: Scalars['ID']['output'];
  read_contacts_permission: Scalars['Boolean']['output'];
  status: OtContractStatusEnum;
};

/** Status of the contract between company and Opentalent */
export const OtContractStatusEnum = {
  Requested: 'REQUESTED',
  SentToCompany: 'SENT_TO_COMPANY',
  Signed: 'SIGNED',
  Unknown: 'UNKNOWN'
} as const;

export type OtContractStatusEnum = typeof OtContractStatusEnum[keyof typeof OtContractStatusEnum];
/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export const OrderByRelationAggregateFunction = {
  /** Amount of items. */
  Count: 'COUNT'
} as const;

export type OrderByRelationAggregateFunction = typeof OrderByRelationAggregateFunction[keyof typeof OrderByRelationAggregateFunction];
/** Aggregate functions when ordering by a relation that may specify a column. */
export const OrderByRelationWithColumnAggregateFunction = {
  /** Average. */
  Avg: 'AVG',
  /** Amount of items. */
  Count: 'COUNT',
  /** Maximum. */
  Max: 'MAX',
  /** Minimum. */
  Min: 'MIN',
  /** Sum. */
  Sum: 'SUM'
} as const;

export type OrderByRelationWithColumnAggregateFunction = typeof OrderByRelationWithColumnAggregateFunction[keyof typeof OrderByRelationWithColumnAggregateFunction];
/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type Perk = {
  __typename?: 'Perk';
  category?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  get_perk_link?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  learn_more_link?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Perk items. */
export type PerkPaginator = {
  __typename?: 'PerkPaginator';
  /** A list of Perk items. */
  data: Array<Perk>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export const PermanentJobCapacityTypeEnum = {
  FullTime: 'FULL_TIME',
  PartTime: 'PART_TIME'
} as const;

export type PermanentJobCapacityTypeEnum = typeof PermanentJobCapacityTypeEnum[keyof typeof PermanentJobCapacityTypeEnum];
export type Query = {
  __typename?: 'Query';
  ATSRecords?: Maybe<Array<Maybe<TalentLogRecordInterface>>>;
  ATSRecordsUnion?: Maybe<Array<Maybe<AtsRecordsUnion>>>;
  availableJobsForTalent?: Maybe<Array<Maybe<AvailableJobForTalent>>>;
  categoryAnalytics?: Maybe<Array<Maybe<DashboardAnalyticsItem>>>;
  chatMessage?: Maybe<ChatMessage>;
  chatMessages: ChatMessagePaginator;
  /** Check company user existence by email */
  checkCompanyUserExistsByEmail: Scalars['Boolean']['output'];
  /** Check talent existence by email */
  checkTalentExistsByEmail: Scalars['Boolean']['output'];
  commonAppInfo?: Maybe<CommonAppInfo>;
  companies: CompanyPaginator;
  company?: Maybe<Company>;
  companyBySlug?: Maybe<Company>;
  /** Publicly available company info. No auth required. */
  companyPublicInfo?: Maybe<CompanyPublicInfo>;
  countryAnalytics?: Maybe<Array<Maybe<DashboardAnalyticsItem>>>;
  /** Current company user */
  currentCompanyUser: User;
  currentCompanyUserColleagues: Array<Maybe<User>>;
  currentCompanyUserCompanySubscription?: Maybe<StripeSubscription>;
  currentCompanyUserJobBoardInfo: JobBoardInfo;
  /** Number of jobs by job status */
  currentCompanyUserJobsCountByStatus: Array<Maybe<JobsCountByStatus>>;
  /** Current talent */
  currentTalent: Talent;
  currentTalentExternalJobBoardSearch: ExternalJobPaginator;
  currentTalentExternalJobRecommendations?: Maybe<Array<Maybe<ExternalJob>>>;
  /** Invitation Links belonging to current talent */
  currentTalentInvitationLinks?: Maybe<Array<Maybe<InvitationLink>>>;
  /** Invitations made by current talent */
  currentTalentInvitations?: Maybe<Array<Maybe<TalentInvitation>>>;
  currentTalentJobApplicationByJobId?: Maybe<JobApplication>;
  currentTalentJobBoardSearch: JobPaginator;
  currentTalentJobRecommedations: JobRecommendationPaginator;
  currentTalentSubscription?: Maybe<StripeSubscription>;
  /** Current company user */
  currentUserAccounts: CurrentUserAccounts;
  currentUserCompanyTags?: Maybe<Array<Maybe<Tag>>>;
  currentUserNotifications: NotificationPaginator;
  currentUserUnreadNotificationsCount?: Maybe<Scalars['Int']['output']>;
  externalJob: ExternalJob;
  externalJobCompanies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  featuredTagsByCompany?: Maybe<Array<Maybe<Tag>>>;
  fieldGlassCandidateIntroduction?: Maybe<FieldGlassCandidateIntroduction>;
  fieldGlassCandidateIntroductionByJobMatchId?: Maybe<FieldGlassCandidateIntroduction>;
  generalAnalytics?: Maybe<Array<Maybe<DashboardAnalyticsItem>>>;
  getAllSMSConversations: SmsConversationPaginator;
  getCountriesList?: Maybe<Array<Maybe<Country>>>;
  getIndustriesList?: Maybe<Array<Maybe<Industry>>>;
  getJobNameById?: Maybe<Scalars['String']['output']>;
  getJobRoles?: Maybe<Array<Maybe<JobRole>>>;
  getPaymentLinkForCompany?: Maybe<Scalars['String']['output']>;
  getPaymentLinkForMatcher?: Maybe<Scalars['String']['output']>;
  getPaymentLinkForRecruiter?: Maybe<Scalars['String']['output']>;
  getPaymentLinkForTalent?: Maybe<Scalars['String']['output']>;
  getTalentOnboardingCountriesForCompany?: Maybe<Array<Maybe<Country>>>;
  getTalentSMSConversation: SmsPaginator;
  getTempDataItem: TempDataItemSearchResult;
  getTypeformPaymentLinkCodeForMatcher?: Maybe<Scalars['String']['output']>;
  /** Public information for Invitation Link by public key */
  invitationLinkInfo?: Maybe<InvitationLinkInfo>;
  job?: Maybe<Job>;
  jobInvitation?: Maybe<JobInvitation>;
  jobMatcherApplications?: Maybe<Array<Maybe<JobMatcherApplication>>>;
  jobMatchers?: Maybe<Array<Maybe<JobMatcher>>>;
  jobMatches?: Maybe<Array<Maybe<JobMatch>>>;
  /** List of Jobs in jobs board */
  jobs: JobPaginator;
  lastTalents?: Maybe<Array<Maybe<Talent>>>;
  marketingSourceAnalytics?: Maybe<Array<Maybe<DashboardAnalyticsItem>>>;
  node?: Maybe<Node>;
  perks: PerkPaginator;
  perksCategories: Array<Scalars['String']['output']>;
  poolingCompanies: CompanyPaginator;
  /** Number of potential talents for job */
  potentialTalentsForJobCount: Scalars['Int']['output'];
  searchCompanyByName: Array<Maybe<CompanySimpleSearchResult>>;
  /** Data for 'Delete my account' page */
  selfDeletePageInfo?: Maybe<SelfDeletePageInfo>;
  /** Send 'Jobs' export to current company user's email */
  sendJobsExportToCurrentCompanyUserEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Send 'Talents' report to current company user's email */
  sendTalentsReportToCurrentCompanyUserEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Get skill by id */
  skill?: Maybe<Skill>;
  /** Get skill by slug */
  skillBySlug?: Maybe<Skill>;
  /** Check if skill exists by name */
  skillExists?: Maybe<Skill>;
  /** Search skills by substring occurrence */
  skillSearch: Array<Skill>;
  /** Get skills by skill type */
  skills: SkillPaginator;
  tagsAnalytics?: Maybe<Array<Maybe<DashboardAnalyticsItem>>>;
  talent?: Maybe<Talent>;
  /** Talent categories */
  talentCategories?: Maybe<Array<Maybe<TalentCategory>>>;
  /** Talent documents */
  talentDocuments?: Maybe<Array<Maybe<TalentDocument>>>;
  /** Info for 'Invite new talent' page (talent invite talent) */
  talentInvitationsInfo?: Maybe<TalentInvitationsInfo>;
  /** Talent skills */
  talentSkills: SkillPaginator;
  /** Talent sources */
  talentSources?: Maybe<Array<Maybe<TalentSource>>>;
  /** Talent working history */
  talentWorkHistory?: Maybe<Array<Maybe<TalentWorkHistory>>>;
  /** Talent list */
  talents: TalentPaginator;
  talentsCountByCategories?: Maybe<Array<Maybe<TalentsCountItem>>>;
  talentsCountBySubcategories?: Maybe<Array<Maybe<TalentsCountItem>>>;
  talentsSearch?: Maybe<TalentsSearchPaginator>;
};


export type QueryAtsRecordsArgs = {
  job_id?: InputMaybe<Scalars['ID']['input']>;
  talent_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAtsRecordsUnionArgs = {
  talent_id: Scalars['ID']['input'];
};


export type QueryAvailableJobsForTalentArgs = {
  talent_id: Scalars['ID']['input'];
};


export type QueryChatMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatMessagesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  talent_id: Scalars['ID']['input'];
};


export type QueryCheckCompanyUserExistsByEmailArgs = {
  email: Scalars['Email']['input'];
};


export type QueryCheckTalentExistsByEmailArgs = {
  talent_email: Scalars['Email']['input'];
};


export type QueryCompaniesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCompanyPublicInfoArgs = {
  company_id: Scalars['ID']['input'];
};


export type QueryCurrentCompanyUserJobsCountByStatusArgs = {
  company_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCurrentTalentExternalJobBoardSearchArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  employment_type?: InputMaybe<Array<InputMaybe<ExternalJobEmploymentTypeEnum>>>;
  first?: Scalars['Int']['input'];
  is_saved?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seniority?: InputMaybe<Array<InputMaybe<ExternalJobSeniorityLevelEnum>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryCurrentTalentJobApplicationByJobIdArgs = {
  job_id: Scalars['ID']['input'];
};


export type QueryCurrentTalentJobBoardSearchArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  communities_filter?: InputMaybe<JobCommunitiesFilterInput>;
  company_id?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_applied?: InputMaybe<Scalars['Boolean']['input']>;
  is_applied_as_matcher?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_assigned_as_matcher?: InputMaybe<Scalars['Boolean']['input']>;
  is_saved?: InputMaybe<Scalars['Boolean']['input']>;
  job_matcher_jobs_filter?: InputMaybe<JobMatcherJobsFilterEnum>;
  job_source_type?: InputMaybe<Array<InputMaybe<JobSourceType>>>;
  order_by?: InputMaybe<Array<QueryCurrentTalentJobBoardSearchOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rate_max?: InputMaybe<Scalars['Float']['input']>;
  rate_min?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryCurrentTalentJobRecommedationsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCurrentUserCompanyTagsArgs = {
  is_featured?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCurrentUserNotificationsArgs = {
  first?: Scalars['Int']['input'];
  is_important?: InputMaybe<Scalars['Boolean']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternalJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExternalJobCompaniesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeaturedTagsByCompanyArgs = {
  company_id: Scalars['ID']['input'];
};


export type QueryFieldGlassCandidateIntroductionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFieldGlassCandidateIntroductionByJobMatchIdArgs = {
  job_match_id: Scalars['ID']['input'];
};


export type QueryGetAllSmsConversationsArgs = {
  company_id: Scalars['ID']['input'];
  direction?: InputMaybe<SmsSortDirectionEnum>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SmsSortEnum>;
};


export type QueryGetCountriesListArgs = {
  is_europe?: InputMaybe<Scalars['Boolean']['input']>;
  is_us?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetJobNameByIdArgs = {
  job_id: Scalars['ID']['input'];
};


export type QueryGetPaymentLinkForCompanyArgs = {
  primary_user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPaymentLinkForMatcherArgs = {
  is_hr_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  talent_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPaymentLinkForRecruiterArgs = {
  is_hr_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  talent_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPaymentLinkForTalentArgs = {
  talent_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTalentOnboardingCountriesForCompanyArgs = {
  company_id: Scalars['ID']['input'];
};


export type QueryGetTalentSmsConversationArgs = {
  company_id: Scalars['ID']['input'];
  direction?: InputMaybe<SmsSortDirectionEnum>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SmsSortEnum>;
  talent_id: Scalars['ID']['input'];
};


export type QueryGetTempDataItemArgs = {
  device_id: Scalars['String']['input'];
  email?: InputMaybe<Scalars['Email']['input']>;
  result?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetTypeformPaymentLinkCodeForMatcherArgs = {
  talent_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvitationLinkInfoArgs = {
  key: Scalars['String']['input'];
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobMatcherApplicationsArgs = {
  job_id: Scalars['ID']['input'];
  status?: InputMaybe<JobMatcherApplicationStatusEnum>;
};


export type QueryJobMatchersArgs = {
  job_id: Scalars['ID']['input'];
};


export type QueryJobMatchesArgs = {
  job_id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  match_type?: InputMaybe<JobMatchTypeEnum>;
  source_type?: InputMaybe<SourceTypeEnum>;
};


export type QueryJobsArgs = {
  company_id?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  order_by?: InputMaybe<Array<QueryJobsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPerksArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPoolingCompaniesArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pooling_type?: InputMaybe<CompanyPoolingTypeEnum>;
};


export type QueryPotentialTalentsForJobCountArgs = {
  campaign_end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  campaign_owner_id?: InputMaybe<Scalars['ID']['input']>;
  campaign_start_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  campaign_talent_pool?: InputMaybe<Array<InputMaybe<SourceTypeEnum>>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  hard_skills_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hours_per_week?: InputMaybe<Scalars['Int']['input']>;
  is_remote_an_option?: InputMaybe<Scalars['Boolean']['input']>;
  location_type?: InputMaybe<JobLocationTypeEnum>;
  office_hours_per_month?: InputMaybe<Scalars['Float']['input']>;
  rate_max?: InputMaybe<Scalars['Float']['input']>;
  rate_min?: InputMaybe<Scalars['Float']['input']>;
  salary_max?: InputMaybe<Scalars['Float']['input']>;
  salary_min?: InputMaybe<Scalars['Float']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  skills_boolean_filter?: InputMaybe<TalentsBooleanSkillsFilterInput>;
  solutions_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  subcategory_id?: InputMaybe<Scalars['ID']['input']>;
  type: JobTypeEnum;
};


export type QuerySearchCompanyByNameArgs = {
  name: Scalars['String']['input'];
};


export type QuerySelfDeletePageInfoArgs = {
  delete_key: Scalars['String']['input'];
};


export type QuerySkillArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkillBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySkillExistsArgs = {
  name: Scalars['String']['input'];
  skill_type: SkillTypeEnum;
};


export type QuerySkillSearchArgs = {
  search: Scalars['String']['input'];
  skill_type?: InputMaybe<Array<InputMaybe<SkillTypeEnum>>>;
};


export type QuerySkillsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  skill_type?: InputMaybe<SkillTypeEnum>;
};


export type QueryTalentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTalentDocumentsArgs = {
  talent_id: Scalars['ID']['input'];
};


export type QueryTalentInvitationsInfoArgs = {
  inviting_talent_id: Scalars['ID']['input'];
};


export type QueryTalentSkillsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  skill_type_id?: InputMaybe<Scalars['Int']['input']>;
  talent_id: Scalars['ID']['input'];
};


export type QueryTalentWorkHistoryArgs = {
  talent_id: Scalars['ID']['input'];
};


export type QueryTalentsArgs = {
  available_now?: InputMaybe<Scalars['Boolean']['input']>;
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  connection_with_company_id?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_active_or_static?: InputMaybe<Scalars['Boolean']['input']>;
  is_matcher?: InputMaybe<Scalars['Boolean']['input']>;
  is_static?: InputMaybe<Scalars['Boolean']['input']>;
  is_verification_required?: InputMaybe<Scalars['Boolean']['input']>;
  max_rate?: InputMaybe<Scalars['Float']['input']>;
  min_rate?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Array<QueryTalentsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skills_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  source_type?: InputMaybe<SourceTypeEnum>;
  worked_in_company_id?: InputMaybe<Scalars['ID']['input']>;
  worked_in_company_str?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTalentsCountByCategoriesArgs = {
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryTalentsCountBySubcategoriesArgs = {
  subcategory_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryTalentsSearchArgs = {
  available_now?: InputMaybe<Scalars['Boolean']['input']>;
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  connected_with_company_id?: InputMaybe<Scalars['ID']['input']>;
  connection_with_company_id?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_active_or_static?: InputMaybe<Scalars['Boolean']['input']>;
  is_matcher?: InputMaybe<Scalars['Boolean']['input']>;
  is_static?: InputMaybe<Scalars['Boolean']['input']>;
  is_verification_required?: InputMaybe<Scalars['Boolean']['input']>;
  max_rate?: InputMaybe<Scalars['Float']['input']>;
  min_rate?: InputMaybe<Scalars['Float']['input']>;
  order_by?: InputMaybe<TalentsOrderBySimple>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  skills_boolean_filter?: InputMaybe<TalentsBooleanSkillsFilterInput>;
  skills_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  source_type?: InputMaybe<SourceTypeEnum>;
  state?: InputMaybe<Scalars['String']['input']>;
  subcategories_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tags_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  work_type?: InputMaybe<Array<InputMaybe<TalentWorkTypeEnum>>>;
  worked_in_company_id?: InputMaybe<Scalars['ID']['input']>;
  worked_in_company_str?: InputMaybe<Scalars['String']['input']>;
  zip_codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Order by clause for Query.currentTalentJobBoardSearch.order_by. */
export type QueryCurrentTalentJobBoardSearchOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: JobOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Order by clause for Query.jobs.order_by. */
export type QueryJobsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: JobOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Order by clause for Query.talents.orderBy. */
export type QueryTalentsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: TalentsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export type RecruiterInfoInput = {
  recruiter_companies_currently_work_for?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recruiter_countries?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recruiter_industries?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recruiter_job_roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recruiter_number_of_candidates?: InputMaybe<RecruiterNumberCandidatesEnum>;
  recruiter_number_of_years?: InputMaybe<RecruiterNumberOfYearsEnum>;
  recruiter_role?: InputMaybe<RecruiterRolesEnum>;
  recruiter_specializations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export const RecruiterNumberCandidatesEnum = {
  From_50To_250: 'FROM_50_TO_250',
  From_250To_500: 'FROM_250_TO_500',
  LessThan_50: 'LESS_THAN_50',
  MoreThan_500: 'MORE_THAN_500'
} as const;

export type RecruiterNumberCandidatesEnum = typeof RecruiterNumberCandidatesEnum[keyof typeof RecruiterNumberCandidatesEnum];
export const RecruiterNumberOfYearsEnum = {
  From_0To_2: 'FROM_0_TO_2',
  From_2To_5: 'FROM_2_TO_5',
  MoreThan_5: 'MORE_THAN_5'
} as const;

export type RecruiterNumberOfYearsEnum = typeof RecruiterNumberOfYearsEnum[keyof typeof RecruiterNumberOfYearsEnum];
export const RecruiterRolesEnum = {
  Both: 'BOTH',
  Independent: 'INDEPENDENT',
  InHouse: 'IN_HOUSE'
} as const;

export type RecruiterRolesEnum = typeof RecruiterRolesEnum[keyof typeof RecruiterRolesEnum];
export const RedirectTargetRouteTypeEnum = {
  CompanyUserJob: 'COMPANY_USER_JOB',
  TalentJob: 'TALENT_JOB',
  TalentJobInvitation: 'TALENT_JOB_INVITATION',
  TalentProfile: 'TALENT_PROFILE'
} as const;

export type RedirectTargetRouteTypeEnum = typeof RedirectTargetRouteTypeEnum[keyof typeof RedirectTargetRouteTypeEnum];
export const RegionEnum = {
  Australia: 'AUSTRALIA',
  Europe: 'EUROPE',
  Us: 'US'
} as const;

export type RegionEnum = typeof RegionEnum[keyof typeof RegionEnum];
export type Report = {
  __typename?: 'Report';
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reason: ReportReasonsEnum;
  reported_talent?: Maybe<Talent>;
  reporting_talent?: Maybe<Talent>;
  reporting_user?: Maybe<User>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export const ReportReasonsEnum = {
  DiscriminationHateSpeech: 'DISCRIMINATION_HATE_SPEECH',
  Harassment: 'HARASSMENT',
  InappropriateBehavior: 'INAPPROPRIATE_BEHAVIOR',
  Other: 'OTHER',
  SpamFakeProfile: 'SPAM_FAKE_PROFILE'
} as const;

export type ReportReasonsEnum = typeof ReportReasonsEnum[keyof typeof ReportReasonsEnum];
export type Sms = {
  __typename?: 'SMS';
  company_id: Scalars['ID']['output'];
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  delivered_at?: Maybe<Scalars['DateTime']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sender_type: SenderTypeEnum;
  status: SmsStatusEnum;
  talent_id: Scalars['ID']['output'];
  talent_phone_number: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  vonage_message_id?: Maybe<Scalars['String']['output']>;
  vonage_status?: Maybe<Scalars['Int']['output']>;
};

export type SmsConversation = {
  __typename?: 'SMSConversation';
  last_sms: Sms;
  talent: Talent;
};

/** A paginated list of SMSConversation items. */
export type SmsConversationPaginator = {
  __typename?: 'SMSConversationPaginator';
  /** A list of SMSConversation items. */
  data: Array<SmsConversation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** A paginated list of SMS items. */
export type SmsPaginator = {
  __typename?: 'SMSPaginator';
  /** A list of SMS items. */
  data: Array<Sms>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export const SmsSortDirectionEnum = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type SmsSortDirectionEnum = typeof SmsSortDirectionEnum[keyof typeof SmsSortDirectionEnum];
export const SmsSortEnum = {
  CreatedAt: 'CREATED_AT'
} as const;

export type SmsSortEnum = typeof SmsSortEnum[keyof typeof SmsSortEnum];
export const SmsStatusEnum = {
  Failed: 'failed',
  New: 'new',
  Received: 'received',
  Sent: 'sent'
} as const;

export type SmsStatusEnum = typeof SmsStatusEnum[keyof typeof SmsStatusEnum];
export type SaveFieldGlassCandidateIntroductionInput = {
  additional_invoice_currency?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Scalars['JSON']['input']>;
  calculate_rate_using?: InputMaybe<Scalars['String']['input']>;
  candidate_cv_hash?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  creator_username?: InputMaybe<Scalars['String']['input']>;
  cv_attachment_hash?: InputMaybe<Scalars['String']['input']>;
  date_available?: InputMaybe<Scalars['DateTime']['input']>;
  date_of_birth?: InputMaybe<Scalars['DateTime']['input']>;
  display_candidate_workforce_record_to_the_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  external_job_seeker_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  job_posting_id?: InputMaybe<Scalars['String']['input']>;
  job_seeker_code?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location_code?: InputMaybe<Scalars['String']['input']>;
  number_of_tiers?: InputMaybe<Scalars['Int']['input']>;
  payment_currency?: InputMaybe<Scalars['String']['input']>;
  primary_location_code?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Scalars['JSON']['input']>;
  rate_change_matrix_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  register_on_behalf_of_worker?: InputMaybe<Scalars['Boolean']['input']>;
  remit_to_address_code?: InputMaybe<Scalars['String']['input']>;
  security_id?: InputMaybe<Scalars['String']['input']>;
  select_rates?: InputMaybe<Scalars['String']['input']>;
  site_code?: InputMaybe<Scalars['String']['input']>;
  standard_bill_rate?: InputMaybe<Scalars['Float']['input']>;
  standard_pay_rate?: InputMaybe<Scalars['Float']['input']>;
  submitted_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  submitted_to_other_job_postings?: InputMaybe<Scalars['Boolean']['input']>;
  supplier_email?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  worker_country_of_origin?: InputMaybe<Scalars['String']['input']>;
  worker_pay_type?: InputMaybe<Scalars['String']['input']>;
};

export const SenderTypeEnum = {
  Talent: 'talent',
  User: 'user'
} as const;

export type SenderTypeEnum = typeof SenderTypeEnum[keyof typeof SenderTypeEnum];
/** Talent skill */
export type Skill = {
  __typename?: 'Skill';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  skill_type: SkillTypeEnum;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of Skill items. */
export type SkillPaginator = {
  __typename?: 'SkillPaginator';
  /** A list of Skill items. */
  data: Array<Skill>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Talent skill type */
export type SkillType = {
  __typename?: 'SkillType';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export const SkillTypeEnum = {
  HardSkills: 'HARD_SKILLS',
  SoftSkills: 'SOFT_SKILLS',
  Solutions: 'SOLUTIONS'
} as const;

export type SkillTypeEnum = typeof SkillTypeEnum[keyof typeof SkillTypeEnum];
/** Directions for ordering a list of records. */
export const SortOrder = {
  /** Sort records in ascending order. */
  Asc: 'ASC',
  /** Sort records in descending order. */
  Desc: 'DESC'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export const SourceTypeEnum = {
  Community: 'COMMUNITY',
  Opentalent: 'OPENTALENT',
  Own: 'OWN'
} as const;

export type SourceTypeEnum = typeof SourceTypeEnum[keyof typeof SourceTypeEnum];
export type StriiveJob = {
  __typename?: 'StriiveJob';
  attachments?: Maybe<Scalars['JSON']['output']>;
  auto_invoice_type?: Maybe<Scalars['String']['output']>;
  billable_per_diem?: Maybe<Scalars['Float']['output']>;
  broker?: Maybe<Scalars['String']['output']>;
  broker_slug?: Maybe<Scalars['String']['output']>;
  broker_url?: Maybe<Scalars['String']['output']>;
  business_unit?: Maybe<Scalars['String']['output']>;
  can_submit_job_seeker?: Maybe<Scalars['Boolean']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  client_name?: Maybe<Scalars['String']['output']>;
  client_name_slug?: Maybe<Scalars['String']['output']>;
  closed_reason_name?: Maybe<Scalars['String']['output']>;
  closing_date_client?: Maybe<Scalars['DateTime']['output']>;
  closing_date_invoice?: Maybe<Scalars['DateTime']['output']>;
  comments?: Maybe<Scalars['JSON']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  coordinator_full_name?: Maybe<Scalars['String']['output']>;
  coordinator_legal_name?: Maybe<Scalars['String']['output']>;
  cost_center_record_id?: Maybe<Scalars['String']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  department_allocation?: Maybe<Scalars['String']['output']>;
  department_code?: Maybe<Scalars['String']['output']>;
  department_slug?: Maybe<Scalars['String']['output']>;
  distributor_full_name?: Maybe<Scalars['String']['output']>;
  distributor_legal_name?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  estimated_additional_spend?: Maybe<Scalars['Float']['output']>;
  estimated_expenses?: Maybe<Scalars['Float']['output']>;
  estimated_total_hours?: Maybe<Scalars['Int']['output']>;
  extendable?: Maybe<Scalars['Boolean']['output']>;
  external_created_at?: Maybe<Scalars['DateTime']['output']>;
  external_request_number?: Maybe<Scalars['String']['output']>;
  external_url?: Maybe<Scalars['String']['output']>;
  has_client_logo?: Maybe<Scalars['Boolean']['output']>;
  has_max_rate?: Maybe<Scalars['Boolean']['output']>;
  has_recruiter_image?: Maybe<Scalars['Boolean']['output']>;
  hourly_rate_client?: Maybe<Scalars['Float']['output']>;
  hourly_rate_max?: Maybe<Scalars['Int']['output']>;
  hourly_rate_min?: Maybe<Scalars['Int']['output']>;
  hours_per_day?: Maybe<Scalars['Int']['output']>;
  hours_per_week_max?: Maybe<Scalars['Int']['output']>;
  hours_per_week_min?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  job_status?: Maybe<Scalars['Int']['output']>;
  job_type?: Maybe<Scalars['String']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  location_slug?: Maybe<Scalars['String']['output']>;
  max_submissions_allowed?: Maybe<Scalars['Int']['output']>;
  maximum_expenses?: Maybe<Scalars['Float']['output']>;
  monthly_rate_max?: Maybe<Scalars['Int']['output']>;
  monthly_rate_min?: Maybe<Scalars['Int']['output']>;
  number_of_positions?: Maybe<Scalars['Int']['output']>;
  order_classification_status?: Maybe<Scalars['String']['output']>;
  order_classification_type?: Maybe<Scalars['String']['output']>;
  order_contact_full_name?: Maybe<Scalars['String']['output']>;
  order_contact_legal_name?: Maybe<Scalars['String']['output']>;
  order_contact_type?: Maybe<Scalars['String']['output']>;
  permanent_job?: Maybe<Scalars['Boolean']['output']>;
  portal_id?: Maybe<Scalars['String']['output']>;
  position_rule_allow_supplier_to_select_job_seeker_site?: Maybe<Scalars['Boolean']['output']>;
  position_rule_auto_activate?: Maybe<Scalars['Boolean']['output']>;
  position_rule_auto_engage?: Maybe<Scalars['Boolean']['output']>;
  position_rule_auto_register?: Maybe<Scalars['Boolean']['output']>;
  position_rule_bill_rate_can_exceed_requested?: Maybe<Scalars['Boolean']['output']>;
  position_rule_pay_rate_required?: Maybe<Scalars['Boolean']['output']>;
  position_rule_resume_required?: Maybe<Scalars['Boolean']['output']>;
  position_rule_supplier_must_enter_rate_change_amounts?: Maybe<Scalars['Boolean']['output']>;
  published_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_order_number?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Scalars['JSON']['output']>;
  questions?: Maybe<Scalars['JSON']['output']>;
  rate_type?: Maybe<Scalars['Int']['output']>;
  rates?: Maybe<Scalars['JSON']['output']>;
  record_id?: Maybe<Scalars['String']['output']>;
  recruiter?: Maybe<Scalars['String']['output']>;
  recruiter_email?: Maybe<Scalars['String']['output']>;
  recruiter_first_name?: Maybe<Scalars['String']['output']>;
  recruiter_function_title?: Maybe<Scalars['String']['output']>;
  recruiter_id?: Maybe<Scalars['String']['output']>;
  recruiter_initials?: Maybe<Scalars['String']['output']>;
  recruiter_last_name?: Maybe<Scalars['String']['output']>;
  recruiter_middle_name?: Maybe<Scalars['String']['output']>;
  recruiter_phone_number?: Maybe<Scalars['String']['output']>;
  recruiter_slug?: Maybe<Scalars['String']['output']>;
  reference_code?: Maybe<Scalars['String']['output']>;
  reference_code_client?: Maybe<Scalars['String']['output']>;
  report_to_full_name?: Maybe<Scalars['String']['output']>;
  report_to_legal_name?: Maybe<Scalars['String']['output']>;
  segment_name?: Maybe<Scalars['String']['output']>;
  segment_name_slug?: Maybe<Scalars['String']['output']>;
  service_type?: Maybe<Scalars['String']['output']>;
  site_tax?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<StriiveJobSourceEnum>;
  staffing_customer_record_id?: Maybe<Scalars['String']['output']>;
  staffing_supplier_record_id?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  striive_created_at?: Maybe<Scalars['DateTime']['output']>;
  striive_id: Scalars['String']['output'];
  striive_updated_at?: Maybe<Scalars['DateTime']['output']>;
  submitted_at?: Maybe<Scalars['DateTime']['output']>;
  tag_names?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_slug?: Maybe<Scalars['String']['output']>;
  trail_end_date?: Maybe<Scalars['DateTime']['output']>;
  travel_time?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  work_site_address?: Maybe<Scalars['String']['output']>;
  work_site_address2?: Maybe<Scalars['String']['output']>;
  work_site_city?: Maybe<Scalars['String']['output']>;
  work_site_country_code?: Maybe<Scalars['String']['output']>;
  work_site_postal_code?: Maybe<Scalars['String']['output']>;
  work_site_record_id?: Maybe<Scalars['String']['output']>;
  work_site_state_code?: Maybe<Scalars['String']['output']>;
};

export const StriiveJobSourceEnum = {
  Atos: 'ATOS',
  Bayer: 'Bayer',
  Between: 'Between',
  Capgemini: 'Capgemini',
  FastFlex: 'FastFlex',
  FastFlexSourcing: 'FastFlexSourcing',
  Group: 'Group',
  Hfrb: 'HFRB',
  HeadFirst: 'HeadFirst',
  HeadFirstBe: 'HeadFirstBE',
  Jenrick: 'Jenrick',
  Maximus: 'Maximus',
  Myler: 'Myler',
  Rabobank: 'Rabobank',
  Shell: 'Shell',
  Source: 'Source',
  StackOps: 'StackOps',
  StaffingMs: 'StaffingMS',
  StarApple: 'StarApple',
  Sterksen: 'Sterksen',
  Striive: 'Striive',
  Wtw: 'WTW',
  YellowFriday: 'YellowFriday',
  Netive: 'netive'
} as const;

export type StriiveJobSourceEnum = typeof StriiveJobSourceEnum[keyof typeof StriiveJobSourceEnum];
export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  cancel_at_period_end?: Maybe<Scalars['Boolean']['output']>;
  current_period_end?: Maybe<Scalars['DateTime']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
};

export type Subcategory = {
  __typename?: 'Subcategory';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  chatMessageCreated?: Maybe<ChatMessage>;
};

export const SuggestingStageEnum = {
  Forwarded: 'FORWARDED',
  Hired: 'HIRED',
  InInterview: 'IN_INTERVIEW',
  Rejected: 'REJECTED',
  RejectedAfterInterview: 'REJECTED_AFTER_INTERVIEW',
  Submitted: 'SUBMITTED'
} as const;

export type SuggestingStageEnum = typeof SuggestingStageEnum[keyof typeof SuggestingStageEnum];
export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Talent = {
  __typename?: 'Talent';
  about?: Maybe<Scalars['String']['output']>;
  account_settings?: Maybe<TalentAccountSettings>;
  account_type: AccountTypeEnum;
  address?: Maybe<Scalars['String']['output']>;
  adobe_portfolio_url?: Maybe<Scalars['String']['output']>;
  available_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  available_date_updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  available_now?: Maybe<Scalars['Boolean']['output']>;
  avatar?: Maybe<Avatar>;
  behance_url?: Maybe<Scalars['String']['output']>;
  bitbucket_url?: Maybe<Scalars['String']['output']>;
  canva_url?: Maybe<Scalars['String']['output']>;
  category?: Maybe<TalentCategory>;
  city?: Maybe<Scalars['String']['output']>;
  companies: Array<Maybe<Company>>;
  company_pool_connections?: Maybe<Array<Maybe<TalentCompanyPoolConnection>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<CurrencyEnum>;
  currently_works_for_one_of_the_companies?: Maybe<Scalars['Boolean']['output']>;
  default_company_referral_key?: Maybe<Scalars['String']['output']>;
  desired_job_types?: Maybe<Array<Maybe<TalentDesiredJobTypeEnum>>>;
  documents?: Maybe<Array<Maybe<TalentDocument>>>;
  dribbble_url?: Maybe<Scalars['String']['output']>;
  email_abac: AbacString;
  employee_name_who_referred?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  figma_url?: Maybe<Scalars['String']['output']>;
  first_name_abac: AbacString;
  full_name_abac: AbacString;
  future_relocation_preferences?: Maybe<Array<Maybe<TalentFutureRelocationPreference>>>;
  github_url?: Maybe<Scalars['String']['output']>;
  gitlab_url?: Maybe<Scalars['String']['output']>;
  hours_per_week?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instagram_url?: Maybe<Scalars['String']['output']>;
  invited_by?: Maybe<TalentInvitedBy>;
  is_agree_to_ai?: Maybe<Scalars['Boolean']['output']>;
  is_agree_to_marketing_materials?: Maybe<Scalars['Boolean']['output']>;
  is_agree_to_sms?: Maybe<Scalars['Boolean']['output']>;
  is_agree_to_terms_and_conditions?: Maybe<Scalars['Boolean']['output']>;
  is_authorized_to_work_in_the_us?: Maybe<Scalars['Boolean']['output']>;
  is_bilingual?: Maybe<Scalars['Boolean']['output']>;
  is_invitation_accepted?: Maybe<Scalars['Boolean']['output']>;
  is_matcher?: Maybe<Scalars['Boolean']['output']>;
  is_ot_pool?: Maybe<Scalars['Boolean']['output']>;
  is_static?: Maybe<Scalars['Boolean']['output']>;
  is_verification_required?: Maybe<Scalars['Boolean']['output']>;
  job_applications?: Maybe<Array<Maybe<JobApplication>>>;
  join_reason?: Maybe<Array<Maybe<JoinReasonEnum>>>;
  kaggle_url?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Maybe<TalentLanguageEnum>>>;
  last_name_abac: AbacString;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  marketing_source?: Maybe<TalentMarketingSourceEnum>;
  medium_url?: Maybe<Scalars['String']['output']>;
  notion_url?: Maybe<Scalars['String']['output']>;
  number_of_active_matcher_assignments?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<TalentOriginEnum>;
  other_url?: Maybe<Scalars['String']['output']>;
  personal_portfolio_url?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  rate_max?: Maybe<Scalars['Float']['output']>;
  rate_min?: Maybe<Scalars['Float']['output']>;
  recent_position_title?: Maybe<Scalars['String']['output']>;
  recruiter_countries?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  recruiter_industries?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  recruiter_job_roles?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  recruiter_number_of_candidates?: Maybe<RecruiterNumberCandidatesEnum>;
  recruiter_number_of_years?: Maybe<RecruiterNumberOfYearsEnum>;
  recruiter_role?: Maybe<RecruiterRolesEnum>;
  recruiter_specializations?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  region?: Maybe<RegionEnum>;
  reminded_at?: Maybe<Scalars['DateTime']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  skills: SkillPaginator;
  slideshare_url?: Maybe<Scalars['String']['output']>;
  source?: Maybe<TalentSource>;
  state?: Maybe<Scalars['String']['output']>;
  stream_chat_id?: Maybe<Scalars['String']['output']>;
  stream_chat_token?: Maybe<Scalars['String']['output']>;
  subcategories: Array<Maybe<Subcategory>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  talent_data?: Maybe<TalentData>;
  talent_work_history?: Maybe<Array<Maybe<TalentWorkHistory>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  upwork_url?: Maybe<Scalars['String']['output']>;
  work_type?: Maybe<Array<Maybe<TalentWorkTypeEnum>>>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type TalentSkillsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentAccountSettings = {
  __typename?: 'TalentAccountSettings';
  instant_matches_notifications_min_score?: Maybe<InstantMatchesNotificationsScoreEnum>;
  locale?: Maybe<LocaleEnum>;
  pref_date_format?: Maybe<DateFormatEnum>;
  pref_lang?: Maybe<Scalars['String']['output']>;
  receive_company_and_product_updates?: Maybe<Scalars['Boolean']['output']>;
  receive_marketing_emails?: Maybe<Scalars['Boolean']['output']>;
  receive_sms_and_phone_calls?: Maybe<Scalars['Boolean']['output']>;
};

export type TalentAccountSettingsInput = {
  instant_matches_notifications_min_score?: InputMaybe<InstantMatchesNotificationsScoreEnum>;
  locale?: InputMaybe<LocaleEnum>;
  pref_date_format?: InputMaybe<DateFormatEnum>;
  pref_lang?: InputMaybe<Scalars['String']['input']>;
  receive_company_and_product_updates?: InputMaybe<Scalars['Boolean']['input']>;
  receive_marketing_emails?: InputMaybe<Scalars['Boolean']['input']>;
  receive_sms_and_phone_calls?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TalentAccountVerificationInput = {
  phone?: InputMaybe<Scalars['String']['input']>;
  vat_number?: InputMaybe<Scalars['String']['input']>;
};

export type TalentCategory = {
  __typename?: 'TalentCategory';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  subcategories?: Maybe<Array<Subcategory>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TalentCompanyPoolConnection = {
  __typename?: 'TalentCompanyPoolConnection';
  cancel_initiator?: Maybe<TalentCompanyPoolingInitiatorEnum>;
  company?: Maybe<Company>;
  initiator?: Maybe<TalentCompanyPoolingInitiatorEnum>;
  status?: Maybe<TalentCompanyPoolingStatusEnum>;
  talent?: Maybe<Talent>;
};

export const TalentCompanyPoolingInitiatorEnum = {
  Company: 'COMPANY',
  System: 'SYSTEM',
  Talent: 'TALENT'
} as const;

export type TalentCompanyPoolingInitiatorEnum = typeof TalentCompanyPoolingInitiatorEnum[keyof typeof TalentCompanyPoolingInitiatorEnum];
export const TalentCompanyPoolingStatusEnum = {
  Approved: 'APPROVED',
  Cancelled: 'CANCELLED',
  Pending: 'PENDING',
  Rejected: 'REJECTED'
} as const;

export type TalentCompanyPoolingStatusEnum = typeof TalentCompanyPoolingStatusEnum[keyof typeof TalentCompanyPoolingStatusEnum];
export type TalentData = {
  __typename?: 'TalentData';
  phone?: Maybe<Scalars['String']['output']>;
  phone_abac?: Maybe<Scalars['String']['output']>;
  vat_number?: Maybe<Scalars['String']['output']>;
};

export const TalentDesiredJobTypeEnum = {
  Hybrid: 'HYBRID',
  OnSite: 'ON_SITE',
  Remote: 'REMOTE'
} as const;

export type TalentDesiredJobTypeEnum = typeof TalentDesiredJobTypeEnum[keyof typeof TalentDesiredJobTypeEnum];
export type TalentDocument = {
  __typename?: 'TalentDocument';
  content_type: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  hash: Scalars['String']['output'];
  is_primary_cv?: Maybe<Scalars['Boolean']['output']>;
  size: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<TalentDocumentType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url_abac?: Maybe<AbacString>;
};

export type TalentDocumentInput = {
  hash: Scalars['String']['input'];
  is_primary_cv: Scalars['Boolean']['input'];
  type: TalentDocumentType;
};

export const TalentDocumentType = {
  Cv: 'cv',
  Portfolio: 'portfolio'
} as const;

export type TalentDocumentType = typeof TalentDocumentType[keyof typeof TalentDocumentType];
export type TalentFutureRelocationPreference = {
  __typename?: 'TalentFutureRelocationPreference';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type TalentFutureRelocationPreferenceInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type TalentGeneralInfoInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  adobe_portfolio_url?: InputMaybe<Scalars['String']['input']>;
  behance_url?: InputMaybe<Scalars['String']['input']>;
  bitbucket_url?: InputMaybe<Scalars['String']['input']>;
  can_help_with?: InputMaybe<Array<InputMaybe<CanHelpWithEnum>>>;
  canva_url?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  desired_job_types?: InputMaybe<Array<InputMaybe<TalentDesiredJobTypeEnum>>>;
  dribbble_url?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  figma_url?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  future_relocation_preferences?: InputMaybe<Array<InputMaybe<TalentFutureRelocationPreferenceInput>>>;
  github_url?: InputMaybe<Scalars['String']['input']>;
  gitlab_url?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  is_agree_to_ai?: InputMaybe<Scalars['Boolean']['input']>;
  is_authorized_to_work_in_the_us?: InputMaybe<Scalars['Boolean']['input']>;
  join_reason?: InputMaybe<Array<InputMaybe<JoinReasonEnum>>>;
  kaggle_url?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  medium_url?: InputMaybe<Scalars['String']['input']>;
  notion_url?: InputMaybe<Scalars['String']['input']>;
  other_url?: InputMaybe<Scalars['String']['input']>;
  personal_portfolio_url?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rate_max?: InputMaybe<Scalars['Float']['input']>;
  rate_min?: InputMaybe<Scalars['Float']['input']>;
  recent_position_title?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  slideshare_url?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  talent_category_id?: InputMaybe<Scalars['ID']['input']>;
  talent_source_id?: InputMaybe<Scalars['ID']['input']>;
  talent_subcategory_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  upwork_url?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type TalentInvitation = {
  __typename?: 'TalentInvitation';
  /** Company id if invitation is for specific company pool */
  company_id?: Maybe<Scalars['ID']['output']>;
  company_user_inviter?: Maybe<User>;
  created_at: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_accepted: Scalars['Boolean']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  talent?: Maybe<Talent>;
  talent_inviter?: Maybe<Talent>;
  uid: Scalars['String']['output'];
};

export const TalentInvitationTypeEnum = {
  InvitationTypeByCompany: 'INVITATION_TYPE_BY_COMPANY',
  InvitationTypeByTalent: 'INVITATION_TYPE_BY_TALENT',
  WithoutInvitation: 'WITHOUT_INVITATION'
} as const;

export type TalentInvitationTypeEnum = typeof TalentInvitationTypeEnum[keyof typeof TalentInvitationTypeEnum];
export type TalentInvitedBy = {
  __typename?: 'TalentInvitedBy';
  company_name?: Maybe<Scalars['String']['output']>;
  first_name_abac?: Maybe<AbacString>;
  id?: Maybe<Scalars['ID']['output']>;
  invitation_type?: Maybe<TalentInvitationTypeEnum>;
  last_name_abac?: Maybe<AbacString>;
};

export type TalentJobConnection = {
  __typename?: 'TalentJobConnection';
  is_applied: Scalars['Boolean']['output'];
  is_saved: Scalars['Boolean']['output'];
};

export const TalentLanguageEnum = {
  Arabic: 'ARABIC',
  Bengali: 'BENGALI',
  Chinese: 'CHINESE',
  English: 'ENGLISH',
  French: 'FRENCH',
  FrenchCreole: 'FRENCH_CREOLE',
  German: 'GERMAN',
  Hindi: 'HINDI',
  Japanese: 'JAPANESE',
  Mandarin: 'MANDARIN',
  Russian: 'RUSSIAN',
  Spanish: 'SPANISH'
} as const;

export type TalentLanguageEnum = typeof TalentLanguageEnum[keyof typeof TalentLanguageEnum];
export type TalentLogRecordInterface = {
  actor?: Maybe<AtsRecordActor>;
  company_id?: Maybe<Scalars['ID']['output']>;
  date: Scalars['DateTimeUtc']['output'];
  id: Scalars['ID']['output'];
  type: AtsRecordTypeEnum;
};

export const TalentMarketingSourceEnum = {
  ClientWebsite: 'CLIENT_WEBSITE',
  EmployeeReferral: 'EMPLOYEE_REFERRAL',
  Other: 'OTHER',
  SearchEngine: 'SEARCH_ENGINE'
} as const;

export type TalentMarketingSourceEnum = typeof TalentMarketingSourceEnum[keyof typeof TalentMarketingSourceEnum];
export const TalentOriginEnum = {
  EnterpriseLanding: 'ENTERPRISE_LANDING',
  ExternalJobPageApplication: 'EXTERNAL_JOB_PAGE_APPLICATION',
  InvitedByCompanyUser: 'INVITED_BY_COMPANY_USER',
  InvitedByTalent: 'INVITED_BY_TALENT',
  MainLanding: 'MAIN_LANDING',
  OldUser: 'OLD_USER'
} as const;

export type TalentOriginEnum = typeof TalentOriginEnum[keyof typeof TalentOriginEnum];
/** A paginated list of Talent items. */
export type TalentPaginator = {
  __typename?: 'TalentPaginator';
  /** A list of Talent items. */
  data: Array<Talent>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TalentSearchHighlight = {
  __typename?: 'TalentSearchHighlight';
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TalentSearchResult = {
  __typename?: 'TalentSearchResult';
  highlights?: Maybe<Array<TalentSearchHighlight>>;
  talent?: Maybe<Talent>;
};

export type TalentSource = {
  __typename?: 'TalentSource';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TalentWorkHistory = {
  __typename?: 'TalentWorkHistory';
  company_name: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  position_title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  worked_from?: Maybe<Scalars['DateTime']['output']>;
  worked_to?: Maybe<Scalars['DateTime']['output']>;
};

export const TalentWorkTypeEnum = {
  DirectHire: 'DIRECT_HIRE',
  Temporary: 'TEMPORARY'
} as const;

export type TalentWorkTypeEnum = typeof TalentWorkTypeEnum[keyof typeof TalentWorkTypeEnum];
export type TalentsBooleanSkillsFilterInput = {
  boolean_skills_filter_items?: InputMaybe<Array<InputMaybe<TalentsBooleanSkillsFilterItemInput>>>;
  not_skills_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TalentsBooleanSkillsFilterItemInput = {
  all_of_skills_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  boolean_operator?: InputMaybe<BooleanOperatorsEnum>;
  one_of_skills_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Allows ordering a list of records. */
export type TalentsOrderByClause = {
  /** The column that is used for ordering. */
  column: TalentsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Order by clause for the `orderBy` argument on the query `posts`. */
export const TalentsOrderByColumn = {
  AvailableNow: 'AVAILABLE_NOW',
  IsInvitationAccepted: 'IS_INVITATION_ACCEPTED',
  TalentId: 'TALENT_ID'
} as const;

export type TalentsOrderByColumn = typeof TalentsOrderByColumn[keyof typeof TalentsOrderByColumn];
export const TalentsOrderBySimple = {
  HighestPricePerHour: 'HIGHEST_PRICE_PER_HOUR',
  LeastRecent: 'LEAST_RECENT',
  LowestPricePerHour: 'LOWEST_PRICE_PER_HOUR',
  MostRecent: 'MOST_RECENT'
} as const;

export type TalentsOrderBySimple = typeof TalentsOrderBySimple[keyof typeof TalentsOrderBySimple];
export type TalentsSearchPaginator = {
  __typename?: 'TalentsSearchPaginator';
  custom_paginator_info: CustomPaginatorInfo;
  data: Array<TalentSearchResult>;
};

export type TempDataItem = {
  __typename?: 'TempDataItem';
  cv_companies_extraction?: Maybe<Array<Maybe<CvCompanyExtraction>>>;
  cv_data_extraction?: Maybe<CvDataExtraction>;
  cv_skills_extraction?: Maybe<Array<Maybe<Skill>>>;
  data?: Maybe<Scalars['String']['output']>;
  device_id: Scalars['String']['output'];
  email?: Maybe<Scalars['Email']['output']>;
};

export type TempDataItemSearchResult = {
  __typename?: 'TempDataItemSearchResult';
  result?: Maybe<TempDataItem>;
  success: Scalars['Boolean']['output'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export const Trashed = {
  /** Only return trashed results. */
  Only: 'ONLY',
  /** Return both trashed and non-trashed results. */
  With: 'WITH',
  /** Only return non-trashed results. */
  Without: 'WITHOUT'
} as const;

export type Trashed = typeof Trashed[keyof typeof Trashed];
export type User = {
  __typename?: 'User';
  account_settings?: Maybe<CompanyUserAccountSettings>;
  avatar?: Maybe<Avatar>;
  company?: Maybe<UserCompany>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['Email']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_primary?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  scoped_companies: Array<UserCompany>;
  stream_chat_id?: Maybe<Scalars['String']['output']>;
  stream_chat_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type UserCompany = {
  __typename?: 'UserCompany';
  about?: Maybe<Scalars['String']['output']>;
  account_type?: Maybe<CompanyAccountTypeEnum>;
  address?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<OtContract>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<CurrencyEnum>;
  has_contract: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_broadbean_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_vonage_enabled?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  region?: Maybe<RegionEnum>;
  sign_up_landing_link?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  type_of_activity?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type WorkHistoryInput = {
  company_name: Scalars['String']['input'];
  position_title: Scalars['String']['input'];
  worked_from?: InputMaybe<Scalars['Date']['input']>;
  worked_to?: InputMaybe<Scalars['Date']['input']>;
};

export type CustomPaginatorInfo = {
  __typename?: 'customPaginatorInfo';
  current_page: Scalars['Int']['output'];
  last_page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RestoreDeletedAccountInfo = {
  __typename?: 'restoreDeletedAccountInfo';
  link_to_set_password_page?: Maybe<Scalars['String']['output']>;
};

export type SelfDeletePageInfo = {
  __typename?: 'selfDeletePageInfo';
  invited_by_full_name?: Maybe<Scalars['String']['output']>;
};

export type TalentInvitationsInfo = {
  __typename?: 'talentInvitationsInfo';
  /** Default referral key for company */
  default_company_referral_key?: Maybe<Scalars['String']['output']>;
  /** Talents who have already been invited */
  invited_talents?: Maybe<Array<Maybe<Talent>>>;
  /** Companies that were invited using talent's referral link */
  referred_companies?: Maybe<Array<Maybe<Company>>>;
  /** Number of invitations left for talent to invite another talents */
  talent_invitations_left: Scalars['Int']['output'];
};

export type TalentsCountItem = {
  __typename?: 'talentsCountItem';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  talents_count: Scalars['Int']['output'];
};

export type GetAtsRecordsQueryVariables = Exact<{
  talent_id?: InputMaybe<Scalars['ID']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAtsRecordsQuery = { __typename?: 'Query', ATSRecords?: Array<
    | { __typename: 'ATSRecordComment', text?: string | undefined, id: string, type: AtsRecordTypeEnum, date: any, actor?: { __typename?: 'ATSRecordActor', first_name: string, last_name?: string | undefined, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined }
    | { __typename: 'ATSRecordJobMatchAction', id: string, type: AtsRecordTypeEnum, date: any, job_match_action?: { __typename?: 'JobMatchAction', id: string, job_match_action_type: JobMatchActionTypeEnum, job_match_type_before?: JobMatchTypeEnum | undefined, job_match_type_after?: JobMatchTypeEnum | undefined, job_match?: { __typename?: 'JobMatch', job: { __typename?: 'Job', id: string, name: string } } | undefined } | undefined, actor?: { __typename?: 'ATSRecordActor', first_name: string, last_name?: string | undefined, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined }
   | undefined> | undefined };

export type GetNotificationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  is_important?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', currentUserUnreadNotificationsCount?: number | undefined, unreadImportantNotificationsCount: { __typename?: 'NotificationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } }, currentUserNotifications: { __typename?: 'NotificationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined, hasMorePages: boolean, lastItem?: number | undefined, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Notification', id: string, is_important: boolean, recipient_type: NotificationRecipientTypeEnum, recipient_id: string, title?: string | undefined, related_job_id?: string | undefined, is_read: boolean, created_at: any, buttons?: Array<{ __typename?: 'NotificationButton', text: string, action: { __typename?: 'NotificationActionRedirect', target_route_type?: RedirectTargetRouteTypeEnum | undefined, target_route_id: string, type?: NotificationActionTypeEnum | undefined } } | undefined> | undefined, reply_to?: { __typename?: 'User', id: string, stream_chat_id?: string | undefined, first_name?: string | undefined, last_name?: string | undefined, position?: string | undefined, company?: { __typename?: 'UserCompany', id: string, name: string, logo?: string | undefined } | undefined, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined, message: { __typename?: 'NotificationMessage', template?: string | undefined, template_actions?: Array<{ __typename?: 'NotificationTemplateAction', key?: string | undefined, text?: string | undefined, action?: { __typename?: 'NotificationActionRedirect', target_route_type?: RedirectTargetRouteTypeEnum | undefined, target_route_id: string, type?: NotificationActionTypeEnum | undefined } | undefined } | undefined> | undefined } }> } };

export type NotificationsListMainFragment = { __typename?: 'NotificationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined, hasMorePages: boolean, lastItem?: number | undefined, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Notification', id: string, is_important: boolean, recipient_type: NotificationRecipientTypeEnum, recipient_id: string, title?: string | undefined, related_job_id?: string | undefined, is_read: boolean, created_at: any, buttons?: Array<{ __typename?: 'NotificationButton', text: string, action: { __typename?: 'NotificationActionRedirect', target_route_type?: RedirectTargetRouteTypeEnum | undefined, target_route_id: string, type?: NotificationActionTypeEnum | undefined } } | undefined> | undefined, reply_to?: { __typename?: 'User', id: string, stream_chat_id?: string | undefined, first_name?: string | undefined, last_name?: string | undefined, position?: string | undefined, company?: { __typename?: 'UserCompany', id: string, name: string, logo?: string | undefined } | undefined, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined, message: { __typename?: 'NotificationMessage', template?: string | undefined, template_actions?: Array<{ __typename?: 'NotificationTemplateAction', key?: string | undefined, text?: string | undefined, action?: { __typename?: 'NotificationActionRedirect', target_route_type?: RedirectTargetRouteTypeEnum | undefined, target_route_id: string, type?: NotificationActionTypeEnum | undefined } | undefined } | undefined> | undefined } }> };

export type ApplyCurrentTalentToCompanyPoolMutationVariables = Exact<{
  company_id: Scalars['ID']['input'];
}>;


export type ApplyCurrentTalentToCompanyPoolMutation = { __typename?: 'Mutation', applyCurrentTalentToCompanyPool?: boolean | undefined };

export type LeaveCurrentTalentFromCompanyPoolMutationVariables = Exact<{
  company_id: Scalars['ID']['input'];
}>;


export type LeaveCurrentTalentFromCompanyPoolMutation = { __typename?: 'Mutation', leaveCurrentTalentFromCompanyPool?: boolean | undefined };

export type AcceptCompanyPoolInvitationMutationVariables = Exact<{
  company_id: Scalars['ID']['input'];
}>;


export type AcceptCompanyPoolInvitationMutation = { __typename?: 'Mutation', acceptCompanyPoolInvitation?: boolean | undefined };

export type RejectCompanyPoolInvitationMutationVariables = Exact<{
  company_id: Scalars['ID']['input'];
}>;


export type RejectCompanyPoolInvitationMutation = { __typename?: 'Mutation', rejectCompanyPoolInvitation?: boolean | undefined };

export type InviteTalentToCompanyPoolMutationVariables = Exact<{
  talent_id: Scalars['ID']['input'];
}>;


export type InviteTalentToCompanyPoolMutation = { __typename?: 'Mutation', inviteTalentToCompanyPool?: boolean | undefined };

export type RejectTalentCompanyPoolApplicationMutationVariables = Exact<{
  talent_id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectTalentCompanyPoolApplicationMutation = { __typename?: 'Mutation', rejectTalentCompanyPoolApplication?: boolean | undefined };

export type RemoveTalentFromCompanyPoolMutationVariables = Exact<{
  talent_id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveTalentFromCompanyPoolMutation = { __typename?: 'Mutation', removeTalentFromCompanyPool?: boolean | undefined };

export type ApproveTalentCompanyPoolApplicationMutationVariables = Exact<{
  talent_id: Scalars['ID']['input'];
}>;


export type ApproveTalentCompanyPoolApplicationMutation = { __typename?: 'Mutation', approveTalentCompanyPoolApplication?: boolean | undefined };

export type RevokeCompanyPoolInvitationMutationVariables = Exact<{
  talent_id: Scalars['ID']['input'];
}>;


export type RevokeCompanyPoolInvitationMutation = { __typename?: 'Mutation', revokeCompanyPoolInvitation?: boolean | undefined };

export type SubmissionStatusFieldsFragment = { __typename?: 'FieldGlassCandidateIntroduction', submission_status?: FieldGlassCandidateIntroductionSubmissionStatusEnum | undefined, error_message?: string | undefined, api_response?: any | undefined };

export type GetApplicationFormJobInfoQueryVariables = Exact<{
  job_id: Scalars['ID']['input'];
  match_id: Scalars['ID']['input'];
}>;


export type GetApplicationFormJobInfoQuery = { __typename?: 'Query', fieldGlassCandidateIntroductionByJobMatchId?: { __typename?: 'FieldGlassCandidateIntroduction', id: string, first_name?: string | undefined, last_name?: string | undefined, email?: string | undefined, job_posting_id?: string | undefined, additional_invoice_currency?: string | undefined, answers?: any | undefined, calculate_rate_using?: string | undefined, comments?: string | undefined, created_at: any, creator_username?: string | undefined, date_available?: any | undefined, date_of_birth?: any | undefined, display_candidate_workforce_record_to_the_buyer?: boolean | undefined, external_job_seeker_id?: string | undefined, job_seeker_code?: string | undefined, location_code?: string | undefined, number_of_tiers?: number | undefined, payment_currency?: string | undefined, double_pay_rate?: number | undefined, overtime_pay_rate?: number | undefined, standard_pay_rate?: number | undefined, primary_location_code?: string | undefined, qualifications?: any | undefined, rate_change_matrix_start_date?: any | undefined, register_on_behalf_of_worker?: boolean | undefined, remit_to_address_code?: string | undefined, security_id?: string | undefined, select_rates?: string | undefined, site_code?: string | undefined, submitted_at?: any | undefined, submitted_by_user_id?: string | undefined, submitted_to_other_job_postings?: boolean | undefined, supplier_email?: string | undefined, time_zone?: string | undefined, unique_id?: string | undefined, updated_at: any, username?: string | undefined, worker_country_of_origin?: string | undefined, worker_pay_type?: string | undefined, submission_status?: FieldGlassCandidateIntroductionSubmissionStatusEnum | undefined, error_message?: string | undefined, api_response?: any | undefined, cv_attachment?: { __typename?: 'File', hash: string, title: string, content_type: string } | undefined } | undefined, job?: { __typename?: 'Job', id: string, name: string, striive_job?: { __typename?: 'StriiveJob', id: string, questions?: any | undefined, qualifications?: any | undefined, rates?: any | undefined, rate_type?: number | undefined, record_id?: string | undefined, source?: StriiveJobSourceEnum | undefined } | undefined, matches?: Array<{ __typename?: 'JobMatch', id: string, talent?: { __typename?: 'Talent', id: string, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, email_abac: { __typename?: 'ABACString', value?: string | undefined }, documents?: Array<{ __typename?: 'TalentDocument', hash: string, title: string, type?: TalentDocumentType | undefined } | undefined> | undefined } | undefined } | undefined> | undefined } | undefined };

export type CreateFieldGlassCandidateIntroductionMutationVariables = Exact<{
  introduction: CreateFieldGlassCandidateIntroductionInput;
  job_match_id: Scalars['ID']['input'];
}>;


export type CreateFieldGlassCandidateIntroductionMutation = { __typename?: 'Mutation', createFieldGlassCandidateIntroduction: { __typename?: 'FieldGlassCandidateIntroduction', id: string, first_name?: string | undefined, site_code?: string | undefined, last_name?: string | undefined, email?: string | undefined, job_posting_id?: string | undefined, date_available?: any | undefined, worker_pay_type?: string | undefined, security_id?: string | undefined, location_code?: string | undefined, double_pay_rate?: number | undefined, overtime_pay_rate?: number | undefined, standard_pay_rate?: number | undefined, display_candidate_workforce_record_to_the_buyer?: boolean | undefined, submitted_to_other_job_postings?: boolean | undefined, qualifications?: any | undefined, answers?: any | undefined, additional_invoice_currency?: string | undefined, calculate_rate_using?: string | undefined, comments?: string | undefined, date_of_birth?: any | undefined, external_job_seeker_id?: string | undefined, job_seeker_code?: string | undefined, number_of_tiers?: number | undefined, payment_currency?: string | undefined, primary_location_code?: string | undefined, rate_change_matrix_start_date?: any | undefined, register_on_behalf_of_worker?: boolean | undefined, remit_to_address_code?: string | undefined, select_rates?: string | undefined, supplier_email?: string | undefined, time_zone?: string | undefined, unique_id?: string | undefined, worker_country_of_origin?: string | undefined, submission_status?: FieldGlassCandidateIntroductionSubmissionStatusEnum | undefined, submitted_at?: any | undefined, submitted_by_user_id?: string | undefined, created_at: any, updated_at: any, candidate_cv_hash?: string | undefined, cv_attachment?: { __typename?: 'File', hash: string, title: string, content_type: string } | undefined } };

export type UpdateFieldGlassCandidateIntroductionMutationVariables = Exact<{
  introduction: SaveFieldGlassCandidateIntroductionInput;
  introduction_id: Scalars['ID']['input'];
}>;


export type UpdateFieldGlassCandidateIntroductionMutation = { __typename?: 'Mutation', saveFieldGlassCandidateIntroduction: { __typename?: 'FieldGlassCandidateIntroduction', id: string, first_name?: string | undefined, last_name?: string | undefined, email?: string | undefined, job_posting_id?: string | undefined, date_available?: any | undefined, double_pay_rate?: number | undefined, overtime_pay_rate?: number | undefined, standard_pay_rate?: number | undefined, worker_pay_type?: string | undefined, site_code?: string | undefined, security_id?: string | undefined, location_code?: string | undefined, display_candidate_workforce_record_to_the_buyer?: boolean | undefined, submitted_to_other_job_postings?: boolean | undefined, qualifications?: any | undefined, answers?: any | undefined, additional_invoice_currency?: string | undefined, calculate_rate_using?: string | undefined, comments?: string | undefined, date_of_birth?: any | undefined, external_job_seeker_id?: string | undefined, job_seeker_code?: string | undefined, number_of_tiers?: number | undefined, payment_currency?: string | undefined, primary_location_code?: string | undefined, rate_change_matrix_start_date?: any | undefined, register_on_behalf_of_worker?: boolean | undefined, remit_to_address_code?: string | undefined, select_rates?: string | undefined, supplier_email?: string | undefined, time_zone?: string | undefined, unique_id?: string | undefined, worker_country_of_origin?: string | undefined, submission_status?: FieldGlassCandidateIntroductionSubmissionStatusEnum | undefined, submitted_at?: any | undefined, submitted_by_user_id?: string | undefined, created_at: any, updated_at: any, candidate_cv_hash?: string | undefined, cv_attachment?: { __typename?: 'File', hash: string, title: string, content_type: string } | undefined } };

export type GetFieldGlassSubmissionStatusQueryVariables = Exact<{
  match_id: Scalars['ID']['input'];
}>;


export type GetFieldGlassSubmissionStatusQuery = { __typename?: 'Query', fieldGlassCandidateIntroductionByJobMatchId?: { __typename?: 'FieldGlassCandidateIntroduction', id: string, submission_status?: FieldGlassCandidateIntroductionSubmissionStatusEnum | undefined, error_message?: string | undefined, api_response?: any | undefined } | undefined };

export type SubmitFieldGlassCandidateIntroductionMutationVariables = Exact<{
  introduction_id: Scalars['ID']['input'];
}>;


export type SubmitFieldGlassCandidateIntroductionMutation = { __typename?: 'Mutation', submitFieldGlassCandidateIntroduction?: boolean | undefined };

export type GetDashboardInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardInfoQuery = { __typename?: 'Query', pendingTalents: { __typename?: 'TalentPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } }, generalAnalytics?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined } | undefined> | undefined, tagsAnalytics?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined } | undefined> | undefined, countryAnalytics?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined } | undefined> | undefined, categoryAnalytics?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined } | undefined> | undefined, lastTalents?: Array<{ __typename?: 'Talent', id: string, location?: string | undefined, rate?: number | undefined, currency?: CurrencyEnum | undefined, is_invitation_accepted?: boolean | undefined, recent_position_title?: string | undefined, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined> | undefined };

export type GetPendingTalentsCountQueryVariables = Exact<{
  source_type?: InputMaybe<SourceTypeEnum>;
  is_verification_required?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPendingTalentsCountQuery = { __typename?: 'Query', talentsSearch?: { __typename?: 'TalentsSearchPaginator', custom_paginator_info: { __typename?: 'customPaginatorInfo', total: number } } | undefined };

export type GetDashboardV2VInfoQueryVariables = Exact<{
  company_id: Scalars['ID']['input'];
}>;


export type GetDashboardV2VInfoQuery = { __typename?: 'Query', pendingTalents?: { __typename?: 'TalentsSearchPaginator', custom_paginator_info: { __typename?: 'customPaginatorInfo', total: number } } | undefined, totalTalents?: { __typename?: 'TalentsSearchPaginator', custom_paginator_info: { __typename?: 'customPaginatorInfo', total: number } } | undefined, staticTalents?: { __typename?: 'TalentsSearchPaginator', custom_paginator_info: { __typename?: 'customPaginatorInfo', total: number } } | undefined, jobs: { __typename?: 'JobPaginator', data: Array<{ __typename?: 'Job', id: string, name: string, posted_at?: any | undefined, matches_with_application_count: number, matches?: Array<{ __typename?: 'JobMatch', id: string, stage?: JobMatchStageEnum | undefined } | undefined> | undefined }> }, generalAnalytics?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined } | undefined> | undefined, tagsAnalytics?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined } | undefined> | undefined, countryAnalytics?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined, children?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined } | undefined> | undefined } | undefined> | undefined, categoryAnalytics?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined } | undefined> | undefined, marketingSourceAnalytics?: Array<{ __typename?: 'DashboardAnalyticsItem', key?: string | undefined, value?: number | undefined, slug?: string | undefined } | undefined> | undefined, lastTalents?: Array<{ __typename?: 'Talent', id: string, location?: string | undefined, rate?: number | undefined, currency?: CurrencyEnum | undefined, is_invitation_accepted?: boolean | undefined, recent_position_title?: string | undefined, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined> | undefined };

export type GetTalentsReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTalentsReportQuery = { __typename?: 'Query', sendJobsExportToCurrentCompanyUserEmail?: boolean | undefined };

export type ExpandJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  campaign_end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
}>;


export type ExpandJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: string } };

export type UpdateJobFinderFeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  finders_fee?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateJobFinderFeeMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: string } };

export type GetJobMatchersApplicationsQueryVariables = Exact<{
  job_id: Scalars['ID']['input'];
  status?: InputMaybe<JobMatcherApplicationStatusEnum>;
}>;


export type GetJobMatchersApplicationsQuery = { __typename?: 'Query', jobMatcherApplications?: Array<{ __typename?: 'JobMatcherApplication', id: string, status: JobMatcherApplicationStatusEnum, job: { __typename?: 'Job', id: string }, matcher: { __typename?: 'Talent', id: string, address?: string | undefined, location?: string | undefined, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } } | undefined> | undefined, jobMatchers?: Array<{ __typename?: 'JobMatcher', job: { __typename?: 'Job', id: string }, talent: { __typename?: 'Talent', id: string, stream_chat_id?: string | undefined, address?: string | undefined, location?: string | undefined, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } } | undefined> | undefined };

export type ApproveJobMacherApplicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveJobMacherApplicationMutation = { __typename?: 'Mutation', approveJobMatcherApplication?: { __typename?: 'JobMatcherApplication', id: string } | undefined };

export type RejectJobMacherApplicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RejectJobMacherApplicationMutation = { __typename?: 'Mutation', rejectJobMatcherApplication?: { __typename?: 'JobMatcherApplication', id: string } | undefined };

export type RemoveJobMatcherFromJobMutationVariables = Exact<{
  matcher_id: Scalars['ID']['input'];
  job_id: Scalars['ID']['input'];
}>;


export type RemoveJobMatcherFromJobMutation = { __typename?: 'Mutation', removeJobMatcherFromJob?: boolean | undefined };

export type ChangeJobMatchStageMutationVariables = Exact<{
  job_match_id: Scalars['ID']['input'];
  new_stage: JobMatchStageEnum;
  declination_reason?: InputMaybe<JobMatchDeclinationReasonsUsEnum>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeJobMatchStageMutation = { __typename?: 'Mutation', changeJobMatchStage?: boolean | undefined };

export type CreateCompanyAccountAccessRequestMutationVariables = Exact<{
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  email: Scalars['Email']['input'];
  company_id?: InputMaybe<Scalars['ID']['input']>;
  new_company_name?: InputMaybe<Scalars['String']['input']>;
  referral_key?: InputMaybe<Scalars['String']['input']>;
  recruiter_employment_type?: InputMaybe<CompanyUserRecruiterEmploymentTypeEnum>;
}>;


export type CreateCompanyAccountAccessRequestMutation = { __typename?: 'Mutation', createCompanyAccountAccessRequest?: boolean | undefined };

export type GetPendingTalentsQueryVariables = Exact<{
  source_type?: InputMaybe<SourceTypeEnum>;
  is_verification_required?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  connection_with_company_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPendingTalentsQuery = { __typename?: 'Query', talentsSearch?: { __typename?: 'TalentsSearchPaginator', custom_paginator_info: { __typename?: 'customPaginatorInfo', current_page: number, last_page: number, per_page: number, total: number }, data: Array<{ __typename?: 'TalentSearchResult', highlights?: Array<{ __typename?: 'TalentSearchHighlight', source?: string | undefined, text?: string | undefined }> | undefined, talent?: { __typename?: 'Talent', currency?: CurrencyEnum | undefined, id: string, reminded_at?: any | undefined, created_at?: any | undefined, is_invitation_accepted?: boolean | undefined, is_verification_required?: boolean | undefined, address?: string | undefined, rate?: number | undefined, recent_position_title?: string | undefined, available_now?: boolean | undefined, location?: string | undefined, stream_chat_id?: string | undefined, is_ot_pool?: boolean | undefined, company_pool_connections?: Array<{ __typename?: 'TalentCompanyPoolConnection', status?: TalentCompanyPoolingStatusEnum | undefined, initiator?: TalentCompanyPoolingInitiatorEnum | undefined, cancel_initiator?: TalentCompanyPoolingInitiatorEnum | undefined, company?: { __typename?: 'Company', id: string, name: string } | undefined } | undefined> | undefined, subcategories: Array<{ __typename?: 'Subcategory', id: string, name: string } | undefined>, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, job_applications?: Array<{ __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', id: string, name: string } } | undefined> | undefined, email_abac: { __typename?: 'ABACString', value?: string | undefined }, source?: { __typename?: 'TalentSource', id: string } | undefined, avatar?: { __typename?: 'Avatar', avatar: string } | undefined, talent_data?: { __typename?: 'TalentData', phone?: string | undefined } | undefined } | undefined }> } | undefined };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag?: boolean | undefined };

export type CreateTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag?: { __typename?: 'Tag', id: string, name: string } | undefined };

export type EditTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type EditTagMutation = { __typename?: 'Mutation', editTag?: { __typename?: 'Tag', id: string, name: string } | undefined };

export type GetLeavePageInfoQueryVariables = Exact<{
  delete_key: Scalars['String']['input'];
}>;


export type GetLeavePageInfoQuery = { __typename?: 'Query', selfDeletePageInfo?: { __typename?: 'selfDeletePageInfo', invited_by_full_name?: string | undefined } | undefined };

export type RestoreAccountMutationVariables = Exact<{
  delete_key: Scalars['String']['input'];
}>;


export type RestoreAccountMutation = { __typename?: 'Mutation', restoreDeletedAccountByDeleteKey?: { __typename?: 'restoreDeletedAccountInfo', link_to_set_password_page?: string | undefined } | undefined };

export type DeleteAccountMutationVariables = Exact<{
  delete_key: Scalars['String']['input'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', selfDeleteAccount?: boolean | undefined };

export type GetNotificationsPageDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  is_important?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetNotificationsPageDataQuery = { __typename?: 'Query', currentUserUnreadNotificationsCount?: number | undefined, importantNotificationsCount: { __typename?: 'NotificationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } }, unreadImportantNotificationsCount: { __typename?: 'NotificationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } }, allNotifications: { __typename?: 'NotificationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined, hasMorePages: boolean, lastItem?: number | undefined, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Notification', id: string, is_important: boolean, recipient_type: NotificationRecipientTypeEnum, recipient_id: string, title?: string | undefined, related_job_id?: string | undefined, is_read: boolean, created_at: any, buttons?: Array<{ __typename?: 'NotificationButton', text: string, action: { __typename?: 'NotificationActionRedirect', target_route_type?: RedirectTargetRouteTypeEnum | undefined, target_route_id: string, type?: NotificationActionTypeEnum | undefined } } | undefined> | undefined, reply_to?: { __typename?: 'User', id: string, stream_chat_id?: string | undefined, first_name?: string | undefined, last_name?: string | undefined, position?: string | undefined, company?: { __typename?: 'UserCompany', id: string, name: string, logo?: string | undefined } | undefined, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined, message: { __typename?: 'NotificationMessage', template?: string | undefined, template_actions?: Array<{ __typename?: 'NotificationTemplateAction', key?: string | undefined, text?: string | undefined, action?: { __typename?: 'NotificationActionRedirect', target_route_type?: RedirectTargetRouteTypeEnum | undefined, target_route_id: string, type?: NotificationActionTypeEnum | undefined } | undefined } | undefined> | undefined } }> } };

export type SetTagsToTalentMutationVariables = Exact<{
  tags_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  talent_id: Scalars['ID']['input'];
}>;


export type SetTagsToTalentMutation = { __typename?: 'Mutation', setTagsToTalent?: boolean | undefined };

export type CreateJobMatcherApplicationMutationVariables = Exact<{
  job_id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateJobMatcherApplicationMutation = { __typename?: 'Mutation', createJobMatcherApplication?: { __typename?: 'JobMatcherApplication', id: string } | undefined };

export type GetCompaniesScreenDataQueryVariables = Exact<{
  pooling_type?: InputMaybe<CompanyPoolingTypeEnum>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCompaniesScreenDataQuery = { __typename?: 'Query', poolingCompanies: { __typename?: 'CompanyPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined, lastItem?: number | undefined, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Company', id: string, name: string, about?: string | undefined, country?: string | undefined, size?: string | undefined, type_of_activity?: string | undefined, logo?: { __typename?: 'CompanyLogo', url: string } | undefined }> } };

export type InviteCompanyToOpentalentMutationVariables = Exact<{
  company_name: Scalars['String']['input'];
  contact_person: Scalars['String']['input'];
  company_email: Scalars['String']['input'];
}>;


export type InviteCompanyToOpentalentMutation = { __typename?: 'Mutation', inviteCompanyToOpentalent?: boolean | undefined };

export type GetCompanyViewScreenDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCompanyViewScreenDataQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name: string, about?: string | undefined, country?: string | undefined, size?: string | undefined, type_of_activity?: string | undefined, address?: string | undefined, website?: string | undefined, logo?: { __typename?: 'CompanyLogo', url: string } | undefined } | undefined, talentsSearch?: { __typename?: 'TalentsSearchPaginator', custom_paginator_info: { __typename?: 'customPaginatorInfo', total: number }, data: Array<{ __typename?: 'TalentSearchResult', talent?: { __typename?: 'Talent', avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined }> } | undefined, jobs: { __typename?: 'JobPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } } };

export type ExportTalentDataByEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportTalentDataByEmailMutation = { __typename?: 'Mutation', exportTalentDataByEmail?: boolean | undefined };

export type GetFeaturedTagsForCompanyQueryVariables = Exact<{
  company_id: Scalars['ID']['input'];
}>;


export type GetFeaturedTagsForCompanyQuery = { __typename?: 'Query', featuredTagsByCompany?: Array<{ __typename?: 'Tag', id: string, name: string } | undefined> | undefined, company?: { __typename?: 'Company', name: string, id: string, slug?: string | undefined, region?: RegionEnum | undefined, primary_branding_color?: string | undefined, secondary_branding_color?: string | undefined, logo?: { __typename?: 'CompanyLogo', url: string } | undefined, onboarding_countries?: Array<{ __typename?: 'Country', id: string, name: string }> | undefined } | undefined };

export type GetCompanyBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetCompanyBySlugQuery = { __typename?: 'Query', companyBySlug?: { __typename?: 'Company', name: string, id: string, slug?: string | undefined, region?: RegionEnum | undefined, primary_branding_color?: string | undefined, secondary_branding_color?: string | undefined, logo?: { __typename?: 'CompanyLogo', url: string } | undefined, onboarding_countries?: Array<{ __typename?: 'Country', id: string, name: string }> | undefined } | undefined };

export type ExtractDataFromCvMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  device_id: Scalars['String']['input'];
}>;


export type ExtractDataFromCvMutation = { __typename?: 'Mutation', extractDataFromCv?: { __typename?: 'TempDataItem', email?: any | undefined } | undefined };

export type GetIndustiesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndustiesListQuery = { __typename?: 'Query', getIndustriesList?: Array<{ __typename?: 'Industry', id: string, name: string } | undefined> | undefined };

export type GetJobRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobRolesQuery = { __typename?: 'Query', getJobRoles?: Array<{ __typename?: 'JobRole', id: string, name: string } | undefined> | undefined };

export type CreateJobRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateJobRoleMutation = { __typename?: 'Mutation', createJobRole?: { __typename?: 'JobRole', id: string, name: string } | undefined };

export type GetOnboardingV2TmpDataQueryVariables = Exact<{
  email?: InputMaybe<Scalars['Email']['input']>;
  device_id: Scalars['String']['input'];
}>;


export type GetOnboardingV2TmpDataQuery = { __typename?: 'Query', getTempDataItem: { __typename?: 'TempDataItemSearchResult', success: boolean, result?: { __typename?: 'TempDataItem', email?: any | undefined, device_id: string, data?: string | undefined, cv_companies_extraction?: Array<{ __typename?: 'CvCompanyExtraction', id?: string | undefined, name?: string | undefined } | undefined> | undefined, cv_data_extraction?: { __typename?: 'CvDataExtraction', city?: string | undefined, email?: string | undefined, first_name?: string | undefined, last_name?: string | undefined, phone?: string | undefined, state?: string | undefined, zip?: string | undefined, about?: string | undefined } | undefined, cv_skills_extraction?: Array<{ __typename?: 'Skill', id: string, name: string, skill_type: SkillTypeEnum } | undefined> | undefined } | undefined } };

export type GetCompanyLogoQueryVariables = Exact<{
  company_id: Scalars['ID']['input'];
}>;


export type GetCompanyLogoQuery = { __typename?: 'Query', company?: { __typename?: 'Company', name: string, id: string, region?: RegionEnum | undefined, primary_branding_color?: string | undefined, secondary_branding_color?: string | undefined, logo?: { __typename?: 'CompanyLogo', url: string } | undefined } | undefined };

export type GetCountiresListQueryVariables = Exact<{
  is_europe?: InputMaybe<Scalars['Boolean']['input']>;
  is_us?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCountiresListQuery = { __typename?: 'Query', getCountriesList?: Array<{ __typename?: 'Country', id: string, name: string, is_europe: boolean } | undefined> | undefined };

export type MutateCancelCurrentTalentSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type MutateCancelCurrentTalentSubscriptionMutation = { __typename?: 'Mutation', cancelCurrentTalentSubscription?: { __typename?: 'StripeSubscription', current_period_end?: any | undefined } | undefined };

export type CreateReportMutationVariables = Exact<{
  reported_talent_id: Scalars['ID']['input'];
  reason: ReportReasonsEnum;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport?: { __typename?: 'Report', id: string, reason: ReportReasonsEnum, comment?: string | undefined, created_at: any } | undefined };

export type GetTalentSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTalentSourcesQuery = { __typename?: 'Query', talentSources?: Array<{ __typename?: 'TalentSource', id: string, name: string, created_at?: any | undefined, updated_at?: any | undefined } | undefined> | undefined };

export type ChooseJobServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type ChooseJobServiceQuery = { __typename?: 'Query', commonAppInfo?: { __typename?: 'CommonAppInfo', total_ot_freelancers_count: number, total_ot_approved_freelancers_count: number, total_ot_recruiters_count: number } | undefined, talentsSearch?: { __typename?: 'TalentsSearchPaginator', custom_paginator_info: { __typename?: 'customPaginatorInfo', total: number } } | undefined };

export type GetTalentOnboardingCountriesForCompanyQueryVariables = Exact<{
  company_id: Scalars['ID']['input'];
}>;


export type GetTalentOnboardingCountriesForCompanyQuery = { __typename?: 'Query', getTalentOnboardingCountriesForCompany?: Array<{ __typename?: 'Country', id: string, name: string } | undefined> | undefined };

export type GetTmpDataQueryVariables = Exact<{
  email?: InputMaybe<Scalars['Email']['input']>;
  device_id: Scalars['String']['input'];
}>;


export type GetTmpDataQuery = { __typename?: 'Query', getTempDataItem: { __typename?: 'TempDataItemSearchResult', success: boolean, result?: { __typename?: 'TempDataItem', email?: any | undefined, device_id: string, data?: string | undefined } | undefined } };

export type SetTmpDataMutationVariables = Exact<{
  email?: InputMaybe<Scalars['Email']['input']>;
  device_id: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetTmpDataMutation = { __typename?: 'Mutation', setTempDataItem?: boolean | undefined };

export type UploadFileMutationVariables = Exact<{
  file_type: FileTypeEnum;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  file: Scalars['Upload']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile?: { __typename?: 'File', hash: string, title: string } | undefined };

export type CancelCurrentCompanySubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelCurrentCompanySubscriptionMutation = { __typename?: 'Mutation', cancelCurrentCompanyUserCompanySubscription?: { __typename?: 'StripeSubscription', start_date?: any | undefined, current_period_end?: any | undefined, cancel_at_period_end?: boolean | undefined } | undefined };

export type CheckCompanyUserExistsByEmailQueryVariables = Exact<{
  email: Scalars['Email']['input'];
}>;


export type CheckCompanyUserExistsByEmailQuery = { __typename?: 'Query', checkCompanyUserExistsByEmail: boolean };

export type CreateAnnouncementMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  need_response: Scalars['Boolean']['input'];
  talents_ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  send_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_important: Scalars['Boolean']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement: boolean };

export type CreateCompanyForUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  type_of_activity?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  primary_company_user_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateCompanyForUserMutation = { __typename?: 'Mutation', createCompanyForUser?: { __typename?: 'Company', id: string } | undefined };

export type CreateCompanyUserMutationVariables = Exact<{
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  email: Scalars['Email']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_type?: InputMaybe<CompanyUserOnboardingTypeEnum>;
  referral_key?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCompanyUserMutation = { __typename?: 'Mutation', createCompanyUserProfile?: { __typename?: 'User', id: string } | undefined };

export type CurrentCompanySubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCompanySubscriptionQuery = { __typename?: 'Query', currentCompanyUserCompanySubscription?: { __typename?: 'StripeSubscription', start_date?: any | undefined, current_period_end?: any | undefined, cancel_at_period_end?: boolean | undefined } | undefined };

export type GetCurrentUserCompanyTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserCompanyTagsQuery = { __typename?: 'Query', currentUserCompanyTags?: Array<{ __typename?: 'Tag', name: string, id: string } | undefined> | undefined };

export type GetPaymentLinkForCompanyQueryVariables = Exact<{
  primary_user_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPaymentLinkForCompanyQuery = { __typename?: 'Query', getPaymentLinkForCompany?: string | undefined };

export type InviteCompanyUserMutationVariables = Exact<{
  email: Scalars['Email']['input'];
}>;


export type InviteCompanyUserMutation = { __typename?: 'Mutation', inviteCompanyUser?: boolean | undefined };

export type RenewCurrentCompanySubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type RenewCurrentCompanySubscriptionMutation = { __typename?: 'Mutation', renewCurrentCompanyUserCompanySubscription?: { __typename?: 'StripeSubscription', start_date?: any | undefined, current_period_end?: any | undefined, cancel_at_period_end?: boolean | undefined } | undefined };

export type UpdateCompanyUserEmailMutationVariables = Exact<{
  email: Scalars['Email']['input'];
}>;


export type UpdateCompanyUserEmailMutation = { __typename?: 'Mutation', updateCompanyUserEmail?: boolean | undefined };

export type UpdateCompanyUserMutationVariables = Exact<{
  company_user_id: Scalars['ID']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCompanyUserMutation = { __typename?: 'Mutation', updateCompanyUserProfile?: { __typename?: 'User', id: string } | undefined };

export type CreateTalentInvitationMutationVariables = Exact<{
  inviter_talent_id?: InputMaybe<Scalars['ID']['input']>;
  inviter_company_user_id?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  tags_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CreateTalentInvitationMutation = { __typename?: 'Mutation', createInvitation?: { __typename?: 'TalentInvitation', id: string, uid: string, is_accepted: boolean, email?: string | undefined, first_name?: string | undefined, last_name?: string | undefined, created_at: any, talent_inviter?: { __typename?: 'Talent', id: string, is_invitation_accepted?: boolean | undefined, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, email_abac: { __typename?: 'ABACString', value?: string | undefined }, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined, company_user_inviter?: { __typename?: 'User', id: string, first_name?: string | undefined, last_name?: string | undefined, email: any } | undefined } | undefined };

export type ResendInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation?: boolean | undefined };

export type CancelInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelInvitationMutation = { __typename?: 'Mutation', cancelInvitation?: boolean | undefined };

export type CurrentTalentInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentTalentInvitationsQuery = { __typename?: 'Query', currentTalentInvitations?: Array<{ __typename?: 'TalentInvitation', id: string, uid: string, email?: string | undefined, is_accepted: boolean, first_name?: string | undefined, last_name?: string | undefined, created_at: any, talent?: { __typename?: 'Talent', id: string, is_invitation_accepted?: boolean | undefined, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, email_abac: { __typename?: 'ABACString', value?: string | undefined }, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined, talent_inviter?: { __typename?: 'Talent', id: string, is_invitation_accepted?: boolean | undefined, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, email_abac: { __typename?: 'ABACString', value?: string | undefined }, avatar?: { __typename?: 'Avatar', avatar: string } | undefined } | undefined, company_user_inviter?: { __typename?: 'User', id: string, first_name?: string | undefined, last_name?: string | undefined, email: any } | undefined } | undefined> | undefined };

export type ApplyForJobMutationVariables = Exact<{
  job_application_data: JobApplicationInput;
}>;


export type ApplyForJobMutation = { __typename?: 'Mutation', applyForJob: boolean };

export type ChangeSuggestingStatusForJobMatchMutationVariables = Exact<{
  job_match_id: Scalars['ID']['input'];
  new_suggesting_stage: SuggestingStageEnum;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeSuggestingStatusForJobMatchMutation = { __typename?: 'Mutation', changeSuggestingStatusForJobMatch?: boolean | undefined };

export type CreateJobSuggestionMutationVariables = Exact<{
  job_id: Scalars['ID']['input'];
  first_name: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  cv_attachment?: InputMaybe<Scalars['String']['input']>;
  motivation_letter_attachment?: InputMaybe<Scalars['String']['input']>;
  screening_questionnaire_attachment?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateJobSuggestionMutation = { __typename?: 'Mutation', createJobSuggestion: boolean };

export type CreateNewJobMutationVariables = Exact<{
  name: Scalars['String']['input'];
  category_id?: InputMaybe<Scalars['ID']['input']>;
  subcategory_id?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  pitch?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  rate_min?: InputMaybe<Scalars['Float']['input']>;
  rate_max?: InputMaybe<Scalars['Float']['input']>;
  is_rate_negotiable?: InputMaybe<Scalars['Boolean']['input']>;
  salary_min?: InputMaybe<Scalars['Float']['input']>;
  salary_max?: InputMaybe<Scalars['Float']['input']>;
  is_salary_negotiable?: InputMaybe<Scalars['Boolean']['input']>;
  max_project_budget?: InputMaybe<Scalars['Float']['input']>;
  finders_fee?: InputMaybe<Scalars['Float']['input']>;
  campaign_owner_id: Scalars['ID']['input'];
  campaign_start_date: Scalars['DateTimeUtc']['input'];
  campaign_end_date: Scalars['DateTimeUtc']['input'];
  campaign_talent_pool?: InputMaybe<Array<InputMaybe<SourceTypeEnum>> | InputMaybe<SourceTypeEnum>>;
  permanent_capacity_type?: InputMaybe<PermanentJobCapacityTypeEnum>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  skills_boolean_filter?: InputMaybe<TalentsBooleanSkillsFilterInput>;
  solutions_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  hard_skills_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  hours_per_week?: InputMaybe<Scalars['Int']['input']>;
  location_type?: InputMaybe<JobLocationTypeEnum>;
  type?: InputMaybe<JobTypeEnum>;
  location?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  is_remote_an_option?: InputMaybe<Scalars['Boolean']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  office_hours_per_month?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreateNewJobMutation = { __typename?: 'Mutation', createJob: string };

export type GetPotentialTalentsCountQueryVariables = Exact<{
  type: JobTypeEnum;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  subcategory_id?: InputMaybe<Scalars['ID']['input']>;
  start_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  rate_min?: InputMaybe<Scalars['Float']['input']>;
  rate_max?: InputMaybe<Scalars['Float']['input']>;
  salary_min?: InputMaybe<Scalars['Float']['input']>;
  salary_max?: InputMaybe<Scalars['Float']['input']>;
  campaign_start_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  campaign_end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  campaign_talent_pool?: InputMaybe<Array<InputMaybe<SourceTypeEnum>> | InputMaybe<SourceTypeEnum>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  skills_boolean_filter?: InputMaybe<TalentsBooleanSkillsFilterInput>;
  solutions_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  hard_skills_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  hours_per_week?: InputMaybe<Scalars['Int']['input']>;
  location_type?: InputMaybe<JobLocationTypeEnum>;
  is_remote_an_option?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  office_hours_per_month?: InputMaybe<Scalars['Float']['input']>;
  campaign_owner_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPotentialTalentsCountQuery = { __typename?: 'Query', potentialTalentsForJobCount: number };

export type MarkNewJobMatchesAsReadMutationVariables = Exact<{
  job_matches_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type MarkNewJobMatchesAsReadMutation = { __typename?: 'Mutation', markNewJobMatchesAsRead?: boolean | undefined };

export type SubmitJobToBroadbeanMutationVariables = Exact<{
  job_id: Scalars['ID']['input'];
}>;


export type SubmitJobToBroadbeanMutation = { __typename?: 'Mutation', submitJobToBroadbean?: { __typename?: 'BroadbeanJobSubmission', broadbean_url?: string | undefined } | undefined };

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  service_type?: InputMaybe<JobServiceTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  pitch?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  end_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  rate_min?: InputMaybe<Scalars['Float']['input']>;
  rate_max?: InputMaybe<Scalars['Float']['input']>;
  is_rate_negotiable?: InputMaybe<Scalars['Boolean']['input']>;
  salary_min?: InputMaybe<Scalars['Float']['input']>;
  salary_max?: InputMaybe<Scalars['Float']['input']>;
  is_salary_negotiable?: InputMaybe<Scalars['Boolean']['input']>;
  max_project_budget?: InputMaybe<Scalars['Float']['input']>;
  finders_fee?: InputMaybe<Scalars['Float']['input']>;
  campaign_owner_id?: InputMaybe<Scalars['ID']['input']>;
  campaign_start_date: Scalars['DateTimeUtc']['input'];
  campaign_end_date: Scalars['DateTimeUtc']['input'];
  campaign_talent_pool?: InputMaybe<Array<InputMaybe<SourceTypeEnum>> | InputMaybe<SourceTypeEnum>>;
  skills_boolean_filter?: InputMaybe<TalentsBooleanSkillsFilterInput>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  solutions_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  hard_skills_required?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  hours_per_week?: InputMaybe<Scalars['Int']['input']>;
  location_type?: InputMaybe<JobLocationTypeEnum>;
  type?: InputMaybe<JobTypeEnum>;
  location?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  is_remote_an_option?: InputMaybe<Scalars['Boolean']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  office_hours_per_month?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: string } };

export type GetCompaniesLandingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesLandingDataQuery = { __typename?: 'Query', commonAppInfo?: { __typename?: 'CommonAppInfo', total_ot_freelancers_count: number, total_ot_freelancers_countries_count: number, total_unique_skills_count: number, total_unique_companies_count: number, total_ot_recruiters_count: number, total_ot_approved_freelancers_count: number } | undefined, talentsCountByCategories?: Array<{ __typename?: 'talentsCountItem', name: string, slug: string, talents_count: number } | undefined> | undefined };

export type SearchSkillsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  skill_type: Array<InputMaybe<SkillTypeEnum>> | InputMaybe<SkillTypeEnum>;
}>;


export type SearchSkillsQuery = { __typename?: 'Query', skillSearch: Array<{ __typename?: 'Skill', id: string, skill_type: SkillTypeEnum, name: string, slug: string, created_at?: any | undefined, updated_at?: any | undefined }> };

export type CreateSmsMutationVariables = Exact<{
  company_id: Scalars['ID']['input'];
  talent_id: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSmsMutation = { __typename?: 'Mutation', createSMS?: { __typename?: 'SMS', id: string, content?: string | undefined, created_at: any, delivered_at?: any | undefined, status: SmsStatusEnum, sender_type: SenderTypeEnum, error_message?: string | undefined, talent_phone_number: string, vonage_message_id?: string | undefined, vonage_status?: number | undefined, user_id?: string | undefined, talent_id: string, company_id: string } | undefined };

export type GetAllSmsConversationsQueryVariables = Exact<{
  company_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SmsSortEnum>;
  direction?: InputMaybe<SmsSortDirectionEnum>;
}>;


export type GetAllSmsConversationsQuery = { __typename?: 'Query', getAllSMSConversations: { __typename?: 'SMSConversationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined, hasMorePages: boolean, lastItem?: number | undefined, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'SMSConversation', talent: { __typename?: 'Talent', id: string, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, avatar?: { __typename?: 'Avatar', avatar: string } | undefined, talent_data?: { __typename?: 'TalentData', phone?: string | undefined } | undefined }, last_sms: { __typename?: 'SMS', id: string, content?: string | undefined, created_at: any, delivered_at?: any | undefined, status: SmsStatusEnum, sender_type: SenderTypeEnum, error_message?: string | undefined, talent_phone_number: string, company_id: string, talent_id: string, user_id?: string | undefined } }> } };

export type GetTalentSmsConversationQueryVariables = Exact<{
  company_id: Scalars['ID']['input'];
  talent_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SmsSortEnum>;
  direction?: InputMaybe<SmsSortDirectionEnum>;
}>;


export type GetTalentSmsConversationQuery = { __typename?: 'Query', getTalentSMSConversation: { __typename?: 'SMSPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | undefined, hasMorePages: boolean, lastItem?: number | undefined, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'SMS', id: string, content?: string | undefined, created_at: any, delivered_at?: any | undefined, status: SmsStatusEnum, sender_type: SenderTypeEnum, error_message?: string | undefined, talent_phone_number: string, vonage_message_id?: string | undefined, vonage_status?: number | undefined, user_id?: string | undefined, talent_id: string, company_id: string }> } };

export type CancelCurrentTalentSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelCurrentTalentSubscriptionMutation = { __typename?: 'Mutation', cancelCurrentTalentSubscription?: { __typename?: 'StripeSubscription', start_date?: any | undefined, current_period_end?: any | undefined, cancel_at_period_end?: boolean | undefined } | undefined };

export type CheckTalentExistsByEmailQueryVariables = Exact<{
  talent_email: Scalars['Email']['input'];
}>;


export type CheckTalentExistsByEmailQuery = { __typename?: 'Query', checkTalentExistsByEmail: boolean };

export type CreateTalentProfileMutationVariables = Exact<{
  email: Scalars['Email']['input'];
  general_info: TalentGeneralInfoInput;
  tags_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  is_ot_pool?: InputMaybe<Scalars['Boolean']['input']>;
  job_application_data?: InputMaybe<JobApplicationInput>;
}>;


export type CreateTalentProfileMutation = { __typename?: 'Mutation', createTalentProfile?: string | undefined };

export type CurrentTalentSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentTalentSubscriptionQuery = { __typename?: 'Query', currentTalentSubscription?: { __typename?: 'StripeSubscription', start_date?: any | undefined, current_period_end?: any | undefined, cancel_at_period_end?: boolean | undefined } | undefined };

export type GetPaymentLinkForTalentQueryVariables = Exact<{
  talent_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPaymentLinkForTalentQuery = { __typename?: 'Query', getPaymentLinkForTalent?: string | undefined };

export type GetPaymentLinkForMatcherQueryVariables = Exact<{
  talent_id?: InputMaybe<Scalars['ID']['input']>;
  is_hr_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPaymentLinkForMatcherQuery = { __typename?: 'Query', getPaymentLinkForMatcher?: string | undefined };

export type GetPaymentLinkForRecruiterQueryVariables = Exact<{
  talent_id?: InputMaybe<Scalars['ID']['input']>;
  is_hr_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPaymentLinkForRecruiterQuery = { __typename?: 'Query', getPaymentLinkForRecruiter?: string | undefined };

export type GetTypeformPaymentLinkCodeForMatcherQueryVariables = Exact<{
  talent_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetTypeformPaymentLinkCodeForMatcherQuery = { __typename?: 'Query', getTypeformPaymentLinkCodeForMatcher?: string | undefined };

export type SubmitTalentAsFreeMatcherMutationVariables = Exact<{
  talent_id: Scalars['ID']['input'];
}>;


export type SubmitTalentAsFreeMatcherMutation = { __typename?: 'Mutation', submitTalentAsFreeMatcher?: boolean | undefined };

export type NotifyTalentAboutJobMatchMutationVariables = Exact<{
  match_id: Scalars['ID']['input'];
}>;


export type NotifyTalentAboutJobMatchMutation = { __typename?: 'Mutation', notifyTalentAboutJobMatch?: boolean | undefined };

export type RenewCurrentTalentSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type RenewCurrentTalentSubscriptionMutation = { __typename?: 'Mutation', renewCurrentTalentSubscription?: { __typename?: 'StripeSubscription', start_date?: any | undefined, current_period_end?: any | undefined, cancel_at_period_end?: boolean | undefined } | undefined };

export type SearchTalentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  skills_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  max_rate?: InputMaybe<Scalars['Float']['input']>;
  min_rate?: InputMaybe<Scalars['Float']['input']>;
  source_type?: InputMaybe<SourceTypeEnum>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_verification_required?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  available_now?: InputMaybe<Scalars['Boolean']['input']>;
  skills_boolean_filter?: InputMaybe<TalentsBooleanSkillsFilterInput>;
}>;


export type SearchTalentsQuery = { __typename?: 'Query', talentsSearch?: { __typename?: 'TalentsSearchPaginator', custom_paginator_info: { __typename?: 'customPaginatorInfo', current_page: number, last_page: number, per_page: number, total: number }, data: Array<{ __typename?: 'TalentSearchResult', highlights?: Array<{ __typename?: 'TalentSearchHighlight', source?: string | undefined, text?: string | undefined }> | undefined, talent?: { __typename?: 'Talent', id: string, reminded_at?: any | undefined, created_at?: any | undefined, is_invitation_accepted?: boolean | undefined, is_verification_required?: boolean | undefined, address?: string | undefined, rate?: number | undefined, currency?: CurrencyEnum | undefined, recent_position_title?: string | undefined, available_now?: boolean | undefined, location?: string | undefined, is_ot_pool?: boolean | undefined, first_name_abac: { __typename?: 'ABACString', value?: string | undefined }, last_name_abac: { __typename?: 'ABACString', value?: string | undefined }, email_abac: { __typename?: 'ABACString', value?: string | undefined }, source?: { __typename?: 'TalentSource', id: string } | undefined, avatar?: { __typename?: 'Avatar', avatar: string } | undefined, talent_data?: { __typename?: 'TalentData', phone?: string | undefined } | undefined } | undefined }> } | undefined };

export type SearchTalentsToSendMessageQueryVariables = Exact<{
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  source_type?: InputMaybe<SourceTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  tags_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  zip_codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  connection_with_company_id?: InputMaybe<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_static?: InputMaybe<Scalars['Boolean']['input']>;
  is_active_or_static?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchTalentsToSendMessageQuery = { __typename?: 'Query', talentsSearch?: { __typename?: 'TalentsSearchPaginator', data: Array<{ __typename?: 'TalentSearchResult', talent?: { __typename?: 'Talent', id: string } | undefined }> } | undefined };

export type SelfDeleteTalentProfilePermanentlyMutationVariables = Exact<{ [key: string]: never; }>;


export type SelfDeleteTalentProfilePermanentlyMutation = { __typename?: 'Mutation', selfDeleteTalentProfilePermanently?: boolean | undefined };

export type TalentCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TalentCategoriesQuery = { __typename?: 'Query', talentCategories?: Array<{ __typename?: 'TalentCategory', id: string, name: string, slug: string, created_at?: any | undefined, updated_at?: any | undefined, subcategories?: Array<{ __typename?: 'Subcategory', id: string, name: string }> | undefined } | undefined> | undefined };

export type TalentsCountByCategoriesQueryVariables = Exact<{
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type TalentsCountByCategoriesQuery = { __typename?: 'Query', talentsCountByCategories?: Array<{ __typename?: 'talentsCountItem', talents_count: number, name: string, slug: string } | undefined> | undefined };

export type TalentsCountBySubcategoriesQueryVariables = Exact<{
  subcategory_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type TalentsCountBySubcategoriesQuery = { __typename?: 'Query', talentsCountBySubcategories?: Array<{ __typename?: 'talentsCountItem', talents_count: number, name: string, slug: string } | undefined> | undefined };

export type UpdateTalentEmailMutationVariables = Exact<{
  email: Scalars['Email']['input'];
}>;


export type UpdateTalentEmailMutation = { __typename?: 'Mutation', updateTalentEmail?: boolean | undefined };

export const NotificationsListMainFragmentDoc = gql`
    fragment NotificationsListMain on NotificationPaginator {
  paginatorInfo {
    count
    currentPage
    firstItem
    hasMorePages
    lastItem
    lastPage
    perPage
    total
  }
  data {
    id
    is_important
    recipient_type
    recipient_id
    buttons {
      text
      action {
        type
        ... on NotificationActionRedirect {
          target_route_type
          target_route_id
        }
      }
    }
    title
    reply_to {
      id
      stream_chat_id
      first_name
      last_name
      position
      company {
        id
        name
        logo
      }
      avatar {
        avatar
      }
    }
    related_job_id
    is_read
    created_at
    message {
      template
      template_actions {
        key
        text
        action {
          type
          ... on NotificationActionRedirect {
            target_route_type
            target_route_id
          }
        }
      }
    }
  }
}
    `;
export const SubmissionStatusFieldsFragmentDoc = gql`
    fragment SubmissionStatusFields on FieldGlassCandidateIntroduction {
  submission_status
  error_message
  api_response
}
    `;
export const GetAtsRecordsDocument = gql`
    query GetATSRecords($talent_id: ID, $job_id: ID) {
  ATSRecords(talent_id: $talent_id, job_id: $job_id) {
    id
    type
    actor {
      first_name
      last_name
      avatar {
        avatar
      }
    }
    date
    __typename
    ... on ATSRecordComment {
      text
    }
    ... on ATSRecordJobMatchAction {
      job_match_action {
        id
        job_match_action_type
        job_match_type_before
        job_match_type_after
        job_match {
          job {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAtsRecordsQuery__
 *
 * To run a query within a React component, call `useGetAtsRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtsRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtsRecordsQuery({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *      job_id: // value for 'job_id'
 *   },
 * });
 */
export function useGetAtsRecordsQuery(baseOptions?: Apollo.QueryHookOptions<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>(GetAtsRecordsDocument, options);
      }
export function useGetAtsRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>(GetAtsRecordsDocument, options);
        }
// @ts-ignore
export function useGetAtsRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>;
export function useGetAtsRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtsRecordsQuery | undefined, GetAtsRecordsQueryVariables>;
export function useGetAtsRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>(GetAtsRecordsDocument, options);
        }
export type GetAtsRecordsQueryHookResult = ReturnType<typeof useGetAtsRecordsQuery>;
export type GetAtsRecordsLazyQueryHookResult = ReturnType<typeof useGetAtsRecordsLazyQuery>;
export type GetAtsRecordsSuspenseQueryHookResult = ReturnType<typeof useGetAtsRecordsSuspenseQuery>;
export type GetAtsRecordsQueryResult = Apollo.QueryResult<GetAtsRecordsQuery, GetAtsRecordsQueryVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications($first: Int = 20, $page: Int = 1, $is_read: Boolean, $is_important: Boolean) {
  currentUserUnreadNotificationsCount
  unreadImportantNotificationsCount: currentUserNotifications(
    is_important: true
    is_read: false
  ) {
    paginatorInfo {
      total
    }
  }
  currentUserNotifications(
    first: $first
    page: $page
    is_important: $is_important
    is_read: $is_read
  ) {
    ...NotificationsListMain
  }
}
    ${NotificationsListMainFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      is_read: // value for 'is_read'
 *      is_important: // value for 'is_important'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
// @ts-ignore
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery | undefined, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const ApplyCurrentTalentToCompanyPoolDocument = gql`
    mutation ApplyCurrentTalentToCompanyPool($company_id: ID!) {
  applyCurrentTalentToCompanyPool(company_id: $company_id)
}
    `;
export type ApplyCurrentTalentToCompanyPoolMutationFn = Apollo.MutationFunction<ApplyCurrentTalentToCompanyPoolMutation, ApplyCurrentTalentToCompanyPoolMutationVariables>;

/**
 * __useApplyCurrentTalentToCompanyPoolMutation__
 *
 * To run a mutation, you first call `useApplyCurrentTalentToCompanyPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCurrentTalentToCompanyPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCurrentTalentToCompanyPoolMutation, { data, loading, error }] = useApplyCurrentTalentToCompanyPoolMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useApplyCurrentTalentToCompanyPoolMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCurrentTalentToCompanyPoolMutation, ApplyCurrentTalentToCompanyPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCurrentTalentToCompanyPoolMutation, ApplyCurrentTalentToCompanyPoolMutationVariables>(ApplyCurrentTalentToCompanyPoolDocument, options);
      }
export type ApplyCurrentTalentToCompanyPoolMutationHookResult = ReturnType<typeof useApplyCurrentTalentToCompanyPoolMutation>;
export type ApplyCurrentTalentToCompanyPoolMutationResult = Apollo.MutationResult<ApplyCurrentTalentToCompanyPoolMutation>;
export type ApplyCurrentTalentToCompanyPoolMutationOptions = Apollo.BaseMutationOptions<ApplyCurrentTalentToCompanyPoolMutation, ApplyCurrentTalentToCompanyPoolMutationVariables>;
export const LeaveCurrentTalentFromCompanyPoolDocument = gql`
    mutation LeaveCurrentTalentFromCompanyPool($company_id: ID!) {
  leaveCurrentTalentFromCompanyPool(company_id: $company_id)
}
    `;
export type LeaveCurrentTalentFromCompanyPoolMutationFn = Apollo.MutationFunction<LeaveCurrentTalentFromCompanyPoolMutation, LeaveCurrentTalentFromCompanyPoolMutationVariables>;

/**
 * __useLeaveCurrentTalentFromCompanyPoolMutation__
 *
 * To run a mutation, you first call `useLeaveCurrentTalentFromCompanyPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCurrentTalentFromCompanyPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveCurrentTalentFromCompanyPoolMutation, { data, loading, error }] = useLeaveCurrentTalentFromCompanyPoolMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useLeaveCurrentTalentFromCompanyPoolMutation(baseOptions?: Apollo.MutationHookOptions<LeaveCurrentTalentFromCompanyPoolMutation, LeaveCurrentTalentFromCompanyPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveCurrentTalentFromCompanyPoolMutation, LeaveCurrentTalentFromCompanyPoolMutationVariables>(LeaveCurrentTalentFromCompanyPoolDocument, options);
      }
export type LeaveCurrentTalentFromCompanyPoolMutationHookResult = ReturnType<typeof useLeaveCurrentTalentFromCompanyPoolMutation>;
export type LeaveCurrentTalentFromCompanyPoolMutationResult = Apollo.MutationResult<LeaveCurrentTalentFromCompanyPoolMutation>;
export type LeaveCurrentTalentFromCompanyPoolMutationOptions = Apollo.BaseMutationOptions<LeaveCurrentTalentFromCompanyPoolMutation, LeaveCurrentTalentFromCompanyPoolMutationVariables>;
export const AcceptCompanyPoolInvitationDocument = gql`
    mutation AcceptCompanyPoolInvitation($company_id: ID!) {
  acceptCompanyPoolInvitation(company_id: $company_id)
}
    `;
export type AcceptCompanyPoolInvitationMutationFn = Apollo.MutationFunction<AcceptCompanyPoolInvitationMutation, AcceptCompanyPoolInvitationMutationVariables>;

/**
 * __useAcceptCompanyPoolInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptCompanyPoolInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCompanyPoolInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCompanyPoolInvitationMutation, { data, loading, error }] = useAcceptCompanyPoolInvitationMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useAcceptCompanyPoolInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCompanyPoolInvitationMutation, AcceptCompanyPoolInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCompanyPoolInvitationMutation, AcceptCompanyPoolInvitationMutationVariables>(AcceptCompanyPoolInvitationDocument, options);
      }
export type AcceptCompanyPoolInvitationMutationHookResult = ReturnType<typeof useAcceptCompanyPoolInvitationMutation>;
export type AcceptCompanyPoolInvitationMutationResult = Apollo.MutationResult<AcceptCompanyPoolInvitationMutation>;
export type AcceptCompanyPoolInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptCompanyPoolInvitationMutation, AcceptCompanyPoolInvitationMutationVariables>;
export const RejectCompanyPoolInvitationDocument = gql`
    mutation RejectCompanyPoolInvitation($company_id: ID!) {
  rejectCompanyPoolInvitation(company_id: $company_id)
}
    `;
export type RejectCompanyPoolInvitationMutationFn = Apollo.MutationFunction<RejectCompanyPoolInvitationMutation, RejectCompanyPoolInvitationMutationVariables>;

/**
 * __useRejectCompanyPoolInvitationMutation__
 *
 * To run a mutation, you first call `useRejectCompanyPoolInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCompanyPoolInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCompanyPoolInvitationMutation, { data, loading, error }] = useRejectCompanyPoolInvitationMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useRejectCompanyPoolInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RejectCompanyPoolInvitationMutation, RejectCompanyPoolInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectCompanyPoolInvitationMutation, RejectCompanyPoolInvitationMutationVariables>(RejectCompanyPoolInvitationDocument, options);
      }
export type RejectCompanyPoolInvitationMutationHookResult = ReturnType<typeof useRejectCompanyPoolInvitationMutation>;
export type RejectCompanyPoolInvitationMutationResult = Apollo.MutationResult<RejectCompanyPoolInvitationMutation>;
export type RejectCompanyPoolInvitationMutationOptions = Apollo.BaseMutationOptions<RejectCompanyPoolInvitationMutation, RejectCompanyPoolInvitationMutationVariables>;
export const InviteTalentToCompanyPoolDocument = gql`
    mutation InviteTalentToCompanyPool($talent_id: ID!) {
  inviteTalentToCompanyPool(talent_id: $talent_id)
}
    `;
export type InviteTalentToCompanyPoolMutationFn = Apollo.MutationFunction<InviteTalentToCompanyPoolMutation, InviteTalentToCompanyPoolMutationVariables>;

/**
 * __useInviteTalentToCompanyPoolMutation__
 *
 * To run a mutation, you first call `useInviteTalentToCompanyPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteTalentToCompanyPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteTalentToCompanyPoolMutation, { data, loading, error }] = useInviteTalentToCompanyPoolMutation({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *   },
 * });
 */
export function useInviteTalentToCompanyPoolMutation(baseOptions?: Apollo.MutationHookOptions<InviteTalentToCompanyPoolMutation, InviteTalentToCompanyPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteTalentToCompanyPoolMutation, InviteTalentToCompanyPoolMutationVariables>(InviteTalentToCompanyPoolDocument, options);
      }
export type InviteTalentToCompanyPoolMutationHookResult = ReturnType<typeof useInviteTalentToCompanyPoolMutation>;
export type InviteTalentToCompanyPoolMutationResult = Apollo.MutationResult<InviteTalentToCompanyPoolMutation>;
export type InviteTalentToCompanyPoolMutationOptions = Apollo.BaseMutationOptions<InviteTalentToCompanyPoolMutation, InviteTalentToCompanyPoolMutationVariables>;
export const RejectTalentCompanyPoolApplicationDocument = gql`
    mutation RejectTalentCompanyPoolApplication($talent_id: ID!, $message: String) {
  rejectTalentCompanyPoolApplication(talent_id: $talent_id, message: $message)
}
    `;
export type RejectTalentCompanyPoolApplicationMutationFn = Apollo.MutationFunction<RejectTalentCompanyPoolApplicationMutation, RejectTalentCompanyPoolApplicationMutationVariables>;

/**
 * __useRejectTalentCompanyPoolApplicationMutation__
 *
 * To run a mutation, you first call `useRejectTalentCompanyPoolApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTalentCompanyPoolApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTalentCompanyPoolApplicationMutation, { data, loading, error }] = useRejectTalentCompanyPoolApplicationMutation({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useRejectTalentCompanyPoolApplicationMutation(baseOptions?: Apollo.MutationHookOptions<RejectTalentCompanyPoolApplicationMutation, RejectTalentCompanyPoolApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectTalentCompanyPoolApplicationMutation, RejectTalentCompanyPoolApplicationMutationVariables>(RejectTalentCompanyPoolApplicationDocument, options);
      }
export type RejectTalentCompanyPoolApplicationMutationHookResult = ReturnType<typeof useRejectTalentCompanyPoolApplicationMutation>;
export type RejectTalentCompanyPoolApplicationMutationResult = Apollo.MutationResult<RejectTalentCompanyPoolApplicationMutation>;
export type RejectTalentCompanyPoolApplicationMutationOptions = Apollo.BaseMutationOptions<RejectTalentCompanyPoolApplicationMutation, RejectTalentCompanyPoolApplicationMutationVariables>;
export const RemoveTalentFromCompanyPoolDocument = gql`
    mutation RemoveTalentFromCompanyPool($talent_id: ID!, $message: String) {
  removeTalentFromCompanyPool(talent_id: $talent_id, message: $message)
}
    `;
export type RemoveTalentFromCompanyPoolMutationFn = Apollo.MutationFunction<RemoveTalentFromCompanyPoolMutation, RemoveTalentFromCompanyPoolMutationVariables>;

/**
 * __useRemoveTalentFromCompanyPoolMutation__
 *
 * To run a mutation, you first call `useRemoveTalentFromCompanyPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTalentFromCompanyPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTalentFromCompanyPoolMutation, { data, loading, error }] = useRemoveTalentFromCompanyPoolMutation({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useRemoveTalentFromCompanyPoolMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTalentFromCompanyPoolMutation, RemoveTalentFromCompanyPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTalentFromCompanyPoolMutation, RemoveTalentFromCompanyPoolMutationVariables>(RemoveTalentFromCompanyPoolDocument, options);
      }
export type RemoveTalentFromCompanyPoolMutationHookResult = ReturnType<typeof useRemoveTalentFromCompanyPoolMutation>;
export type RemoveTalentFromCompanyPoolMutationResult = Apollo.MutationResult<RemoveTalentFromCompanyPoolMutation>;
export type RemoveTalentFromCompanyPoolMutationOptions = Apollo.BaseMutationOptions<RemoveTalentFromCompanyPoolMutation, RemoveTalentFromCompanyPoolMutationVariables>;
export const ApproveTalentCompanyPoolApplicationDocument = gql`
    mutation ApproveTalentCompanyPoolApplication($talent_id: ID!) {
  approveTalentCompanyPoolApplication(talent_id: $talent_id)
}
    `;
export type ApproveTalentCompanyPoolApplicationMutationFn = Apollo.MutationFunction<ApproveTalentCompanyPoolApplicationMutation, ApproveTalentCompanyPoolApplicationMutationVariables>;

/**
 * __useApproveTalentCompanyPoolApplicationMutation__
 *
 * To run a mutation, you first call `useApproveTalentCompanyPoolApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTalentCompanyPoolApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTalentCompanyPoolApplicationMutation, { data, loading, error }] = useApproveTalentCompanyPoolApplicationMutation({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *   },
 * });
 */
export function useApproveTalentCompanyPoolApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveTalentCompanyPoolApplicationMutation, ApproveTalentCompanyPoolApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveTalentCompanyPoolApplicationMutation, ApproveTalentCompanyPoolApplicationMutationVariables>(ApproveTalentCompanyPoolApplicationDocument, options);
      }
export type ApproveTalentCompanyPoolApplicationMutationHookResult = ReturnType<typeof useApproveTalentCompanyPoolApplicationMutation>;
export type ApproveTalentCompanyPoolApplicationMutationResult = Apollo.MutationResult<ApproveTalentCompanyPoolApplicationMutation>;
export type ApproveTalentCompanyPoolApplicationMutationOptions = Apollo.BaseMutationOptions<ApproveTalentCompanyPoolApplicationMutation, ApproveTalentCompanyPoolApplicationMutationVariables>;
export const RevokeCompanyPoolInvitationDocument = gql`
    mutation RevokeCompanyPoolInvitation($talent_id: ID!) {
  revokeCompanyPoolInvitation(talent_id: $talent_id)
}
    `;
export type RevokeCompanyPoolInvitationMutationFn = Apollo.MutationFunction<RevokeCompanyPoolInvitationMutation, RevokeCompanyPoolInvitationMutationVariables>;

/**
 * __useRevokeCompanyPoolInvitationMutation__
 *
 * To run a mutation, you first call `useRevokeCompanyPoolInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCompanyPoolInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCompanyPoolInvitationMutation, { data, loading, error }] = useRevokeCompanyPoolInvitationMutation({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *   },
 * });
 */
export function useRevokeCompanyPoolInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RevokeCompanyPoolInvitationMutation, RevokeCompanyPoolInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeCompanyPoolInvitationMutation, RevokeCompanyPoolInvitationMutationVariables>(RevokeCompanyPoolInvitationDocument, options);
      }
export type RevokeCompanyPoolInvitationMutationHookResult = ReturnType<typeof useRevokeCompanyPoolInvitationMutation>;
export type RevokeCompanyPoolInvitationMutationResult = Apollo.MutationResult<RevokeCompanyPoolInvitationMutation>;
export type RevokeCompanyPoolInvitationMutationOptions = Apollo.BaseMutationOptions<RevokeCompanyPoolInvitationMutation, RevokeCompanyPoolInvitationMutationVariables>;
export const GetApplicationFormJobInfoDocument = gql`
    query GetApplicationFormJobInfo($job_id: ID!, $match_id: ID!) {
  fieldGlassCandidateIntroductionByJobMatchId(job_match_id: $match_id) {
    id
    first_name
    last_name
    email
    job_posting_id
    additional_invoice_currency
    answers
    calculate_rate_using
    comments
    created_at
    creator_username
    date_available
    date_of_birth
    display_candidate_workforce_record_to_the_buyer
    external_job_seeker_id
    job_seeker_code
    location_code
    number_of_tiers
    payment_currency
    double_pay_rate
    overtime_pay_rate
    standard_pay_rate
    primary_location_code
    qualifications
    rate_change_matrix_start_date
    register_on_behalf_of_worker
    remit_to_address_code
    security_id
    select_rates
    site_code
    ...SubmissionStatusFields
    submitted_at
    submitted_by_user_id
    submitted_to_other_job_postings
    supplier_email
    time_zone
    unique_id
    updated_at
    username
    worker_country_of_origin
    worker_pay_type
    cv_attachment {
      hash
      title
      content_type
    }
  }
  job(id: $job_id) {
    id
    name
    striive_job {
      id
      questions
      qualifications
      rates
      rate_type
      record_id
      source
    }
    matches {
      id
      talent {
        id
        first_name_abac {
          value
        }
        last_name_abac {
          value
        }
        email_abac {
          value
        }
        documents {
          hash
          title
          type
        }
      }
    }
  }
}
    ${SubmissionStatusFieldsFragmentDoc}`;

/**
 * __useGetApplicationFormJobInfoQuery__
 *
 * To run a query within a React component, call `useGetApplicationFormJobInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationFormJobInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationFormJobInfoQuery({
 *   variables: {
 *      job_id: // value for 'job_id'
 *      match_id: // value for 'match_id'
 *   },
 * });
 */
export function useGetApplicationFormJobInfoQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables> & ({ variables: GetApplicationFormJobInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables>(GetApplicationFormJobInfoDocument, options);
      }
export function useGetApplicationFormJobInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables>(GetApplicationFormJobInfoDocument, options);
        }
// @ts-ignore
export function useGetApplicationFormJobInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables>;
export function useGetApplicationFormJobInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationFormJobInfoQuery | undefined, GetApplicationFormJobInfoQueryVariables>;
export function useGetApplicationFormJobInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables>(GetApplicationFormJobInfoDocument, options);
        }
export type GetApplicationFormJobInfoQueryHookResult = ReturnType<typeof useGetApplicationFormJobInfoQuery>;
export type GetApplicationFormJobInfoLazyQueryHookResult = ReturnType<typeof useGetApplicationFormJobInfoLazyQuery>;
export type GetApplicationFormJobInfoSuspenseQueryHookResult = ReturnType<typeof useGetApplicationFormJobInfoSuspenseQuery>;
export type GetApplicationFormJobInfoQueryResult = Apollo.QueryResult<GetApplicationFormJobInfoQuery, GetApplicationFormJobInfoQueryVariables>;
export const CreateFieldGlassCandidateIntroductionDocument = gql`
    mutation CreateFieldGlassCandidateIntroduction($introduction: CreateFieldGlassCandidateIntroductionInput!, $job_match_id: ID!) {
  createFieldGlassCandidateIntroduction(
    introduction: $introduction
    job_match_id: $job_match_id
  ) {
    id
    first_name
    site_code
    last_name
    email
    job_posting_id
    date_available
    worker_pay_type
    security_id
    location_code
    double_pay_rate
    overtime_pay_rate
    standard_pay_rate
    display_candidate_workforce_record_to_the_buyer
    submitted_to_other_job_postings
    qualifications
    answers
    additional_invoice_currency
    calculate_rate_using
    comments
    date_of_birth
    external_job_seeker_id
    job_seeker_code
    number_of_tiers
    payment_currency
    primary_location_code
    rate_change_matrix_start_date
    register_on_behalf_of_worker
    remit_to_address_code
    select_rates
    site_code
    supplier_email
    time_zone
    unique_id
    worker_country_of_origin
    submission_status
    submitted_at
    submitted_by_user_id
    created_at
    updated_at
    cv_attachment {
      hash
      title
      content_type
    }
    candidate_cv_hash
  }
}
    `;
export type CreateFieldGlassCandidateIntroductionMutationFn = Apollo.MutationFunction<CreateFieldGlassCandidateIntroductionMutation, CreateFieldGlassCandidateIntroductionMutationVariables>;

/**
 * __useCreateFieldGlassCandidateIntroductionMutation__
 *
 * To run a mutation, you first call `useCreateFieldGlassCandidateIntroductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFieldGlassCandidateIntroductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFieldGlassCandidateIntroductionMutation, { data, loading, error }] = useCreateFieldGlassCandidateIntroductionMutation({
 *   variables: {
 *      introduction: // value for 'introduction'
 *      job_match_id: // value for 'job_match_id'
 *   },
 * });
 */
export function useCreateFieldGlassCandidateIntroductionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFieldGlassCandidateIntroductionMutation, CreateFieldGlassCandidateIntroductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFieldGlassCandidateIntroductionMutation, CreateFieldGlassCandidateIntroductionMutationVariables>(CreateFieldGlassCandidateIntroductionDocument, options);
      }
export type CreateFieldGlassCandidateIntroductionMutationHookResult = ReturnType<typeof useCreateFieldGlassCandidateIntroductionMutation>;
export type CreateFieldGlassCandidateIntroductionMutationResult = Apollo.MutationResult<CreateFieldGlassCandidateIntroductionMutation>;
export type CreateFieldGlassCandidateIntroductionMutationOptions = Apollo.BaseMutationOptions<CreateFieldGlassCandidateIntroductionMutation, CreateFieldGlassCandidateIntroductionMutationVariables>;
export const UpdateFieldGlassCandidateIntroductionDocument = gql`
    mutation UpdateFieldGlassCandidateIntroduction($introduction: SaveFieldGlassCandidateIntroductionInput!, $introduction_id: ID!) {
  saveFieldGlassCandidateIntroduction(
    introduction: $introduction
    introduction_id: $introduction_id
  ) {
    id
    first_name
    last_name
    email
    job_posting_id
    date_available
    double_pay_rate
    overtime_pay_rate
    standard_pay_rate
    worker_pay_type
    site_code
    security_id
    location_code
    display_candidate_workforce_record_to_the_buyer
    submitted_to_other_job_postings
    qualifications
    answers
    additional_invoice_currency
    calculate_rate_using
    comments
    date_of_birth
    external_job_seeker_id
    job_seeker_code
    number_of_tiers
    payment_currency
    primary_location_code
    rate_change_matrix_start_date
    register_on_behalf_of_worker
    remit_to_address_code
    select_rates
    site_code
    supplier_email
    time_zone
    unique_id
    worker_country_of_origin
    submission_status
    submitted_at
    submitted_by_user_id
    created_at
    updated_at
    cv_attachment {
      hash
      title
      content_type
    }
    candidate_cv_hash
  }
}
    `;
export type UpdateFieldGlassCandidateIntroductionMutationFn = Apollo.MutationFunction<UpdateFieldGlassCandidateIntroductionMutation, UpdateFieldGlassCandidateIntroductionMutationVariables>;

/**
 * __useUpdateFieldGlassCandidateIntroductionMutation__
 *
 * To run a mutation, you first call `useUpdateFieldGlassCandidateIntroductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldGlassCandidateIntroductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldGlassCandidateIntroductionMutation, { data, loading, error }] = useUpdateFieldGlassCandidateIntroductionMutation({
 *   variables: {
 *      introduction: // value for 'introduction'
 *      introduction_id: // value for 'introduction_id'
 *   },
 * });
 */
export function useUpdateFieldGlassCandidateIntroductionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldGlassCandidateIntroductionMutation, UpdateFieldGlassCandidateIntroductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldGlassCandidateIntroductionMutation, UpdateFieldGlassCandidateIntroductionMutationVariables>(UpdateFieldGlassCandidateIntroductionDocument, options);
      }
export type UpdateFieldGlassCandidateIntroductionMutationHookResult = ReturnType<typeof useUpdateFieldGlassCandidateIntroductionMutation>;
export type UpdateFieldGlassCandidateIntroductionMutationResult = Apollo.MutationResult<UpdateFieldGlassCandidateIntroductionMutation>;
export type UpdateFieldGlassCandidateIntroductionMutationOptions = Apollo.BaseMutationOptions<UpdateFieldGlassCandidateIntroductionMutation, UpdateFieldGlassCandidateIntroductionMutationVariables>;
export const GetFieldGlassSubmissionStatusDocument = gql`
    query GetFieldGlassSubmissionStatus($match_id: ID!) {
  fieldGlassCandidateIntroductionByJobMatchId(job_match_id: $match_id) {
    id
    ...SubmissionStatusFields
  }
}
    ${SubmissionStatusFieldsFragmentDoc}`;

/**
 * __useGetFieldGlassSubmissionStatusQuery__
 *
 * To run a query within a React component, call `useGetFieldGlassSubmissionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldGlassSubmissionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldGlassSubmissionStatusQuery({
 *   variables: {
 *      match_id: // value for 'match_id'
 *   },
 * });
 */
export function useGetFieldGlassSubmissionStatusQuery(baseOptions: Apollo.QueryHookOptions<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables> & ({ variables: GetFieldGlassSubmissionStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables>(GetFieldGlassSubmissionStatusDocument, options);
      }
export function useGetFieldGlassSubmissionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables>(GetFieldGlassSubmissionStatusDocument, options);
        }
// @ts-ignore
export function useGetFieldGlassSubmissionStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables>;
export function useGetFieldGlassSubmissionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetFieldGlassSubmissionStatusQuery | undefined, GetFieldGlassSubmissionStatusQueryVariables>;
export function useGetFieldGlassSubmissionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables>(GetFieldGlassSubmissionStatusDocument, options);
        }
export type GetFieldGlassSubmissionStatusQueryHookResult = ReturnType<typeof useGetFieldGlassSubmissionStatusQuery>;
export type GetFieldGlassSubmissionStatusLazyQueryHookResult = ReturnType<typeof useGetFieldGlassSubmissionStatusLazyQuery>;
export type GetFieldGlassSubmissionStatusSuspenseQueryHookResult = ReturnType<typeof useGetFieldGlassSubmissionStatusSuspenseQuery>;
export type GetFieldGlassSubmissionStatusQueryResult = Apollo.QueryResult<GetFieldGlassSubmissionStatusQuery, GetFieldGlassSubmissionStatusQueryVariables>;
export const SubmitFieldGlassCandidateIntroductionDocument = gql`
    mutation SubmitFieldGlassCandidateIntroduction($introduction_id: ID!) {
  submitFieldGlassCandidateIntroduction(introduction_id: $introduction_id)
}
    `;
export type SubmitFieldGlassCandidateIntroductionMutationFn = Apollo.MutationFunction<SubmitFieldGlassCandidateIntroductionMutation, SubmitFieldGlassCandidateIntroductionMutationVariables>;

/**
 * __useSubmitFieldGlassCandidateIntroductionMutation__
 *
 * To run a mutation, you first call `useSubmitFieldGlassCandidateIntroductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFieldGlassCandidateIntroductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFieldGlassCandidateIntroductionMutation, { data, loading, error }] = useSubmitFieldGlassCandidateIntroductionMutation({
 *   variables: {
 *      introduction_id: // value for 'introduction_id'
 *   },
 * });
 */
export function useSubmitFieldGlassCandidateIntroductionMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFieldGlassCandidateIntroductionMutation, SubmitFieldGlassCandidateIntroductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFieldGlassCandidateIntroductionMutation, SubmitFieldGlassCandidateIntroductionMutationVariables>(SubmitFieldGlassCandidateIntroductionDocument, options);
      }
export type SubmitFieldGlassCandidateIntroductionMutationHookResult = ReturnType<typeof useSubmitFieldGlassCandidateIntroductionMutation>;
export type SubmitFieldGlassCandidateIntroductionMutationResult = Apollo.MutationResult<SubmitFieldGlassCandidateIntroductionMutation>;
export type SubmitFieldGlassCandidateIntroductionMutationOptions = Apollo.BaseMutationOptions<SubmitFieldGlassCandidateIntroductionMutation, SubmitFieldGlassCandidateIntroductionMutationVariables>;
export const GetDashboardInfoDocument = gql`
    query GetDashboardInfo {
  pendingTalents: talents(source_type: OWN, is_verification_required: true) {
    paginatorInfo {
      total
    }
  }
  generalAnalytics {
    key
    value
    slug
  }
  tagsAnalytics {
    key
    value
    slug
  }
  countryAnalytics {
    key
    value
    slug
  }
  categoryAnalytics {
    key
    value
    slug
  }
  lastTalents {
    first_name_abac {
      value
    }
    last_name_abac {
      value
    }
    id
    location
    avatar {
      avatar
    }
    rate
    currency
    is_invitation_accepted
    recent_position_title
  }
}
    `;

/**
 * __useGetDashboardInfoQuery__
 *
 * To run a query within a React component, call `useGetDashboardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>(GetDashboardInfoDocument, options);
      }
export function useGetDashboardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>(GetDashboardInfoDocument, options);
        }
// @ts-ignore
export function useGetDashboardInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>;
export function useGetDashboardInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardInfoQuery | undefined, GetDashboardInfoQueryVariables>;
export function useGetDashboardInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>(GetDashboardInfoDocument, options);
        }
export type GetDashboardInfoQueryHookResult = ReturnType<typeof useGetDashboardInfoQuery>;
export type GetDashboardInfoLazyQueryHookResult = ReturnType<typeof useGetDashboardInfoLazyQuery>;
export type GetDashboardInfoSuspenseQueryHookResult = ReturnType<typeof useGetDashboardInfoSuspenseQuery>;
export type GetDashboardInfoQueryResult = Apollo.QueryResult<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>;
export const GetPendingTalentsCountDocument = gql`
    query GetPendingTalentsCount($source_type: SourceTypeEnum = OWN, $is_verification_required: Boolean = true, $first: Int = 1, $page: Int = 1) {
  talentsSearch(
    source_type: $source_type
    first: $first
    page: $page
    is_verification_required: $is_verification_required
  ) {
    custom_paginator_info {
      total
    }
  }
}
    `;

/**
 * __useGetPendingTalentsCountQuery__
 *
 * To run a query within a React component, call `useGetPendingTalentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingTalentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingTalentsCountQuery({
 *   variables: {
 *      source_type: // value for 'source_type'
 *      is_verification_required: // value for 'is_verification_required'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetPendingTalentsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>(GetPendingTalentsCountDocument, options);
      }
export function useGetPendingTalentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>(GetPendingTalentsCountDocument, options);
        }
// @ts-ignore
export function useGetPendingTalentsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>;
export function useGetPendingTalentsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingTalentsCountQuery | undefined, GetPendingTalentsCountQueryVariables>;
export function useGetPendingTalentsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>(GetPendingTalentsCountDocument, options);
        }
export type GetPendingTalentsCountQueryHookResult = ReturnType<typeof useGetPendingTalentsCountQuery>;
export type GetPendingTalentsCountLazyQueryHookResult = ReturnType<typeof useGetPendingTalentsCountLazyQuery>;
export type GetPendingTalentsCountSuspenseQueryHookResult = ReturnType<typeof useGetPendingTalentsCountSuspenseQuery>;
export type GetPendingTalentsCountQueryResult = Apollo.QueryResult<GetPendingTalentsCountQuery, GetPendingTalentsCountQueryVariables>;
export const GetDashboardV2VInfoDocument = gql`
    query GetDashboardV2VInfo($company_id: ID!) {
  pendingTalents: talentsSearch(source_type: OWN, is_verification_required: true) {
    custom_paginator_info {
      total
    }
  }
  totalTalents: talentsSearch(source_type: OWN, is_verification_required: false) {
    custom_paginator_info {
      total
    }
  }
  staticTalents: talentsSearch(
    source_type: OWN
    is_static: true
    is_verification_required: false
  ) {
    custom_paginator_info {
      total
    }
  }
  jobs(
    is_draft: false
    first: 5
    page: 1
    company_id: $company_id
    is_archived: false
  ) {
    data {
      id
      name
      posted_at
      matches_with_application_count
      matches {
        id
        stage
      }
    }
  }
  generalAnalytics {
    key
    value
    slug
  }
  tagsAnalytics {
    key
    value
    slug
  }
  countryAnalytics {
    key
    value
    slug
    children {
      key
      value
      slug
    }
  }
  categoryAnalytics {
    key
    value
    slug
  }
  marketingSourceAnalytics {
    key
    value
    slug
  }
  lastTalents {
    first_name_abac {
      value
    }
    last_name_abac {
      value
    }
    id
    location
    avatar {
      avatar
    }
    rate
    currency
    is_invitation_accepted
    recent_position_title
  }
}
    `;

/**
 * __useGetDashboardV2VInfoQuery__
 *
 * To run a query within a React component, call `useGetDashboardV2VInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardV2VInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardV2VInfoQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGetDashboardV2VInfoQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables> & ({ variables: GetDashboardV2VInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables>(GetDashboardV2VInfoDocument, options);
      }
export function useGetDashboardV2VInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables>(GetDashboardV2VInfoDocument, options);
        }
// @ts-ignore
export function useGetDashboardV2VInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables>;
export function useGetDashboardV2VInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardV2VInfoQuery | undefined, GetDashboardV2VInfoQueryVariables>;
export function useGetDashboardV2VInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables>(GetDashboardV2VInfoDocument, options);
        }
export type GetDashboardV2VInfoQueryHookResult = ReturnType<typeof useGetDashboardV2VInfoQuery>;
export type GetDashboardV2VInfoLazyQueryHookResult = ReturnType<typeof useGetDashboardV2VInfoLazyQuery>;
export type GetDashboardV2VInfoSuspenseQueryHookResult = ReturnType<typeof useGetDashboardV2VInfoSuspenseQuery>;
export type GetDashboardV2VInfoQueryResult = Apollo.QueryResult<GetDashboardV2VInfoQuery, GetDashboardV2VInfoQueryVariables>;
export const GetTalentsReportDocument = gql`
    query GetTalentsReport {
  sendJobsExportToCurrentCompanyUserEmail
}
    `;

/**
 * __useGetTalentsReportQuery__
 *
 * To run a query within a React component, call `useGetTalentsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentsReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTalentsReportQuery(baseOptions?: Apollo.QueryHookOptions<GetTalentsReportQuery, GetTalentsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTalentsReportQuery, GetTalentsReportQueryVariables>(GetTalentsReportDocument, options);
      }
export function useGetTalentsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTalentsReportQuery, GetTalentsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTalentsReportQuery, GetTalentsReportQueryVariables>(GetTalentsReportDocument, options);
        }
// @ts-ignore
export function useGetTalentsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTalentsReportQuery, GetTalentsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetTalentsReportQuery, GetTalentsReportQueryVariables>;
export function useGetTalentsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentsReportQuery, GetTalentsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetTalentsReportQuery | undefined, GetTalentsReportQueryVariables>;
export function useGetTalentsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentsReportQuery, GetTalentsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTalentsReportQuery, GetTalentsReportQueryVariables>(GetTalentsReportDocument, options);
        }
export type GetTalentsReportQueryHookResult = ReturnType<typeof useGetTalentsReportQuery>;
export type GetTalentsReportLazyQueryHookResult = ReturnType<typeof useGetTalentsReportLazyQuery>;
export type GetTalentsReportSuspenseQueryHookResult = ReturnType<typeof useGetTalentsReportSuspenseQuery>;
export type GetTalentsReportQueryResult = Apollo.QueryResult<GetTalentsReportQuery, GetTalentsReportQueryVariables>;
export const ExpandJobDocument = gql`
    mutation ExpandJob($id: ID!, $campaign_end_date: DateTimeUtc) {
  updateJob(id: $id, campaign_end_date: $campaign_end_date) {
    id
  }
}
    `;
export type ExpandJobMutationFn = Apollo.MutationFunction<ExpandJobMutation, ExpandJobMutationVariables>;

/**
 * __useExpandJobMutation__
 *
 * To run a mutation, you first call `useExpandJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpandJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expandJobMutation, { data, loading, error }] = useExpandJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaign_end_date: // value for 'campaign_end_date'
 *   },
 * });
 */
export function useExpandJobMutation(baseOptions?: Apollo.MutationHookOptions<ExpandJobMutation, ExpandJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpandJobMutation, ExpandJobMutationVariables>(ExpandJobDocument, options);
      }
export type ExpandJobMutationHookResult = ReturnType<typeof useExpandJobMutation>;
export type ExpandJobMutationResult = Apollo.MutationResult<ExpandJobMutation>;
export type ExpandJobMutationOptions = Apollo.BaseMutationOptions<ExpandJobMutation, ExpandJobMutationVariables>;
export const UpdateJobFinderFeeDocument = gql`
    mutation UpdateJobFinderFee($id: ID!, $finders_fee: Float) {
  updateJob(id: $id, finders_fee: $finders_fee) {
    id
  }
}
    `;
export type UpdateJobFinderFeeMutationFn = Apollo.MutationFunction<UpdateJobFinderFeeMutation, UpdateJobFinderFeeMutationVariables>;

/**
 * __useUpdateJobFinderFeeMutation__
 *
 * To run a mutation, you first call `useUpdateJobFinderFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobFinderFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobFinderFeeMutation, { data, loading, error }] = useUpdateJobFinderFeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      finders_fee: // value for 'finders_fee'
 *   },
 * });
 */
export function useUpdateJobFinderFeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobFinderFeeMutation, UpdateJobFinderFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobFinderFeeMutation, UpdateJobFinderFeeMutationVariables>(UpdateJobFinderFeeDocument, options);
      }
export type UpdateJobFinderFeeMutationHookResult = ReturnType<typeof useUpdateJobFinderFeeMutation>;
export type UpdateJobFinderFeeMutationResult = Apollo.MutationResult<UpdateJobFinderFeeMutation>;
export type UpdateJobFinderFeeMutationOptions = Apollo.BaseMutationOptions<UpdateJobFinderFeeMutation, UpdateJobFinderFeeMutationVariables>;
export const GetJobMatchersApplicationsDocument = gql`
    query GetJobMatchersApplications($job_id: ID!, $status: JobMatcherApplicationStatusEnum) {
  jobMatcherApplications(job_id: $job_id, status: $status) {
    id
    job {
      id
    }
    matcher {
      first_name_abac {
        value
      }
      last_name_abac {
        value
      }
      id
      address
      location
      avatar {
        avatar
      }
    }
    status
  }
  jobMatchers(job_id: $job_id) {
    job {
      id
    }
    talent {
      id
      stream_chat_id
      first_name_abac {
        value
      }
      last_name_abac {
        value
      }
      id
      address
      location
      avatar {
        avatar
      }
    }
  }
}
    `;

/**
 * __useGetJobMatchersApplicationsQuery__
 *
 * To run a query within a React component, call `useGetJobMatchersApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobMatchersApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobMatchersApplicationsQuery({
 *   variables: {
 *      job_id: // value for 'job_id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetJobMatchersApplicationsQuery(baseOptions: Apollo.QueryHookOptions<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables> & ({ variables: GetJobMatchersApplicationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables>(GetJobMatchersApplicationsDocument, options);
      }
export function useGetJobMatchersApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables>(GetJobMatchersApplicationsDocument, options);
        }
// @ts-ignore
export function useGetJobMatchersApplicationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables>;
export function useGetJobMatchersApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobMatchersApplicationsQuery | undefined, GetJobMatchersApplicationsQueryVariables>;
export function useGetJobMatchersApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables>(GetJobMatchersApplicationsDocument, options);
        }
export type GetJobMatchersApplicationsQueryHookResult = ReturnType<typeof useGetJobMatchersApplicationsQuery>;
export type GetJobMatchersApplicationsLazyQueryHookResult = ReturnType<typeof useGetJobMatchersApplicationsLazyQuery>;
export type GetJobMatchersApplicationsSuspenseQueryHookResult = ReturnType<typeof useGetJobMatchersApplicationsSuspenseQuery>;
export type GetJobMatchersApplicationsQueryResult = Apollo.QueryResult<GetJobMatchersApplicationsQuery, GetJobMatchersApplicationsQueryVariables>;
export const ApproveJobMacherApplicationDocument = gql`
    mutation ApproveJobMacherApplication($id: ID!) {
  approveJobMatcherApplication(id: $id) {
    id
  }
}
    `;
export type ApproveJobMacherApplicationMutationFn = Apollo.MutationFunction<ApproveJobMacherApplicationMutation, ApproveJobMacherApplicationMutationVariables>;

/**
 * __useApproveJobMacherApplicationMutation__
 *
 * To run a mutation, you first call `useApproveJobMacherApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveJobMacherApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveJobMacherApplicationMutation, { data, loading, error }] = useApproveJobMacherApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveJobMacherApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveJobMacherApplicationMutation, ApproveJobMacherApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveJobMacherApplicationMutation, ApproveJobMacherApplicationMutationVariables>(ApproveJobMacherApplicationDocument, options);
      }
export type ApproveJobMacherApplicationMutationHookResult = ReturnType<typeof useApproveJobMacherApplicationMutation>;
export type ApproveJobMacherApplicationMutationResult = Apollo.MutationResult<ApproveJobMacherApplicationMutation>;
export type ApproveJobMacherApplicationMutationOptions = Apollo.BaseMutationOptions<ApproveJobMacherApplicationMutation, ApproveJobMacherApplicationMutationVariables>;
export const RejectJobMacherApplicationDocument = gql`
    mutation RejectJobMacherApplication($id: ID!) {
  rejectJobMatcherApplication(id: $id) {
    id
  }
}
    `;
export type RejectJobMacherApplicationMutationFn = Apollo.MutationFunction<RejectJobMacherApplicationMutation, RejectJobMacherApplicationMutationVariables>;

/**
 * __useRejectJobMacherApplicationMutation__
 *
 * To run a mutation, you first call `useRejectJobMacherApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectJobMacherApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectJobMacherApplicationMutation, { data, loading, error }] = useRejectJobMacherApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectJobMacherApplicationMutation(baseOptions?: Apollo.MutationHookOptions<RejectJobMacherApplicationMutation, RejectJobMacherApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectJobMacherApplicationMutation, RejectJobMacherApplicationMutationVariables>(RejectJobMacherApplicationDocument, options);
      }
export type RejectJobMacherApplicationMutationHookResult = ReturnType<typeof useRejectJobMacherApplicationMutation>;
export type RejectJobMacherApplicationMutationResult = Apollo.MutationResult<RejectJobMacherApplicationMutation>;
export type RejectJobMacherApplicationMutationOptions = Apollo.BaseMutationOptions<RejectJobMacherApplicationMutation, RejectJobMacherApplicationMutationVariables>;
export const RemoveJobMatcherFromJobDocument = gql`
    mutation RemoveJobMatcherFromJob($matcher_id: ID!, $job_id: ID!) {
  removeJobMatcherFromJob(matcher_id: $matcher_id, job_id: $job_id)
}
    `;
export type RemoveJobMatcherFromJobMutationFn = Apollo.MutationFunction<RemoveJobMatcherFromJobMutation, RemoveJobMatcherFromJobMutationVariables>;

/**
 * __useRemoveJobMatcherFromJobMutation__
 *
 * To run a mutation, you first call `useRemoveJobMatcherFromJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveJobMatcherFromJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeJobMatcherFromJobMutation, { data, loading, error }] = useRemoveJobMatcherFromJobMutation({
 *   variables: {
 *      matcher_id: // value for 'matcher_id'
 *      job_id: // value for 'job_id'
 *   },
 * });
 */
export function useRemoveJobMatcherFromJobMutation(baseOptions?: Apollo.MutationHookOptions<RemoveJobMatcherFromJobMutation, RemoveJobMatcherFromJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveJobMatcherFromJobMutation, RemoveJobMatcherFromJobMutationVariables>(RemoveJobMatcherFromJobDocument, options);
      }
export type RemoveJobMatcherFromJobMutationHookResult = ReturnType<typeof useRemoveJobMatcherFromJobMutation>;
export type RemoveJobMatcherFromJobMutationResult = Apollo.MutationResult<RemoveJobMatcherFromJobMutation>;
export type RemoveJobMatcherFromJobMutationOptions = Apollo.BaseMutationOptions<RemoveJobMatcherFromJobMutation, RemoveJobMatcherFromJobMutationVariables>;
export const ChangeJobMatchStageDocument = gql`
    mutation ChangeJobMatchStage($job_match_id: ID!, $new_stage: JobMatchStageEnum!, $declination_reason: JobMatchDeclinationReasonsUsEnum, $message: String) {
  changeJobMatchStage(
    job_match_id: $job_match_id
    new_stage: $new_stage
    declination_reason: $declination_reason
    message: $message
  )
}
    `;
export type ChangeJobMatchStageMutationFn = Apollo.MutationFunction<ChangeJobMatchStageMutation, ChangeJobMatchStageMutationVariables>;

/**
 * __useChangeJobMatchStageMutation__
 *
 * To run a mutation, you first call `useChangeJobMatchStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeJobMatchStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeJobMatchStageMutation, { data, loading, error }] = useChangeJobMatchStageMutation({
 *   variables: {
 *      job_match_id: // value for 'job_match_id'
 *      new_stage: // value for 'new_stage'
 *      declination_reason: // value for 'declination_reason'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useChangeJobMatchStageMutation(baseOptions?: Apollo.MutationHookOptions<ChangeJobMatchStageMutation, ChangeJobMatchStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeJobMatchStageMutation, ChangeJobMatchStageMutationVariables>(ChangeJobMatchStageDocument, options);
      }
export type ChangeJobMatchStageMutationHookResult = ReturnType<typeof useChangeJobMatchStageMutation>;
export type ChangeJobMatchStageMutationResult = Apollo.MutationResult<ChangeJobMatchStageMutation>;
export type ChangeJobMatchStageMutationOptions = Apollo.BaseMutationOptions<ChangeJobMatchStageMutation, ChangeJobMatchStageMutationVariables>;
export const CreateCompanyAccountAccessRequestDocument = gql`
    mutation CreateCompanyAccountAccessRequest($first_name: String!, $last_name: String!, $email: Email!, $company_id: ID, $new_company_name: String, $referral_key: String, $recruiter_employment_type: CompanyUserRecruiterEmploymentTypeEnum) {
  createCompanyAccountAccessRequest(
    first_name: $first_name
    last_name: $last_name
    email: $email
    company_id: $company_id
    new_company_name: $new_company_name
    referral_key: $referral_key
    recruiter_employment_type: $recruiter_employment_type
  )
}
    `;
export type CreateCompanyAccountAccessRequestMutationFn = Apollo.MutationFunction<CreateCompanyAccountAccessRequestMutation, CreateCompanyAccountAccessRequestMutationVariables>;

/**
 * __useCreateCompanyAccountAccessRequestMutation__
 *
 * To run a mutation, you first call `useCreateCompanyAccountAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyAccountAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyAccountAccessRequestMutation, { data, loading, error }] = useCreateCompanyAccountAccessRequestMutation({
 *   variables: {
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      email: // value for 'email'
 *      company_id: // value for 'company_id'
 *      new_company_name: // value for 'new_company_name'
 *      referral_key: // value for 'referral_key'
 *      recruiter_employment_type: // value for 'recruiter_employment_type'
 *   },
 * });
 */
export function useCreateCompanyAccountAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyAccountAccessRequestMutation, CreateCompanyAccountAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyAccountAccessRequestMutation, CreateCompanyAccountAccessRequestMutationVariables>(CreateCompanyAccountAccessRequestDocument, options);
      }
export type CreateCompanyAccountAccessRequestMutationHookResult = ReturnType<typeof useCreateCompanyAccountAccessRequestMutation>;
export type CreateCompanyAccountAccessRequestMutationResult = Apollo.MutationResult<CreateCompanyAccountAccessRequestMutation>;
export type CreateCompanyAccountAccessRequestMutationOptions = Apollo.BaseMutationOptions<CreateCompanyAccountAccessRequestMutation, CreateCompanyAccountAccessRequestMutationVariables>;
export const GetPendingTalentsDocument = gql`
    query GetPendingTalents($source_type: SourceTypeEnum = OWN, $is_verification_required: Boolean = true, $first: Int = 10, $page: Int = 1, $connection_with_company_id: ID) {
  talentsSearch(
    source_type: $source_type
    first: $first
    page: $page
    is_verification_required: $is_verification_required
    connection_with_company_id: $connection_with_company_id
  ) {
    custom_paginator_info {
      current_page
      last_page
      per_page
      total
    }
    data {
      highlights {
        source
        text
      }
      talent {
        company_pool_connections {
          company {
            id
            name
          }
          status
          initiator
          cancel_initiator
        }
        subcategories {
          id
          name
        }
        currency
        id
        reminded_at
        created_at
        is_invitation_accepted
        is_verification_required
        first_name_abac {
          value
        }
        last_name_abac {
          value
        }
        address
        job_applications {
          id
          job {
            id
            name
          }
        }
        rate
        recent_position_title
        email_abac {
          value
        }
        available_now
        location
        stream_chat_id
        is_ot_pool
        source {
          id
        }
        avatar {
          avatar
        }
        talent_data {
          phone
        }
      }
    }
  }
}
    `;

/**
 * __useGetPendingTalentsQuery__
 *
 * To run a query within a React component, call `useGetPendingTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingTalentsQuery({
 *   variables: {
 *      source_type: // value for 'source_type'
 *      is_verification_required: // value for 'is_verification_required'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      connection_with_company_id: // value for 'connection_with_company_id'
 *   },
 * });
 */
export function useGetPendingTalentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>(GetPendingTalentsDocument, options);
      }
export function useGetPendingTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>(GetPendingTalentsDocument, options);
        }
// @ts-ignore
export function useGetPendingTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>;
export function useGetPendingTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingTalentsQuery | undefined, GetPendingTalentsQueryVariables>;
export function useGetPendingTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>(GetPendingTalentsDocument, options);
        }
export type GetPendingTalentsQueryHookResult = ReturnType<typeof useGetPendingTalentsQuery>;
export type GetPendingTalentsLazyQueryHookResult = ReturnType<typeof useGetPendingTalentsLazyQuery>;
export type GetPendingTalentsSuspenseQueryHookResult = ReturnType<typeof useGetPendingTalentsSuspenseQuery>;
export type GetPendingTalentsQueryResult = Apollo.QueryResult<GetPendingTalentsQuery, GetPendingTalentsQueryVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: ID!) {
  deleteTag(id: $id)
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($name: String!) {
  createTag(name: $name) {
    id
    name
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const EditTagDocument = gql`
    mutation EditTag($id: ID!, $name: String!) {
  editTag(id: $id, name: $name) {
    id
    name
  }
}
    `;
export type EditTagMutationFn = Apollo.MutationFunction<EditTagMutation, EditTagMutationVariables>;

/**
 * __useEditTagMutation__
 *
 * To run a mutation, you first call `useEditTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTagMutation, { data, loading, error }] = useEditTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditTagMutation(baseOptions?: Apollo.MutationHookOptions<EditTagMutation, EditTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTagMutation, EditTagMutationVariables>(EditTagDocument, options);
      }
export type EditTagMutationHookResult = ReturnType<typeof useEditTagMutation>;
export type EditTagMutationResult = Apollo.MutationResult<EditTagMutation>;
export type EditTagMutationOptions = Apollo.BaseMutationOptions<EditTagMutation, EditTagMutationVariables>;
export const GetLeavePageInfoDocument = gql`
    query GetLeavePageInfo($delete_key: String!) {
  selfDeletePageInfo(delete_key: $delete_key) {
    invited_by_full_name
  }
}
    `;

/**
 * __useGetLeavePageInfoQuery__
 *
 * To run a query within a React component, call `useGetLeavePageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeavePageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeavePageInfoQuery({
 *   variables: {
 *      delete_key: // value for 'delete_key'
 *   },
 * });
 */
export function useGetLeavePageInfoQuery(baseOptions: Apollo.QueryHookOptions<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables> & ({ variables: GetLeavePageInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables>(GetLeavePageInfoDocument, options);
      }
export function useGetLeavePageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables>(GetLeavePageInfoDocument, options);
        }
// @ts-ignore
export function useGetLeavePageInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables>;
export function useGetLeavePageInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeavePageInfoQuery | undefined, GetLeavePageInfoQueryVariables>;
export function useGetLeavePageInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables>(GetLeavePageInfoDocument, options);
        }
export type GetLeavePageInfoQueryHookResult = ReturnType<typeof useGetLeavePageInfoQuery>;
export type GetLeavePageInfoLazyQueryHookResult = ReturnType<typeof useGetLeavePageInfoLazyQuery>;
export type GetLeavePageInfoSuspenseQueryHookResult = ReturnType<typeof useGetLeavePageInfoSuspenseQuery>;
export type GetLeavePageInfoQueryResult = Apollo.QueryResult<GetLeavePageInfoQuery, GetLeavePageInfoQueryVariables>;
export const RestoreAccountDocument = gql`
    mutation RestoreAccount($delete_key: String!) {
  restoreDeletedAccountByDeleteKey(delete_key: $delete_key) {
    link_to_set_password_page
  }
}
    `;
export type RestoreAccountMutationFn = Apollo.MutationFunction<RestoreAccountMutation, RestoreAccountMutationVariables>;

/**
 * __useRestoreAccountMutation__
 *
 * To run a mutation, you first call `useRestoreAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreAccountMutation, { data, loading, error }] = useRestoreAccountMutation({
 *   variables: {
 *      delete_key: // value for 'delete_key'
 *   },
 * });
 */
export function useRestoreAccountMutation(baseOptions?: Apollo.MutationHookOptions<RestoreAccountMutation, RestoreAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreAccountMutation, RestoreAccountMutationVariables>(RestoreAccountDocument, options);
      }
export type RestoreAccountMutationHookResult = ReturnType<typeof useRestoreAccountMutation>;
export type RestoreAccountMutationResult = Apollo.MutationResult<RestoreAccountMutation>;
export type RestoreAccountMutationOptions = Apollo.BaseMutationOptions<RestoreAccountMutation, RestoreAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($delete_key: String!) {
  selfDeleteAccount(delete_key: $delete_key)
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      delete_key: // value for 'delete_key'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const GetNotificationsPageDataDocument = gql`
    query GetNotificationsPageData($first: Int = 20, $page: Int = 1, $is_read: Boolean, $is_important: Boolean) {
  currentUserUnreadNotificationsCount
  importantNotificationsCount: currentUserNotifications(is_important: true) {
    paginatorInfo {
      total
    }
  }
  unreadImportantNotificationsCount: currentUserNotifications(
    is_important: true
    is_read: false
  ) {
    paginatorInfo {
      total
    }
  }
  allNotifications: currentUserNotifications(
    first: $first
    page: $page
    is_important: $is_important
    is_read: $is_read
  ) {
    ...NotificationsListMain
  }
}
    ${NotificationsListMainFragmentDoc}`;

/**
 * __useGetNotificationsPageDataQuery__
 *
 * To run a query within a React component, call `useGetNotificationsPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsPageDataQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      is_read: // value for 'is_read'
 *      is_important: // value for 'is_important'
 *   },
 * });
 */
export function useGetNotificationsPageDataQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>(GetNotificationsPageDataDocument, options);
      }
export function useGetNotificationsPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>(GetNotificationsPageDataDocument, options);
        }
// @ts-ignore
export function useGetNotificationsPageDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>;
export function useGetNotificationsPageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsPageDataQuery | undefined, GetNotificationsPageDataQueryVariables>;
export function useGetNotificationsPageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>(GetNotificationsPageDataDocument, options);
        }
export type GetNotificationsPageDataQueryHookResult = ReturnType<typeof useGetNotificationsPageDataQuery>;
export type GetNotificationsPageDataLazyQueryHookResult = ReturnType<typeof useGetNotificationsPageDataLazyQuery>;
export type GetNotificationsPageDataSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsPageDataSuspenseQuery>;
export type GetNotificationsPageDataQueryResult = Apollo.QueryResult<GetNotificationsPageDataQuery, GetNotificationsPageDataQueryVariables>;
export const SetTagsToTalentDocument = gql`
    mutation SetTagsToTalent($tags_ids: [ID!]!, $talent_id: ID!) {
  setTagsToTalent(tags_ids: $tags_ids, talent_id: $talent_id)
}
    `;
export type SetTagsToTalentMutationFn = Apollo.MutationFunction<SetTagsToTalentMutation, SetTagsToTalentMutationVariables>;

/**
 * __useSetTagsToTalentMutation__
 *
 * To run a mutation, you first call `useSetTagsToTalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTagsToTalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTagsToTalentMutation, { data, loading, error }] = useSetTagsToTalentMutation({
 *   variables: {
 *      tags_ids: // value for 'tags_ids'
 *      talent_id: // value for 'talent_id'
 *   },
 * });
 */
export function useSetTagsToTalentMutation(baseOptions?: Apollo.MutationHookOptions<SetTagsToTalentMutation, SetTagsToTalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTagsToTalentMutation, SetTagsToTalentMutationVariables>(SetTagsToTalentDocument, options);
      }
export type SetTagsToTalentMutationHookResult = ReturnType<typeof useSetTagsToTalentMutation>;
export type SetTagsToTalentMutationResult = Apollo.MutationResult<SetTagsToTalentMutation>;
export type SetTagsToTalentMutationOptions = Apollo.BaseMutationOptions<SetTagsToTalentMutation, SetTagsToTalentMutationVariables>;
export const CreateJobMatcherApplicationDocument = gql`
    mutation CreateJobMatcherApplication($job_id: ID!, $message: String) {
  createJobMatcherApplication(job_id: $job_id, message: $message) {
    id
  }
}
    `;
export type CreateJobMatcherApplicationMutationFn = Apollo.MutationFunction<CreateJobMatcherApplicationMutation, CreateJobMatcherApplicationMutationVariables>;

/**
 * __useCreateJobMatcherApplicationMutation__
 *
 * To run a mutation, you first call `useCreateJobMatcherApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMatcherApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMatcherApplicationMutation, { data, loading, error }] = useCreateJobMatcherApplicationMutation({
 *   variables: {
 *      job_id: // value for 'job_id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateJobMatcherApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMatcherApplicationMutation, CreateJobMatcherApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobMatcherApplicationMutation, CreateJobMatcherApplicationMutationVariables>(CreateJobMatcherApplicationDocument, options);
      }
export type CreateJobMatcherApplicationMutationHookResult = ReturnType<typeof useCreateJobMatcherApplicationMutation>;
export type CreateJobMatcherApplicationMutationResult = Apollo.MutationResult<CreateJobMatcherApplicationMutation>;
export type CreateJobMatcherApplicationMutationOptions = Apollo.BaseMutationOptions<CreateJobMatcherApplicationMutation, CreateJobMatcherApplicationMutationVariables>;
export const GetCompaniesScreenDataDocument = gql`
    query GetCompaniesScreenData($pooling_type: CompanyPoolingTypeEnum, $country: String, $first: Int, $page: Int) {
  poolingCompanies(
    pooling_type: $pooling_type
    country: $country
    first: $first
    page: $page
  ) {
    paginatorInfo {
      count
      currentPage
      firstItem
      lastItem
      lastPage
      perPage
      total
    }
    data {
      id
      name
      about
      country
      size
      type_of_activity
      logo {
        url
      }
    }
  }
}
    `;

/**
 * __useGetCompaniesScreenDataQuery__
 *
 * To run a query within a React component, call `useGetCompaniesScreenDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesScreenDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesScreenDataQuery({
 *   variables: {
 *      pooling_type: // value for 'pooling_type'
 *      country: // value for 'country'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetCompaniesScreenDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>(GetCompaniesScreenDataDocument, options);
      }
export function useGetCompaniesScreenDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>(GetCompaniesScreenDataDocument, options);
        }
// @ts-ignore
export function useGetCompaniesScreenDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>;
export function useGetCompaniesScreenDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompaniesScreenDataQuery | undefined, GetCompaniesScreenDataQueryVariables>;
export function useGetCompaniesScreenDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>(GetCompaniesScreenDataDocument, options);
        }
export type GetCompaniesScreenDataQueryHookResult = ReturnType<typeof useGetCompaniesScreenDataQuery>;
export type GetCompaniesScreenDataLazyQueryHookResult = ReturnType<typeof useGetCompaniesScreenDataLazyQuery>;
export type GetCompaniesScreenDataSuspenseQueryHookResult = ReturnType<typeof useGetCompaniesScreenDataSuspenseQuery>;
export type GetCompaniesScreenDataQueryResult = Apollo.QueryResult<GetCompaniesScreenDataQuery, GetCompaniesScreenDataQueryVariables>;
export const InviteCompanyToOpentalentDocument = gql`
    mutation InviteCompanyToOpentalent($company_name: String!, $contact_person: String!, $company_email: String!) {
  inviteCompanyToOpentalent(
    company_name: $company_name
    contact_person: $contact_person
    company_email: $company_email
  )
}
    `;
export type InviteCompanyToOpentalentMutationFn = Apollo.MutationFunction<InviteCompanyToOpentalentMutation, InviteCompanyToOpentalentMutationVariables>;

/**
 * __useInviteCompanyToOpentalentMutation__
 *
 * To run a mutation, you first call `useInviteCompanyToOpentalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCompanyToOpentalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCompanyToOpentalentMutation, { data, loading, error }] = useInviteCompanyToOpentalentMutation({
 *   variables: {
 *      company_name: // value for 'company_name'
 *      contact_person: // value for 'contact_person'
 *      company_email: // value for 'company_email'
 *   },
 * });
 */
export function useInviteCompanyToOpentalentMutation(baseOptions?: Apollo.MutationHookOptions<InviteCompanyToOpentalentMutation, InviteCompanyToOpentalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteCompanyToOpentalentMutation, InviteCompanyToOpentalentMutationVariables>(InviteCompanyToOpentalentDocument, options);
      }
export type InviteCompanyToOpentalentMutationHookResult = ReturnType<typeof useInviteCompanyToOpentalentMutation>;
export type InviteCompanyToOpentalentMutationResult = Apollo.MutationResult<InviteCompanyToOpentalentMutation>;
export type InviteCompanyToOpentalentMutationOptions = Apollo.BaseMutationOptions<InviteCompanyToOpentalentMutation, InviteCompanyToOpentalentMutationVariables>;
export const GetCompanyViewScreenDataDocument = gql`
    query GetCompanyViewScreenData($id: ID!) {
  company(id: $id) {
    id
    name
    about
    country
    size
    type_of_activity
    address
    website
    logo {
      url
    }
  }
  talentsSearch(
    connection_with_company_id: $id
    first: 3
    is_verification_required: false
  ) {
    custom_paginator_info {
      total
    }
    data {
      talent {
        avatar {
          avatar
        }
      }
    }
  }
  jobs(company_id: $id, first: 1, is_archived: false, is_draft: false) {
    paginatorInfo {
      total
    }
  }
}
    `;

/**
 * __useGetCompanyViewScreenDataQuery__
 *
 * To run a query within a React component, call `useGetCompanyViewScreenDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyViewScreenDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyViewScreenDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyViewScreenDataQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables> & ({ variables: GetCompanyViewScreenDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables>(GetCompanyViewScreenDataDocument, options);
      }
export function useGetCompanyViewScreenDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables>(GetCompanyViewScreenDataDocument, options);
        }
// @ts-ignore
export function useGetCompanyViewScreenDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables>;
export function useGetCompanyViewScreenDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyViewScreenDataQuery | undefined, GetCompanyViewScreenDataQueryVariables>;
export function useGetCompanyViewScreenDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables>(GetCompanyViewScreenDataDocument, options);
        }
export type GetCompanyViewScreenDataQueryHookResult = ReturnType<typeof useGetCompanyViewScreenDataQuery>;
export type GetCompanyViewScreenDataLazyQueryHookResult = ReturnType<typeof useGetCompanyViewScreenDataLazyQuery>;
export type GetCompanyViewScreenDataSuspenseQueryHookResult = ReturnType<typeof useGetCompanyViewScreenDataSuspenseQuery>;
export type GetCompanyViewScreenDataQueryResult = Apollo.QueryResult<GetCompanyViewScreenDataQuery, GetCompanyViewScreenDataQueryVariables>;
export const ExportTalentDataByEmailDocument = gql`
    mutation ExportTalentDataByEmail {
  exportTalentDataByEmail
}
    `;
export type ExportTalentDataByEmailMutationFn = Apollo.MutationFunction<ExportTalentDataByEmailMutation, ExportTalentDataByEmailMutationVariables>;

/**
 * __useExportTalentDataByEmailMutation__
 *
 * To run a mutation, you first call `useExportTalentDataByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTalentDataByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTalentDataByEmailMutation, { data, loading, error }] = useExportTalentDataByEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useExportTalentDataByEmailMutation(baseOptions?: Apollo.MutationHookOptions<ExportTalentDataByEmailMutation, ExportTalentDataByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportTalentDataByEmailMutation, ExportTalentDataByEmailMutationVariables>(ExportTalentDataByEmailDocument, options);
      }
export type ExportTalentDataByEmailMutationHookResult = ReturnType<typeof useExportTalentDataByEmailMutation>;
export type ExportTalentDataByEmailMutationResult = Apollo.MutationResult<ExportTalentDataByEmailMutation>;
export type ExportTalentDataByEmailMutationOptions = Apollo.BaseMutationOptions<ExportTalentDataByEmailMutation, ExportTalentDataByEmailMutationVariables>;
export const GetFeaturedTagsForCompanyDocument = gql`
    query GetFeaturedTagsForCompany($company_id: ID!) {
  featuredTagsByCompany(company_id: $company_id) {
    id
    name
  }
  company(id: $company_id) {
    name
    id
    slug
    region
    logo {
      url
    }
    primary_branding_color
    secondary_branding_color
    onboarding_countries {
      id
      name
    }
  }
}
    `;

/**
 * __useGetFeaturedTagsForCompanyQuery__
 *
 * To run a query within a React component, call `useGetFeaturedTagsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedTagsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedTagsForCompanyQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGetFeaturedTagsForCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables> & ({ variables: GetFeaturedTagsForCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables>(GetFeaturedTagsForCompanyDocument, options);
      }
export function useGetFeaturedTagsForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables>(GetFeaturedTagsForCompanyDocument, options);
        }
// @ts-ignore
export function useGetFeaturedTagsForCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables>;
export function useGetFeaturedTagsForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeaturedTagsForCompanyQuery | undefined, GetFeaturedTagsForCompanyQueryVariables>;
export function useGetFeaturedTagsForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables>(GetFeaturedTagsForCompanyDocument, options);
        }
export type GetFeaturedTagsForCompanyQueryHookResult = ReturnType<typeof useGetFeaturedTagsForCompanyQuery>;
export type GetFeaturedTagsForCompanyLazyQueryHookResult = ReturnType<typeof useGetFeaturedTagsForCompanyLazyQuery>;
export type GetFeaturedTagsForCompanySuspenseQueryHookResult = ReturnType<typeof useGetFeaturedTagsForCompanySuspenseQuery>;
export type GetFeaturedTagsForCompanyQueryResult = Apollo.QueryResult<GetFeaturedTagsForCompanyQuery, GetFeaturedTagsForCompanyQueryVariables>;
export const GetCompanyBySlugDocument = gql`
    query GetCompanyBySlug($slug: String!) {
  companyBySlug(slug: $slug) {
    name
    id
    slug
    region
    logo {
      url
    }
    primary_branding_color
    secondary_branding_color
    onboarding_countries {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCompanyBySlugQuery__
 *
 * To run a query within a React component, call `useGetCompanyBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCompanyBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables> & ({ variables: GetCompanyBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables>(GetCompanyBySlugDocument, options);
      }
export function useGetCompanyBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables>(GetCompanyBySlugDocument, options);
        }
// @ts-ignore
export function useGetCompanyBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables>;
export function useGetCompanyBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyBySlugQuery | undefined, GetCompanyBySlugQueryVariables>;
export function useGetCompanyBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables>(GetCompanyBySlugDocument, options);
        }
export type GetCompanyBySlugQueryHookResult = ReturnType<typeof useGetCompanyBySlugQuery>;
export type GetCompanyBySlugLazyQueryHookResult = ReturnType<typeof useGetCompanyBySlugLazyQuery>;
export type GetCompanyBySlugSuspenseQueryHookResult = ReturnType<typeof useGetCompanyBySlugSuspenseQuery>;
export type GetCompanyBySlugQueryResult = Apollo.QueryResult<GetCompanyBySlugQuery, GetCompanyBySlugQueryVariables>;
export const ExtractDataFromCvDocument = gql`
    mutation ExtractDataFromCv($file: Upload!, $device_id: String!) {
  extractDataFromCv(file: $file, device_id: $device_id) {
    email
  }
}
    `;
export type ExtractDataFromCvMutationFn = Apollo.MutationFunction<ExtractDataFromCvMutation, ExtractDataFromCvMutationVariables>;

/**
 * __useExtractDataFromCvMutation__
 *
 * To run a mutation, you first call `useExtractDataFromCvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractDataFromCvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractDataFromCvMutation, { data, loading, error }] = useExtractDataFromCvMutation({
 *   variables: {
 *      file: // value for 'file'
 *      device_id: // value for 'device_id'
 *   },
 * });
 */
export function useExtractDataFromCvMutation(baseOptions?: Apollo.MutationHookOptions<ExtractDataFromCvMutation, ExtractDataFromCvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtractDataFromCvMutation, ExtractDataFromCvMutationVariables>(ExtractDataFromCvDocument, options);
      }
export type ExtractDataFromCvMutationHookResult = ReturnType<typeof useExtractDataFromCvMutation>;
export type ExtractDataFromCvMutationResult = Apollo.MutationResult<ExtractDataFromCvMutation>;
export type ExtractDataFromCvMutationOptions = Apollo.BaseMutationOptions<ExtractDataFromCvMutation, ExtractDataFromCvMutationVariables>;
export const GetIndustiesListDocument = gql`
    query GetIndustiesList {
  getIndustriesList {
    id
    name
  }
}
    `;

/**
 * __useGetIndustiesListQuery__
 *
 * To run a query within a React component, call `useGetIndustiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustiesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndustiesListQuery(baseOptions?: Apollo.QueryHookOptions<GetIndustiesListQuery, GetIndustiesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustiesListQuery, GetIndustiesListQueryVariables>(GetIndustiesListDocument, options);
      }
export function useGetIndustiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustiesListQuery, GetIndustiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustiesListQuery, GetIndustiesListQueryVariables>(GetIndustiesListDocument, options);
        }
// @ts-ignore
export function useGetIndustiesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustiesListQuery, GetIndustiesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustiesListQuery, GetIndustiesListQueryVariables>;
export function useGetIndustiesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustiesListQuery, GetIndustiesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustiesListQuery | undefined, GetIndustiesListQueryVariables>;
export function useGetIndustiesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustiesListQuery, GetIndustiesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustiesListQuery, GetIndustiesListQueryVariables>(GetIndustiesListDocument, options);
        }
export type GetIndustiesListQueryHookResult = ReturnType<typeof useGetIndustiesListQuery>;
export type GetIndustiesListLazyQueryHookResult = ReturnType<typeof useGetIndustiesListLazyQuery>;
export type GetIndustiesListSuspenseQueryHookResult = ReturnType<typeof useGetIndustiesListSuspenseQuery>;
export type GetIndustiesListQueryResult = Apollo.QueryResult<GetIndustiesListQuery, GetIndustiesListQueryVariables>;
export const GetJobRolesDocument = gql`
    query GetJobRoles {
  getJobRoles {
    id
    name
  }
}
    `;

/**
 * __useGetJobRolesQuery__
 *
 * To run a query within a React component, call `useGetJobRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetJobRolesQuery, GetJobRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobRolesQuery, GetJobRolesQueryVariables>(GetJobRolesDocument, options);
      }
export function useGetJobRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobRolesQuery, GetJobRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobRolesQuery, GetJobRolesQueryVariables>(GetJobRolesDocument, options);
        }
// @ts-ignore
export function useGetJobRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobRolesQuery, GetJobRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobRolesQuery, GetJobRolesQueryVariables>;
export function useGetJobRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobRolesQuery, GetJobRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobRolesQuery | undefined, GetJobRolesQueryVariables>;
export function useGetJobRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobRolesQuery, GetJobRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobRolesQuery, GetJobRolesQueryVariables>(GetJobRolesDocument, options);
        }
export type GetJobRolesQueryHookResult = ReturnType<typeof useGetJobRolesQuery>;
export type GetJobRolesLazyQueryHookResult = ReturnType<typeof useGetJobRolesLazyQuery>;
export type GetJobRolesSuspenseQueryHookResult = ReturnType<typeof useGetJobRolesSuspenseQuery>;
export type GetJobRolesQueryResult = Apollo.QueryResult<GetJobRolesQuery, GetJobRolesQueryVariables>;
export const CreateJobRoleDocument = gql`
    mutation CreateJobRole($name: String!) {
  createJobRole(name: $name) {
    id
    name
  }
}
    `;
export type CreateJobRoleMutationFn = Apollo.MutationFunction<CreateJobRoleMutation, CreateJobRoleMutationVariables>;

/**
 * __useCreateJobRoleMutation__
 *
 * To run a mutation, you first call `useCreateJobRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobRoleMutation, { data, loading, error }] = useCreateJobRoleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateJobRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobRoleMutation, CreateJobRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobRoleMutation, CreateJobRoleMutationVariables>(CreateJobRoleDocument, options);
      }
export type CreateJobRoleMutationHookResult = ReturnType<typeof useCreateJobRoleMutation>;
export type CreateJobRoleMutationResult = Apollo.MutationResult<CreateJobRoleMutation>;
export type CreateJobRoleMutationOptions = Apollo.BaseMutationOptions<CreateJobRoleMutation, CreateJobRoleMutationVariables>;
export const GetOnboardingV2TmpDataDocument = gql`
    query GetOnboardingV2TmpData($email: Email, $device_id: String!) {
  getTempDataItem(email: $email, device_id: $device_id) {
    success
    result {
      email
      device_id
      data
      cv_companies_extraction {
        id
        name
      }
      cv_data_extraction {
        city
        email
        first_name
        last_name
        phone
        state
        zip
        about
      }
      cv_skills_extraction {
        id
        name
        skill_type
      }
    }
  }
}
    `;

/**
 * __useGetOnboardingV2TmpDataQuery__
 *
 * To run a query within a React component, call `useGetOnboardingV2TmpDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingV2TmpDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingV2TmpDataQuery({
 *   variables: {
 *      email: // value for 'email'
 *      device_id: // value for 'device_id'
 *   },
 * });
 */
export function useGetOnboardingV2TmpDataQuery(baseOptions: Apollo.QueryHookOptions<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables> & ({ variables: GetOnboardingV2TmpDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables>(GetOnboardingV2TmpDataDocument, options);
      }
export function useGetOnboardingV2TmpDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables>(GetOnboardingV2TmpDataDocument, options);
        }
// @ts-ignore
export function useGetOnboardingV2TmpDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables>;
export function useGetOnboardingV2TmpDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetOnboardingV2TmpDataQuery | undefined, GetOnboardingV2TmpDataQueryVariables>;
export function useGetOnboardingV2TmpDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables>(GetOnboardingV2TmpDataDocument, options);
        }
export type GetOnboardingV2TmpDataQueryHookResult = ReturnType<typeof useGetOnboardingV2TmpDataQuery>;
export type GetOnboardingV2TmpDataLazyQueryHookResult = ReturnType<typeof useGetOnboardingV2TmpDataLazyQuery>;
export type GetOnboardingV2TmpDataSuspenseQueryHookResult = ReturnType<typeof useGetOnboardingV2TmpDataSuspenseQuery>;
export type GetOnboardingV2TmpDataQueryResult = Apollo.QueryResult<GetOnboardingV2TmpDataQuery, GetOnboardingV2TmpDataQueryVariables>;
export const GetCompanyLogoDocument = gql`
    query GetCompanyLogo($company_id: ID!) {
  company(id: $company_id) {
    name
    id
    region
    primary_branding_color
    secondary_branding_color
    logo {
      url
    }
  }
}
    `;

/**
 * __useGetCompanyLogoQuery__
 *
 * To run a query within a React component, call `useGetCompanyLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLogoQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGetCompanyLogoQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyLogoQuery, GetCompanyLogoQueryVariables> & ({ variables: GetCompanyLogoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLogoQuery, GetCompanyLogoQueryVariables>(GetCompanyLogoDocument, options);
      }
export function useGetCompanyLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLogoQuery, GetCompanyLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLogoQuery, GetCompanyLogoQueryVariables>(GetCompanyLogoDocument, options);
        }
// @ts-ignore
export function useGetCompanyLogoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyLogoQuery, GetCompanyLogoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyLogoQuery, GetCompanyLogoQueryVariables>;
export function useGetCompanyLogoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLogoQuery, GetCompanyLogoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyLogoQuery | undefined, GetCompanyLogoQueryVariables>;
export function useGetCompanyLogoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLogoQuery, GetCompanyLogoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyLogoQuery, GetCompanyLogoQueryVariables>(GetCompanyLogoDocument, options);
        }
export type GetCompanyLogoQueryHookResult = ReturnType<typeof useGetCompanyLogoQuery>;
export type GetCompanyLogoLazyQueryHookResult = ReturnType<typeof useGetCompanyLogoLazyQuery>;
export type GetCompanyLogoSuspenseQueryHookResult = ReturnType<typeof useGetCompanyLogoSuspenseQuery>;
export type GetCompanyLogoQueryResult = Apollo.QueryResult<GetCompanyLogoQuery, GetCompanyLogoQueryVariables>;
export const GetCountiresListDocument = gql`
    query GetCountiresList($is_europe: Boolean, $is_us: Boolean) {
  getCountriesList(is_europe: $is_europe, is_us: $is_us) {
    id
    name
    is_europe
  }
}
    `;

/**
 * __useGetCountiresListQuery__
 *
 * To run a query within a React component, call `useGetCountiresListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountiresListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountiresListQuery({
 *   variables: {
 *      is_europe: // value for 'is_europe'
 *      is_us: // value for 'is_us'
 *   },
 * });
 */
export function useGetCountiresListQuery(baseOptions?: Apollo.QueryHookOptions<GetCountiresListQuery, GetCountiresListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountiresListQuery, GetCountiresListQueryVariables>(GetCountiresListDocument, options);
      }
export function useGetCountiresListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountiresListQuery, GetCountiresListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountiresListQuery, GetCountiresListQueryVariables>(GetCountiresListDocument, options);
        }
// @ts-ignore
export function useGetCountiresListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountiresListQuery, GetCountiresListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountiresListQuery, GetCountiresListQueryVariables>;
export function useGetCountiresListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountiresListQuery, GetCountiresListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountiresListQuery | undefined, GetCountiresListQueryVariables>;
export function useGetCountiresListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountiresListQuery, GetCountiresListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountiresListQuery, GetCountiresListQueryVariables>(GetCountiresListDocument, options);
        }
export type GetCountiresListQueryHookResult = ReturnType<typeof useGetCountiresListQuery>;
export type GetCountiresListLazyQueryHookResult = ReturnType<typeof useGetCountiresListLazyQuery>;
export type GetCountiresListSuspenseQueryHookResult = ReturnType<typeof useGetCountiresListSuspenseQuery>;
export type GetCountiresListQueryResult = Apollo.QueryResult<GetCountiresListQuery, GetCountiresListQueryVariables>;
export const MutateCancelCurrentTalentSubscriptionDocument = gql`
    mutation MutateCancelCurrentTalentSubscription {
  cancelCurrentTalentSubscription {
    current_period_end
  }
}
    `;
export type MutateCancelCurrentTalentSubscriptionMutationFn = Apollo.MutationFunction<MutateCancelCurrentTalentSubscriptionMutation, MutateCancelCurrentTalentSubscriptionMutationVariables>;

/**
 * __useMutateCancelCurrentTalentSubscriptionMutation__
 *
 * To run a mutation, you first call `useMutateCancelCurrentTalentSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateCancelCurrentTalentSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateCancelCurrentTalentSubscriptionMutation, { data, loading, error }] = useMutateCancelCurrentTalentSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useMutateCancelCurrentTalentSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<MutateCancelCurrentTalentSubscriptionMutation, MutateCancelCurrentTalentSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateCancelCurrentTalentSubscriptionMutation, MutateCancelCurrentTalentSubscriptionMutationVariables>(MutateCancelCurrentTalentSubscriptionDocument, options);
      }
export type MutateCancelCurrentTalentSubscriptionMutationHookResult = ReturnType<typeof useMutateCancelCurrentTalentSubscriptionMutation>;
export type MutateCancelCurrentTalentSubscriptionMutationResult = Apollo.MutationResult<MutateCancelCurrentTalentSubscriptionMutation>;
export type MutateCancelCurrentTalentSubscriptionMutationOptions = Apollo.BaseMutationOptions<MutateCancelCurrentTalentSubscriptionMutation, MutateCancelCurrentTalentSubscriptionMutationVariables>;
export const CreateReportDocument = gql`
    mutation CreateReport($reported_talent_id: ID!, $reason: ReportReasonsEnum!, $comment: String) {
  createReport(
    reported_talent_id: $reported_talent_id
    reason: $reason
    comment: $comment
  ) {
    id
    reason
    comment
    created_at
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      reported_talent_id: // value for 'reported_talent_id'
 *      reason: // value for 'reason'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const GetTalentSourcesDocument = gql`
    query GetTalentSources {
  talentSources {
    id
    name
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetTalentSourcesQuery__
 *
 * To run a query within a React component, call `useGetTalentSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTalentSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>(GetTalentSourcesDocument, options);
      }
export function useGetTalentSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>(GetTalentSourcesDocument, options);
        }
// @ts-ignore
export function useGetTalentSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>;
export function useGetTalentSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTalentSourcesQuery | undefined, GetTalentSourcesQueryVariables>;
export function useGetTalentSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>(GetTalentSourcesDocument, options);
        }
export type GetTalentSourcesQueryHookResult = ReturnType<typeof useGetTalentSourcesQuery>;
export type GetTalentSourcesLazyQueryHookResult = ReturnType<typeof useGetTalentSourcesLazyQuery>;
export type GetTalentSourcesSuspenseQueryHookResult = ReturnType<typeof useGetTalentSourcesSuspenseQuery>;
export type GetTalentSourcesQueryResult = Apollo.QueryResult<GetTalentSourcesQuery, GetTalentSourcesQueryVariables>;
export const ChooseJobServiceDocument = gql`
    query ChooseJobService {
  commonAppInfo {
    total_ot_freelancers_count
    total_ot_approved_freelancers_count
    total_ot_recruiters_count
  }
  talentsSearch(source_type: OWN, is_active: true) {
    custom_paginator_info {
      total
    }
  }
}
    `;

/**
 * __useChooseJobServiceQuery__
 *
 * To run a query within a React component, call `useChooseJobServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useChooseJobServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChooseJobServiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useChooseJobServiceQuery(baseOptions?: Apollo.QueryHookOptions<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>(ChooseJobServiceDocument, options);
      }
export function useChooseJobServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>(ChooseJobServiceDocument, options);
        }
// @ts-ignore
export function useChooseJobServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>): Apollo.UseSuspenseQueryResult<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>;
export function useChooseJobServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>): Apollo.UseSuspenseQueryResult<ChooseJobServiceQuery | undefined, ChooseJobServiceQueryVariables>;
export function useChooseJobServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>(ChooseJobServiceDocument, options);
        }
export type ChooseJobServiceQueryHookResult = ReturnType<typeof useChooseJobServiceQuery>;
export type ChooseJobServiceLazyQueryHookResult = ReturnType<typeof useChooseJobServiceLazyQuery>;
export type ChooseJobServiceSuspenseQueryHookResult = ReturnType<typeof useChooseJobServiceSuspenseQuery>;
export type ChooseJobServiceQueryResult = Apollo.QueryResult<ChooseJobServiceQuery, ChooseJobServiceQueryVariables>;
export const GetTalentOnboardingCountriesForCompanyDocument = gql`
    query GetTalentOnboardingCountriesForCompany($company_id: ID!) {
  getTalentOnboardingCountriesForCompany(company_id: $company_id) {
    id
    name
  }
}
    `;

/**
 * __useGetTalentOnboardingCountriesForCompanyQuery__
 *
 * To run a query within a React component, call `useGetTalentOnboardingCountriesForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentOnboardingCountriesForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentOnboardingCountriesForCompanyQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGetTalentOnboardingCountriesForCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables> & ({ variables: GetTalentOnboardingCountriesForCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables>(GetTalentOnboardingCountriesForCompanyDocument, options);
      }
export function useGetTalentOnboardingCountriesForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables>(GetTalentOnboardingCountriesForCompanyDocument, options);
        }
// @ts-ignore
export function useGetTalentOnboardingCountriesForCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables>;
export function useGetTalentOnboardingCountriesForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetTalentOnboardingCountriesForCompanyQuery | undefined, GetTalentOnboardingCountriesForCompanyQueryVariables>;
export function useGetTalentOnboardingCountriesForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables>(GetTalentOnboardingCountriesForCompanyDocument, options);
        }
export type GetTalentOnboardingCountriesForCompanyQueryHookResult = ReturnType<typeof useGetTalentOnboardingCountriesForCompanyQuery>;
export type GetTalentOnboardingCountriesForCompanyLazyQueryHookResult = ReturnType<typeof useGetTalentOnboardingCountriesForCompanyLazyQuery>;
export type GetTalentOnboardingCountriesForCompanySuspenseQueryHookResult = ReturnType<typeof useGetTalentOnboardingCountriesForCompanySuspenseQuery>;
export type GetTalentOnboardingCountriesForCompanyQueryResult = Apollo.QueryResult<GetTalentOnboardingCountriesForCompanyQuery, GetTalentOnboardingCountriesForCompanyQueryVariables>;
export const GetTmpDataDocument = gql`
    query GetTmpData($email: Email, $device_id: String!) {
  getTempDataItem(email: $email, device_id: $device_id) {
    success
    result {
      email
      device_id
      data
    }
  }
}
    `;

/**
 * __useGetTmpDataQuery__
 *
 * To run a query within a React component, call `useGetTmpDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTmpDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTmpDataQuery({
 *   variables: {
 *      email: // value for 'email'
 *      device_id: // value for 'device_id'
 *   },
 * });
 */
export function useGetTmpDataQuery(baseOptions: Apollo.QueryHookOptions<GetTmpDataQuery, GetTmpDataQueryVariables> & ({ variables: GetTmpDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTmpDataQuery, GetTmpDataQueryVariables>(GetTmpDataDocument, options);
      }
export function useGetTmpDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTmpDataQuery, GetTmpDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTmpDataQuery, GetTmpDataQueryVariables>(GetTmpDataDocument, options);
        }
// @ts-ignore
export function useGetTmpDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTmpDataQuery, GetTmpDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetTmpDataQuery, GetTmpDataQueryVariables>;
export function useGetTmpDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTmpDataQuery, GetTmpDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetTmpDataQuery | undefined, GetTmpDataQueryVariables>;
export function useGetTmpDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTmpDataQuery, GetTmpDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTmpDataQuery, GetTmpDataQueryVariables>(GetTmpDataDocument, options);
        }
export type GetTmpDataQueryHookResult = ReturnType<typeof useGetTmpDataQuery>;
export type GetTmpDataLazyQueryHookResult = ReturnType<typeof useGetTmpDataLazyQuery>;
export type GetTmpDataSuspenseQueryHookResult = ReturnType<typeof useGetTmpDataSuspenseQuery>;
export type GetTmpDataQueryResult = Apollo.QueryResult<GetTmpDataQuery, GetTmpDataQueryVariables>;
export const SetTmpDataDocument = gql`
    mutation SetTmpData($email: Email, $device_id: String!, $data: String) {
  setTempDataItem(email: $email, device_id: $device_id, data: $data)
}
    `;
export type SetTmpDataMutationFn = Apollo.MutationFunction<SetTmpDataMutation, SetTmpDataMutationVariables>;

/**
 * __useSetTmpDataMutation__
 *
 * To run a mutation, you first call `useSetTmpDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTmpDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTmpDataMutation, { data, loading, error }] = useSetTmpDataMutation({
 *   variables: {
 *      email: // value for 'email'
 *      device_id: // value for 'device_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetTmpDataMutation(baseOptions?: Apollo.MutationHookOptions<SetTmpDataMutation, SetTmpDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTmpDataMutation, SetTmpDataMutationVariables>(SetTmpDataDocument, options);
      }
export type SetTmpDataMutationHookResult = ReturnType<typeof useSetTmpDataMutation>;
export type SetTmpDataMutationResult = Apollo.MutationResult<SetTmpDataMutation>;
export type SetTmpDataMutationOptions = Apollo.BaseMutationOptions<SetTmpDataMutation, SetTmpDataMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($file_type: FileTypeEnum!, $owner_id: ID, $file: Upload!) {
  uploadFile(file_type: $file_type, owner_id: $owner_id, file: $file) {
    hash
    title
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file_type: // value for 'file_type'
 *      owner_id: // value for 'owner_id'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const CancelCurrentCompanySubscriptionDocument = gql`
    mutation CancelCurrentCompanySubscription {
  cancelCurrentCompanyUserCompanySubscription {
    start_date
    current_period_end
    cancel_at_period_end
  }
}
    `;
export type CancelCurrentCompanySubscriptionMutationFn = Apollo.MutationFunction<CancelCurrentCompanySubscriptionMutation, CancelCurrentCompanySubscriptionMutationVariables>;

/**
 * __useCancelCurrentCompanySubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelCurrentCompanySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCurrentCompanySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCurrentCompanySubscriptionMutation, { data, loading, error }] = useCancelCurrentCompanySubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelCurrentCompanySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelCurrentCompanySubscriptionMutation, CancelCurrentCompanySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCurrentCompanySubscriptionMutation, CancelCurrentCompanySubscriptionMutationVariables>(CancelCurrentCompanySubscriptionDocument, options);
      }
export type CancelCurrentCompanySubscriptionMutationHookResult = ReturnType<typeof useCancelCurrentCompanySubscriptionMutation>;
export type CancelCurrentCompanySubscriptionMutationResult = Apollo.MutationResult<CancelCurrentCompanySubscriptionMutation>;
export type CancelCurrentCompanySubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelCurrentCompanySubscriptionMutation, CancelCurrentCompanySubscriptionMutationVariables>;
export const CheckCompanyUserExistsByEmailDocument = gql`
    query CheckCompanyUserExistsByEmail($email: Email!) {
  checkCompanyUserExistsByEmail(email: $email)
}
    `;

/**
 * __useCheckCompanyUserExistsByEmailQuery__
 *
 * To run a query within a React component, call `useCheckCompanyUserExistsByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCompanyUserExistsByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCompanyUserExistsByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckCompanyUserExistsByEmailQuery(baseOptions: Apollo.QueryHookOptions<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables> & ({ variables: CheckCompanyUserExistsByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables>(CheckCompanyUserExistsByEmailDocument, options);
      }
export function useCheckCompanyUserExistsByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables>(CheckCompanyUserExistsByEmailDocument, options);
        }
// @ts-ignore
export function useCheckCompanyUserExistsByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables>;
export function useCheckCompanyUserExistsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<CheckCompanyUserExistsByEmailQuery | undefined, CheckCompanyUserExistsByEmailQueryVariables>;
export function useCheckCompanyUserExistsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables>(CheckCompanyUserExistsByEmailDocument, options);
        }
export type CheckCompanyUserExistsByEmailQueryHookResult = ReturnType<typeof useCheckCompanyUserExistsByEmailQuery>;
export type CheckCompanyUserExistsByEmailLazyQueryHookResult = ReturnType<typeof useCheckCompanyUserExistsByEmailLazyQuery>;
export type CheckCompanyUserExistsByEmailSuspenseQueryHookResult = ReturnType<typeof useCheckCompanyUserExistsByEmailSuspenseQuery>;
export type CheckCompanyUserExistsByEmailQueryResult = Apollo.QueryResult<CheckCompanyUserExistsByEmailQuery, CheckCompanyUserExistsByEmailQueryVariables>;
export const CreateAnnouncementDocument = gql`
    mutation CreateAnnouncement($text: String, $title: String, $need_response: Boolean!, $talents_ids: [ID]!, $send_email: Boolean, $is_important: Boolean!, $subject: String) {
  createAnnouncement(
    is_important: $is_important
    subject: $subject
    title: $title
    text: $text
    need_response: $need_response
    talents_ids: $talents_ids
    send_email: $send_email
  )
}
    `;
export type CreateAnnouncementMutationFn = Apollo.MutationFunction<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      text: // value for 'text'
 *      title: // value for 'title'
 *      need_response: // value for 'need_response'
 *      talents_ids: // value for 'talents_ids'
 *      send_email: // value for 'send_email'
 *      is_important: // value for 'is_important'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>(CreateAnnouncementDocument, options);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationResult = Apollo.MutationResult<CreateAnnouncementMutation>;
export type CreateAnnouncementMutationOptions = Apollo.BaseMutationOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const CreateCompanyForUserDocument = gql`
    mutation CreateCompanyForUser($name: String!, $address: String, $type_of_activity: String, $website: String, $logo: String, $primary_company_user_id: ID) {
  createCompanyForUser(
    name: $name
    address: $address
    type_of_activity: $type_of_activity
    website: $website
    logo: $logo
    primary_company_user_id: $primary_company_user_id
  ) {
    id
  }
}
    `;
export type CreateCompanyForUserMutationFn = Apollo.MutationFunction<CreateCompanyForUserMutation, CreateCompanyForUserMutationVariables>;

/**
 * __useCreateCompanyForUserMutation__
 *
 * To run a mutation, you first call `useCreateCompanyForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyForUserMutation, { data, loading, error }] = useCreateCompanyForUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      address: // value for 'address'
 *      type_of_activity: // value for 'type_of_activity'
 *      website: // value for 'website'
 *      logo: // value for 'logo'
 *      primary_company_user_id: // value for 'primary_company_user_id'
 *   },
 * });
 */
export function useCreateCompanyForUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyForUserMutation, CreateCompanyForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyForUserMutation, CreateCompanyForUserMutationVariables>(CreateCompanyForUserDocument, options);
      }
export type CreateCompanyForUserMutationHookResult = ReturnType<typeof useCreateCompanyForUserMutation>;
export type CreateCompanyForUserMutationResult = Apollo.MutationResult<CreateCompanyForUserMutation>;
export type CreateCompanyForUserMutationOptions = Apollo.BaseMutationOptions<CreateCompanyForUserMutation, CreateCompanyForUserMutationVariables>;
export const CreateCompanyUserDocument = gql`
    mutation CreateCompanyUser($first_name: String!, $last_name: String!, $email: Email!, $avatar: String, $position: String, $is_primary: Boolean, $onboarding_type: CompanyUserOnboardingTypeEnum, $referral_key: String) {
  createCompanyUserProfile(
    first_name: $first_name
    last_name: $last_name
    email: $email
    position: $position
    avatar: $avatar
    is_primary: $is_primary
    onboarding_type: $onboarding_type
    referral_key: $referral_key
  ) {
    id
  }
}
    `;
export type CreateCompanyUserMutationFn = Apollo.MutationFunction<CreateCompanyUserMutation, CreateCompanyUserMutationVariables>;

/**
 * __useCreateCompanyUserMutation__
 *
 * To run a mutation, you first call `useCreateCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyUserMutation, { data, loading, error }] = useCreateCompanyUserMutation({
 *   variables: {
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      email: // value for 'email'
 *      avatar: // value for 'avatar'
 *      position: // value for 'position'
 *      is_primary: // value for 'is_primary'
 *      onboarding_type: // value for 'onboarding_type'
 *      referral_key: // value for 'referral_key'
 *   },
 * });
 */
export function useCreateCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyUserMutation, CreateCompanyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyUserMutation, CreateCompanyUserMutationVariables>(CreateCompanyUserDocument, options);
      }
export type CreateCompanyUserMutationHookResult = ReturnType<typeof useCreateCompanyUserMutation>;
export type CreateCompanyUserMutationResult = Apollo.MutationResult<CreateCompanyUserMutation>;
export type CreateCompanyUserMutationOptions = Apollo.BaseMutationOptions<CreateCompanyUserMutation, CreateCompanyUserMutationVariables>;
export const CurrentCompanySubscriptionDocument = gql`
    query CurrentCompanySubscription {
  currentCompanyUserCompanySubscription {
    start_date
    current_period_end
    cancel_at_period_end
  }
}
    `;

/**
 * __useCurrentCompanySubscriptionQuery__
 *
 * To run a query within a React component, call `useCurrentCompanySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentCompanySubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentCompanySubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentCompanySubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>(CurrentCompanySubscriptionDocument, options);
      }
export function useCurrentCompanySubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>(CurrentCompanySubscriptionDocument, options);
        }
// @ts-ignore
export function useCurrentCompanySubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>;
export function useCurrentCompanySubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentCompanySubscriptionQuery | undefined, CurrentCompanySubscriptionQueryVariables>;
export function useCurrentCompanySubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>(CurrentCompanySubscriptionDocument, options);
        }
export type CurrentCompanySubscriptionQueryHookResult = ReturnType<typeof useCurrentCompanySubscriptionQuery>;
export type CurrentCompanySubscriptionLazyQueryHookResult = ReturnType<typeof useCurrentCompanySubscriptionLazyQuery>;
export type CurrentCompanySubscriptionSuspenseQueryHookResult = ReturnType<typeof useCurrentCompanySubscriptionSuspenseQuery>;
export type CurrentCompanySubscriptionQueryResult = Apollo.QueryResult<CurrentCompanySubscriptionQuery, CurrentCompanySubscriptionQueryVariables>;
export const GetCurrentUserCompanyTagsDocument = gql`
    query GetCurrentUserCompanyTags {
  currentUserCompanyTags {
    name
    id
  }
}
    `;

/**
 * __useGetCurrentUserCompanyTagsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserCompanyTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserCompanyTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserCompanyTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserCompanyTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>(GetCurrentUserCompanyTagsDocument, options);
      }
export function useGetCurrentUserCompanyTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>(GetCurrentUserCompanyTagsDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserCompanyTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>;
export function useGetCurrentUserCompanyTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserCompanyTagsQuery | undefined, GetCurrentUserCompanyTagsQueryVariables>;
export function useGetCurrentUserCompanyTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>(GetCurrentUserCompanyTagsDocument, options);
        }
export type GetCurrentUserCompanyTagsQueryHookResult = ReturnType<typeof useGetCurrentUserCompanyTagsQuery>;
export type GetCurrentUserCompanyTagsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserCompanyTagsLazyQuery>;
export type GetCurrentUserCompanyTagsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserCompanyTagsSuspenseQuery>;
export type GetCurrentUserCompanyTagsQueryResult = Apollo.QueryResult<GetCurrentUserCompanyTagsQuery, GetCurrentUserCompanyTagsQueryVariables>;
export const GetPaymentLinkForCompanyDocument = gql`
    query GetPaymentLinkForCompany($primary_user_id: ID) {
  getPaymentLinkForCompany(primary_user_id: $primary_user_id)
}
    `;

/**
 * __useGetPaymentLinkForCompanyQuery__
 *
 * To run a query within a React component, call `useGetPaymentLinkForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLinkForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentLinkForCompanyQuery({
 *   variables: {
 *      primary_user_id: // value for 'primary_user_id'
 *   },
 * });
 */
export function useGetPaymentLinkForCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>(GetPaymentLinkForCompanyDocument, options);
      }
export function useGetPaymentLinkForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>(GetPaymentLinkForCompanyDocument, options);
        }
// @ts-ignore
export function useGetPaymentLinkForCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>;
export function useGetPaymentLinkForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentLinkForCompanyQuery | undefined, GetPaymentLinkForCompanyQueryVariables>;
export function useGetPaymentLinkForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>(GetPaymentLinkForCompanyDocument, options);
        }
export type GetPaymentLinkForCompanyQueryHookResult = ReturnType<typeof useGetPaymentLinkForCompanyQuery>;
export type GetPaymentLinkForCompanyLazyQueryHookResult = ReturnType<typeof useGetPaymentLinkForCompanyLazyQuery>;
export type GetPaymentLinkForCompanySuspenseQueryHookResult = ReturnType<typeof useGetPaymentLinkForCompanySuspenseQuery>;
export type GetPaymentLinkForCompanyQueryResult = Apollo.QueryResult<GetPaymentLinkForCompanyQuery, GetPaymentLinkForCompanyQueryVariables>;
export const InviteCompanyUserDocument = gql`
    mutation InviteCompanyUser($email: Email!) {
  inviteCompanyUser(email: $email)
}
    `;
export type InviteCompanyUserMutationFn = Apollo.MutationFunction<InviteCompanyUserMutation, InviteCompanyUserMutationVariables>;

/**
 * __useInviteCompanyUserMutation__
 *
 * To run a mutation, you first call `useInviteCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCompanyUserMutation, { data, loading, error }] = useInviteCompanyUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInviteCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteCompanyUserMutation, InviteCompanyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteCompanyUserMutation, InviteCompanyUserMutationVariables>(InviteCompanyUserDocument, options);
      }
export type InviteCompanyUserMutationHookResult = ReturnType<typeof useInviteCompanyUserMutation>;
export type InviteCompanyUserMutationResult = Apollo.MutationResult<InviteCompanyUserMutation>;
export type InviteCompanyUserMutationOptions = Apollo.BaseMutationOptions<InviteCompanyUserMutation, InviteCompanyUserMutationVariables>;
export const RenewCurrentCompanySubscriptionDocument = gql`
    mutation RenewCurrentCompanySubscription {
  renewCurrentCompanyUserCompanySubscription {
    start_date
    current_period_end
    cancel_at_period_end
  }
}
    `;
export type RenewCurrentCompanySubscriptionMutationFn = Apollo.MutationFunction<RenewCurrentCompanySubscriptionMutation, RenewCurrentCompanySubscriptionMutationVariables>;

/**
 * __useRenewCurrentCompanySubscriptionMutation__
 *
 * To run a mutation, you first call `useRenewCurrentCompanySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewCurrentCompanySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewCurrentCompanySubscriptionMutation, { data, loading, error }] = useRenewCurrentCompanySubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useRenewCurrentCompanySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RenewCurrentCompanySubscriptionMutation, RenewCurrentCompanySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewCurrentCompanySubscriptionMutation, RenewCurrentCompanySubscriptionMutationVariables>(RenewCurrentCompanySubscriptionDocument, options);
      }
export type RenewCurrentCompanySubscriptionMutationHookResult = ReturnType<typeof useRenewCurrentCompanySubscriptionMutation>;
export type RenewCurrentCompanySubscriptionMutationResult = Apollo.MutationResult<RenewCurrentCompanySubscriptionMutation>;
export type RenewCurrentCompanySubscriptionMutationOptions = Apollo.BaseMutationOptions<RenewCurrentCompanySubscriptionMutation, RenewCurrentCompanySubscriptionMutationVariables>;
export const UpdateCompanyUserEmailDocument = gql`
    mutation UpdateCompanyUserEmail($email: Email!) {
  updateCompanyUserEmail(email: $email)
}
    `;
export type UpdateCompanyUserEmailMutationFn = Apollo.MutationFunction<UpdateCompanyUserEmailMutation, UpdateCompanyUserEmailMutationVariables>;

/**
 * __useUpdateCompanyUserEmailMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyUserEmailMutation, { data, loading, error }] = useUpdateCompanyUserEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateCompanyUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyUserEmailMutation, UpdateCompanyUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyUserEmailMutation, UpdateCompanyUserEmailMutationVariables>(UpdateCompanyUserEmailDocument, options);
      }
export type UpdateCompanyUserEmailMutationHookResult = ReturnType<typeof useUpdateCompanyUserEmailMutation>;
export type UpdateCompanyUserEmailMutationResult = Apollo.MutationResult<UpdateCompanyUserEmailMutation>;
export type UpdateCompanyUserEmailMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyUserEmailMutation, UpdateCompanyUserEmailMutationVariables>;
export const UpdateCompanyUserDocument = gql`
    mutation UpdateCompanyUser($company_user_id: ID!, $first_name: String, $last_name: String, $email: Email, $position: String, $avatar: String) {
  updateCompanyUserProfile(
    company_user_id: $company_user_id
    first_name: $first_name
    last_name: $last_name
    email: $email
    position: $position
    avatar: $avatar
  ) {
    id
  }
}
    `;
export type UpdateCompanyUserMutationFn = Apollo.MutationFunction<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>;

/**
 * __useUpdateCompanyUserMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyUserMutation, { data, loading, error }] = useUpdateCompanyUserMutation({
 *   variables: {
 *      company_user_id: // value for 'company_user_id'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      email: // value for 'email'
 *      position: // value for 'position'
 *      avatar: // value for 'avatar'
 *   },
 * });
 */
export function useUpdateCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>(UpdateCompanyUserDocument, options);
      }
export type UpdateCompanyUserMutationHookResult = ReturnType<typeof useUpdateCompanyUserMutation>;
export type UpdateCompanyUserMutationResult = Apollo.MutationResult<UpdateCompanyUserMutation>;
export type UpdateCompanyUserMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>;
export const CreateTalentInvitationDocument = gql`
    mutation CreateTalentInvitation($inviter_talent_id: ID, $inviter_company_user_id: ID, $email: String!, $first_name: String, $last_name: String, $tags_ids: [ID!]) {
  createInvitation(
    inviter_talent_id: $inviter_talent_id
    tags_ids: $tags_ids
    inviter_company_user_id: $inviter_company_user_id
    email: $email
    first_name: $first_name
    last_name: $last_name
  ) {
    id
    uid
    is_accepted
    email
    first_name
    last_name
    uid
    is_accepted
    talent_inviter {
      id
      first_name_abac {
        value
      }
      last_name_abac {
        value
      }
      email_abac {
        value
      }
      is_invitation_accepted
      avatar {
        avatar
      }
    }
    company_user_inviter {
      id
      first_name
      last_name
      email
    }
    created_at
  }
}
    `;
export type CreateTalentInvitationMutationFn = Apollo.MutationFunction<CreateTalentInvitationMutation, CreateTalentInvitationMutationVariables>;

/**
 * __useCreateTalentInvitationMutation__
 *
 * To run a mutation, you first call `useCreateTalentInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTalentInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTalentInvitationMutation, { data, loading, error }] = useCreateTalentInvitationMutation({
 *   variables: {
 *      inviter_talent_id: // value for 'inviter_talent_id'
 *      inviter_company_user_id: // value for 'inviter_company_user_id'
 *      email: // value for 'email'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      tags_ids: // value for 'tags_ids'
 *   },
 * });
 */
export function useCreateTalentInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTalentInvitationMutation, CreateTalentInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTalentInvitationMutation, CreateTalentInvitationMutationVariables>(CreateTalentInvitationDocument, options);
      }
export type CreateTalentInvitationMutationHookResult = ReturnType<typeof useCreateTalentInvitationMutation>;
export type CreateTalentInvitationMutationResult = Apollo.MutationResult<CreateTalentInvitationMutation>;
export type CreateTalentInvitationMutationOptions = Apollo.BaseMutationOptions<CreateTalentInvitationMutation, CreateTalentInvitationMutationVariables>;
export const ResendInvitationDocument = gql`
    mutation ResendInvitation($id: ID!) {
  resendInvitation(id: $id)
}
    `;
export type ResendInvitationMutationFn = Apollo.MutationFunction<ResendInvitationMutation, ResendInvitationMutationVariables>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationMutation, ResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationMutation, ResendInvitationMutationVariables>(ResendInvitationDocument, options);
      }
export type ResendInvitationMutationHookResult = ReturnType<typeof useResendInvitationMutation>;
export type ResendInvitationMutationResult = Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const CancelInvitationDocument = gql`
    mutation CancelInvitation($id: ID!) {
  cancelInvitation(id: $id)
}
    `;
export type CancelInvitationMutationFn = Apollo.MutationFunction<CancelInvitationMutation, CancelInvitationMutationVariables>;

/**
 * __useCancelInvitationMutation__
 *
 * To run a mutation, you first call `useCancelInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInvitationMutation, { data, loading, error }] = useCancelInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CancelInvitationMutation, CancelInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelInvitationMutation, CancelInvitationMutationVariables>(CancelInvitationDocument, options);
      }
export type CancelInvitationMutationHookResult = ReturnType<typeof useCancelInvitationMutation>;
export type CancelInvitationMutationResult = Apollo.MutationResult<CancelInvitationMutation>;
export type CancelInvitationMutationOptions = Apollo.BaseMutationOptions<CancelInvitationMutation, CancelInvitationMutationVariables>;
export const CurrentTalentInvitationsDocument = gql`
    query CurrentTalentInvitations {
  currentTalentInvitations {
    id
    uid
    talent {
      id
      first_name_abac {
        value
      }
      last_name_abac {
        value
      }
      email_abac {
        value
      }
      is_invitation_accepted
      avatar {
        avatar
      }
    }
    email
    is_accepted
    first_name
    last_name
    talent_inviter {
      id
      first_name_abac {
        value
      }
      last_name_abac {
        value
      }
      email_abac {
        value
      }
      is_invitation_accepted
      avatar {
        avatar
      }
    }
    company_user_inviter {
      id
      first_name
      last_name
      email
    }
    created_at
  }
}
    `;

/**
 * __useCurrentTalentInvitationsQuery__
 *
 * To run a query within a React component, call `useCurrentTalentInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTalentInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentTalentInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentTalentInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>(CurrentTalentInvitationsDocument, options);
      }
export function useCurrentTalentInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>(CurrentTalentInvitationsDocument, options);
        }
// @ts-ignore
export function useCurrentTalentInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>;
export function useCurrentTalentInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentTalentInvitationsQuery | undefined, CurrentTalentInvitationsQueryVariables>;
export function useCurrentTalentInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>(CurrentTalentInvitationsDocument, options);
        }
export type CurrentTalentInvitationsQueryHookResult = ReturnType<typeof useCurrentTalentInvitationsQuery>;
export type CurrentTalentInvitationsLazyQueryHookResult = ReturnType<typeof useCurrentTalentInvitationsLazyQuery>;
export type CurrentTalentInvitationsSuspenseQueryHookResult = ReturnType<typeof useCurrentTalentInvitationsSuspenseQuery>;
export type CurrentTalentInvitationsQueryResult = Apollo.QueryResult<CurrentTalentInvitationsQuery, CurrentTalentInvitationsQueryVariables>;
export const ApplyForJobDocument = gql`
    mutation ApplyForJob($job_application_data: JobApplicationInput!) {
  applyForJob(job_application_data: $job_application_data)
}
    `;
export type ApplyForJobMutationFn = Apollo.MutationFunction<ApplyForJobMutation, ApplyForJobMutationVariables>;

/**
 * __useApplyForJobMutation__
 *
 * To run a mutation, you first call `useApplyForJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyForJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyForJobMutation, { data, loading, error }] = useApplyForJobMutation({
 *   variables: {
 *      job_application_data: // value for 'job_application_data'
 *   },
 * });
 */
export function useApplyForJobMutation(baseOptions?: Apollo.MutationHookOptions<ApplyForJobMutation, ApplyForJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyForJobMutation, ApplyForJobMutationVariables>(ApplyForJobDocument, options);
      }
export type ApplyForJobMutationHookResult = ReturnType<typeof useApplyForJobMutation>;
export type ApplyForJobMutationResult = Apollo.MutationResult<ApplyForJobMutation>;
export type ApplyForJobMutationOptions = Apollo.BaseMutationOptions<ApplyForJobMutation, ApplyForJobMutationVariables>;
export const ChangeSuggestingStatusForJobMatchDocument = gql`
    mutation ChangeSuggestingStatusForJobMatch($job_match_id: ID!, $new_suggesting_stage: SuggestingStageEnum!, $message: String) {
  changeSuggestingStatusForJobMatch(
    job_match_id: $job_match_id
    new_suggesting_stage: $new_suggesting_stage
    message: $message
  )
}
    `;
export type ChangeSuggestingStatusForJobMatchMutationFn = Apollo.MutationFunction<ChangeSuggestingStatusForJobMatchMutation, ChangeSuggestingStatusForJobMatchMutationVariables>;

/**
 * __useChangeSuggestingStatusForJobMatchMutation__
 *
 * To run a mutation, you first call `useChangeSuggestingStatusForJobMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSuggestingStatusForJobMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSuggestingStatusForJobMatchMutation, { data, loading, error }] = useChangeSuggestingStatusForJobMatchMutation({
 *   variables: {
 *      job_match_id: // value for 'job_match_id'
 *      new_suggesting_stage: // value for 'new_suggesting_stage'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useChangeSuggestingStatusForJobMatchMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSuggestingStatusForJobMatchMutation, ChangeSuggestingStatusForJobMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSuggestingStatusForJobMatchMutation, ChangeSuggestingStatusForJobMatchMutationVariables>(ChangeSuggestingStatusForJobMatchDocument, options);
      }
export type ChangeSuggestingStatusForJobMatchMutationHookResult = ReturnType<typeof useChangeSuggestingStatusForJobMatchMutation>;
export type ChangeSuggestingStatusForJobMatchMutationResult = Apollo.MutationResult<ChangeSuggestingStatusForJobMatchMutation>;
export type ChangeSuggestingStatusForJobMatchMutationOptions = Apollo.BaseMutationOptions<ChangeSuggestingStatusForJobMatchMutation, ChangeSuggestingStatusForJobMatchMutationVariables>;
export const CreateJobSuggestionDocument = gql`
    mutation CreateJobSuggestion($job_id: ID!, $first_name: String!, $last_name: String, $email: String!, $cv_attachment: String, $motivation_letter_attachment: String, $screening_questionnaire_attachment: String) {
  createJobSuggestion(
    job_id: $job_id
    first_name: $first_name
    email: $email
    last_name: $last_name
    cv_attachment: $cv_attachment
    motivation_letter_attachment: $motivation_letter_attachment
    screening_questionnaire_attachment: $screening_questionnaire_attachment
  )
}
    `;
export type CreateJobSuggestionMutationFn = Apollo.MutationFunction<CreateJobSuggestionMutation, CreateJobSuggestionMutationVariables>;

/**
 * __useCreateJobSuggestionMutation__
 *
 * To run a mutation, you first call `useCreateJobSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobSuggestionMutation, { data, loading, error }] = useCreateJobSuggestionMutation({
 *   variables: {
 *      job_id: // value for 'job_id'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      email: // value for 'email'
 *      cv_attachment: // value for 'cv_attachment'
 *      motivation_letter_attachment: // value for 'motivation_letter_attachment'
 *      screening_questionnaire_attachment: // value for 'screening_questionnaire_attachment'
 *   },
 * });
 */
export function useCreateJobSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobSuggestionMutation, CreateJobSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobSuggestionMutation, CreateJobSuggestionMutationVariables>(CreateJobSuggestionDocument, options);
      }
export type CreateJobSuggestionMutationHookResult = ReturnType<typeof useCreateJobSuggestionMutation>;
export type CreateJobSuggestionMutationResult = Apollo.MutationResult<CreateJobSuggestionMutation>;
export type CreateJobSuggestionMutationOptions = Apollo.BaseMutationOptions<CreateJobSuggestionMutation, CreateJobSuggestionMutationVariables>;
export const CreateNewJobDocument = gql`
    mutation CreateNewJob($name: String!, $category_id: ID, $subcategory_id: ID, $description: String!, $pitch: String, $start_date: DateTimeUtc, $end_date: DateTimeUtc, $rate_min: Float, $rate_max: Float, $is_rate_negotiable: Boolean, $salary_min: Float, $salary_max: Float, $is_salary_negotiable: Boolean, $max_project_budget: Float, $finders_fee: Float, $campaign_owner_id: ID!, $campaign_start_date: DateTimeUtc!, $campaign_end_date: DateTimeUtc!, $campaign_talent_pool: [SourceTypeEnum], $permanent_capacity_type: PermanentJobCapacityTypeEnum, $is_archived: Boolean, $skills: [ID], $skills_boolean_filter: TalentsBooleanSkillsFilterInput, $solutions_required: [ID], $hard_skills_required: [ID], $hours_per_week: Int, $location_type: JobLocationTypeEnum, $type: JobTypeEnum, $location: String, $country: String, $city: String, $client: String, $is_remote_an_option: Boolean, $is_draft: Boolean, $office_hours_per_month: Float) {
  createJob(
    permanent_capacity_type: $permanent_capacity_type
    office_hours_per_month: $office_hours_per_month
    is_draft: $is_draft
    name: $name
    category_id: $category_id
    subcategory_id: $subcategory_id
    description: $description
    pitch: $pitch
    start_date: $start_date
    end_date: $end_date
    rate_min: $rate_min
    rate_max: $rate_max
    is_rate_negotiable: $is_rate_negotiable
    salary_min: $salary_min
    salary_max: $salary_max
    is_salary_negotiable: $is_salary_negotiable
    max_project_budget: $max_project_budget
    finders_fee: $finders_fee
    campaign_owner_id: $campaign_owner_id
    campaign_start_date: $campaign_start_date
    campaign_end_date: $campaign_end_date
    campaign_talent_pool: $campaign_talent_pool
    is_archived: $is_archived
    skills: $skills
    skills_boolean_filter: $skills_boolean_filter
    is_remote_an_option: $is_remote_an_option
    solutions_required: $solutions_required
    hard_skills_required: $hard_skills_required
    hours_per_week: $hours_per_week
    location_type: $location_type
    type: $type
    location: $location
    country: $country
    city: $city
    client: $client
  )
}
    `;
export type CreateNewJobMutationFn = Apollo.MutationFunction<CreateNewJobMutation, CreateNewJobMutationVariables>;

/**
 * __useCreateNewJobMutation__
 *
 * To run a mutation, you first call `useCreateNewJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewJobMutation, { data, loading, error }] = useCreateNewJobMutation({
 *   variables: {
 *      name: // value for 'name'
 *      category_id: // value for 'category_id'
 *      subcategory_id: // value for 'subcategory_id'
 *      description: // value for 'description'
 *      pitch: // value for 'pitch'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      rate_min: // value for 'rate_min'
 *      rate_max: // value for 'rate_max'
 *      is_rate_negotiable: // value for 'is_rate_negotiable'
 *      salary_min: // value for 'salary_min'
 *      salary_max: // value for 'salary_max'
 *      is_salary_negotiable: // value for 'is_salary_negotiable'
 *      max_project_budget: // value for 'max_project_budget'
 *      finders_fee: // value for 'finders_fee'
 *      campaign_owner_id: // value for 'campaign_owner_id'
 *      campaign_start_date: // value for 'campaign_start_date'
 *      campaign_end_date: // value for 'campaign_end_date'
 *      campaign_talent_pool: // value for 'campaign_talent_pool'
 *      permanent_capacity_type: // value for 'permanent_capacity_type'
 *      is_archived: // value for 'is_archived'
 *      skills: // value for 'skills'
 *      skills_boolean_filter: // value for 'skills_boolean_filter'
 *      solutions_required: // value for 'solutions_required'
 *      hard_skills_required: // value for 'hard_skills_required'
 *      hours_per_week: // value for 'hours_per_week'
 *      location_type: // value for 'location_type'
 *      type: // value for 'type'
 *      location: // value for 'location'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *      client: // value for 'client'
 *      is_remote_an_option: // value for 'is_remote_an_option'
 *      is_draft: // value for 'is_draft'
 *      office_hours_per_month: // value for 'office_hours_per_month'
 *   },
 * });
 */
export function useCreateNewJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewJobMutation, CreateNewJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewJobMutation, CreateNewJobMutationVariables>(CreateNewJobDocument, options);
      }
export type CreateNewJobMutationHookResult = ReturnType<typeof useCreateNewJobMutation>;
export type CreateNewJobMutationResult = Apollo.MutationResult<CreateNewJobMutation>;
export type CreateNewJobMutationOptions = Apollo.BaseMutationOptions<CreateNewJobMutation, CreateNewJobMutationVariables>;
export const GetPotentialTalentsCountDocument = gql`
    query GetPotentialTalentsCount($type: JobTypeEnum!, $category_id: ID, $subcategory_id: ID, $start_date: DateTimeUtc, $end_date: DateTimeUtc, $rate_min: Float, $rate_max: Float, $salary_min: Float, $salary_max: Float, $campaign_start_date: DateTimeUtc, $campaign_end_date: DateTimeUtc, $campaign_talent_pool: [SourceTypeEnum], $skills: [ID], $skills_boolean_filter: TalentsBooleanSkillsFilterInput, $solutions_required: [ID], $hard_skills_required: [ID], $hours_per_week: Int, $location_type: JobLocationTypeEnum, $is_remote_an_option: Boolean, $country: String, $office_hours_per_month: Float, $campaign_owner_id: ID) {
  potentialTalentsForJobCount(
    type: $type
    campaign_owner_id: $campaign_owner_id
    category_id: $category_id
    subcategory_id: $subcategory_id
    start_date: $start_date
    end_date: $end_date
    rate_min: $rate_min
    rate_max: $rate_max
    salary_min: $salary_min
    salary_max: $salary_max
    campaign_start_date: $campaign_start_date
    campaign_end_date: $campaign_end_date
    campaign_talent_pool: $campaign_talent_pool
    skills: $skills
    skills_boolean_filter: $skills_boolean_filter
    solutions_required: $solutions_required
    hard_skills_required: $hard_skills_required
    hours_per_week: $hours_per_week
    location_type: $location_type
    is_remote_an_option: $is_remote_an_option
    country: $country
    office_hours_per_month: $office_hours_per_month
  )
}
    `;

/**
 * __useGetPotentialTalentsCountQuery__
 *
 * To run a query within a React component, call `useGetPotentialTalentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPotentialTalentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPotentialTalentsCountQuery({
 *   variables: {
 *      type: // value for 'type'
 *      category_id: // value for 'category_id'
 *      subcategory_id: // value for 'subcategory_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      rate_min: // value for 'rate_min'
 *      rate_max: // value for 'rate_max'
 *      salary_min: // value for 'salary_min'
 *      salary_max: // value for 'salary_max'
 *      campaign_start_date: // value for 'campaign_start_date'
 *      campaign_end_date: // value for 'campaign_end_date'
 *      campaign_talent_pool: // value for 'campaign_talent_pool'
 *      skills: // value for 'skills'
 *      skills_boolean_filter: // value for 'skills_boolean_filter'
 *      solutions_required: // value for 'solutions_required'
 *      hard_skills_required: // value for 'hard_skills_required'
 *      hours_per_week: // value for 'hours_per_week'
 *      location_type: // value for 'location_type'
 *      is_remote_an_option: // value for 'is_remote_an_option'
 *      country: // value for 'country'
 *      office_hours_per_month: // value for 'office_hours_per_month'
 *      campaign_owner_id: // value for 'campaign_owner_id'
 *   },
 * });
 */
export function useGetPotentialTalentsCountQuery(baseOptions: Apollo.QueryHookOptions<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables> & ({ variables: GetPotentialTalentsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables>(GetPotentialTalentsCountDocument, options);
      }
export function useGetPotentialTalentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables>(GetPotentialTalentsCountDocument, options);
        }
// @ts-ignore
export function useGetPotentialTalentsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables>;
export function useGetPotentialTalentsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetPotentialTalentsCountQuery | undefined, GetPotentialTalentsCountQueryVariables>;
export function useGetPotentialTalentsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables>(GetPotentialTalentsCountDocument, options);
        }
export type GetPotentialTalentsCountQueryHookResult = ReturnType<typeof useGetPotentialTalentsCountQuery>;
export type GetPotentialTalentsCountLazyQueryHookResult = ReturnType<typeof useGetPotentialTalentsCountLazyQuery>;
export type GetPotentialTalentsCountSuspenseQueryHookResult = ReturnType<typeof useGetPotentialTalentsCountSuspenseQuery>;
export type GetPotentialTalentsCountQueryResult = Apollo.QueryResult<GetPotentialTalentsCountQuery, GetPotentialTalentsCountQueryVariables>;
export const MarkNewJobMatchesAsReadDocument = gql`
    mutation MarkNewJobMatchesAsRead($job_matches_ids: [ID]) {
  markNewJobMatchesAsRead(job_matches_ids: $job_matches_ids)
}
    `;
export type MarkNewJobMatchesAsReadMutationFn = Apollo.MutationFunction<MarkNewJobMatchesAsReadMutation, MarkNewJobMatchesAsReadMutationVariables>;

/**
 * __useMarkNewJobMatchesAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNewJobMatchesAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNewJobMatchesAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNewJobMatchesAsReadMutation, { data, loading, error }] = useMarkNewJobMatchesAsReadMutation({
 *   variables: {
 *      job_matches_ids: // value for 'job_matches_ids'
 *   },
 * });
 */
export function useMarkNewJobMatchesAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNewJobMatchesAsReadMutation, MarkNewJobMatchesAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNewJobMatchesAsReadMutation, MarkNewJobMatchesAsReadMutationVariables>(MarkNewJobMatchesAsReadDocument, options);
      }
export type MarkNewJobMatchesAsReadMutationHookResult = ReturnType<typeof useMarkNewJobMatchesAsReadMutation>;
export type MarkNewJobMatchesAsReadMutationResult = Apollo.MutationResult<MarkNewJobMatchesAsReadMutation>;
export type MarkNewJobMatchesAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNewJobMatchesAsReadMutation, MarkNewJobMatchesAsReadMutationVariables>;
export const SubmitJobToBroadbeanDocument = gql`
    mutation SubmitJobToBroadbean($job_id: ID!) {
  submitJobToBroadbean(job_id: $job_id) {
    broadbean_url
  }
}
    `;
export type SubmitJobToBroadbeanMutationFn = Apollo.MutationFunction<SubmitJobToBroadbeanMutation, SubmitJobToBroadbeanMutationVariables>;

/**
 * __useSubmitJobToBroadbeanMutation__
 *
 * To run a mutation, you first call `useSubmitJobToBroadbeanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitJobToBroadbeanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitJobToBroadbeanMutation, { data, loading, error }] = useSubmitJobToBroadbeanMutation({
 *   variables: {
 *      job_id: // value for 'job_id'
 *   },
 * });
 */
export function useSubmitJobToBroadbeanMutation(baseOptions?: Apollo.MutationHookOptions<SubmitJobToBroadbeanMutation, SubmitJobToBroadbeanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitJobToBroadbeanMutation, SubmitJobToBroadbeanMutationVariables>(SubmitJobToBroadbeanDocument, options);
      }
export type SubmitJobToBroadbeanMutationHookResult = ReturnType<typeof useSubmitJobToBroadbeanMutation>;
export type SubmitJobToBroadbeanMutationResult = Apollo.MutationResult<SubmitJobToBroadbeanMutation>;
export type SubmitJobToBroadbeanMutationOptions = Apollo.BaseMutationOptions<SubmitJobToBroadbeanMutation, SubmitJobToBroadbeanMutationVariables>;
export const UpdateJobDocument = gql`
    mutation UpdateJob($id: ID!, $service_type: JobServiceTypeEnum, $name: String, $category_id: ID, $description: String, $pitch: String, $start_date: DateTimeUtc, $end_date: DateTimeUtc, $rate_min: Float, $rate_max: Float, $is_rate_negotiable: Boolean, $salary_min: Float, $salary_max: Float, $is_salary_negotiable: Boolean, $max_project_budget: Float, $finders_fee: Float, $campaign_owner_id: ID, $campaign_start_date: DateTimeUtc!, $campaign_end_date: DateTimeUtc!, $campaign_talent_pool: [SourceTypeEnum], $skills_boolean_filter: TalentsBooleanSkillsFilterInput, $is_archived: Boolean, $skills: [ID], $solutions_required: [ID], $hard_skills_required: [ID], $hours_per_week: Int, $location_type: JobLocationTypeEnum, $type: JobTypeEnum, $location: String, $country: String, $city: String, $client: String, $is_remote_an_option: Boolean, $is_draft: Boolean, $office_hours_per_month: Float) {
  updateJob(
    service_type: $service_type
    skills_boolean_filter: $skills_boolean_filter
    office_hours_per_month: $office_hours_per_month
    is_draft: $is_draft
    id: $id
    name: $name
    category_id: $category_id
    description: $description
    pitch: $pitch
    start_date: $start_date
    end_date: $end_date
    rate_min: $rate_min
    rate_max: $rate_max
    is_remote_an_option: $is_remote_an_option
    is_rate_negotiable: $is_rate_negotiable
    salary_min: $salary_min
    salary_max: $salary_max
    is_salary_negotiable: $is_salary_negotiable
    max_project_budget: $max_project_budget
    finders_fee: $finders_fee
    campaign_owner_id: $campaign_owner_id
    campaign_start_date: $campaign_start_date
    campaign_end_date: $campaign_end_date
    campaign_talent_pool: $campaign_talent_pool
    is_archived: $is_archived
    skills: $skills
    solutions_required: $solutions_required
    hard_skills_required: $hard_skills_required
    hours_per_week: $hours_per_week
    location_type: $location_type
    type: $type
    location: $location
    country: $country
    city: $city
    client: $client
  ) {
    id
  }
}
    `;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      service_type: // value for 'service_type'
 *      name: // value for 'name'
 *      category_id: // value for 'category_id'
 *      description: // value for 'description'
 *      pitch: // value for 'pitch'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      rate_min: // value for 'rate_min'
 *      rate_max: // value for 'rate_max'
 *      is_rate_negotiable: // value for 'is_rate_negotiable'
 *      salary_min: // value for 'salary_min'
 *      salary_max: // value for 'salary_max'
 *      is_salary_negotiable: // value for 'is_salary_negotiable'
 *      max_project_budget: // value for 'max_project_budget'
 *      finders_fee: // value for 'finders_fee'
 *      campaign_owner_id: // value for 'campaign_owner_id'
 *      campaign_start_date: // value for 'campaign_start_date'
 *      campaign_end_date: // value for 'campaign_end_date'
 *      campaign_talent_pool: // value for 'campaign_talent_pool'
 *      skills_boolean_filter: // value for 'skills_boolean_filter'
 *      is_archived: // value for 'is_archived'
 *      skills: // value for 'skills'
 *      solutions_required: // value for 'solutions_required'
 *      hard_skills_required: // value for 'hard_skills_required'
 *      hours_per_week: // value for 'hours_per_week'
 *      location_type: // value for 'location_type'
 *      type: // value for 'type'
 *      location: // value for 'location'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *      client: // value for 'client'
 *      is_remote_an_option: // value for 'is_remote_an_option'
 *      is_draft: // value for 'is_draft'
 *      office_hours_per_month: // value for 'office_hours_per_month'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const GetCompaniesLandingDataDocument = gql`
    query GetCompaniesLandingData {
  commonAppInfo {
    total_ot_freelancers_count
    total_ot_freelancers_countries_count
    total_unique_skills_count
    total_unique_companies_count
    total_ot_recruiters_count
    total_ot_approved_freelancers_count
  }
  talentsCountByCategories {
    name
    slug
    talents_count
  }
}
    `;

/**
 * __useGetCompaniesLandingDataQuery__
 *
 * To run a query within a React component, call `useGetCompaniesLandingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesLandingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesLandingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompaniesLandingDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>(GetCompaniesLandingDataDocument, options);
      }
export function useGetCompaniesLandingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>(GetCompaniesLandingDataDocument, options);
        }
// @ts-ignore
export function useGetCompaniesLandingDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>;
export function useGetCompaniesLandingDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompaniesLandingDataQuery | undefined, GetCompaniesLandingDataQueryVariables>;
export function useGetCompaniesLandingDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>(GetCompaniesLandingDataDocument, options);
        }
export type GetCompaniesLandingDataQueryHookResult = ReturnType<typeof useGetCompaniesLandingDataQuery>;
export type GetCompaniesLandingDataLazyQueryHookResult = ReturnType<typeof useGetCompaniesLandingDataLazyQuery>;
export type GetCompaniesLandingDataSuspenseQueryHookResult = ReturnType<typeof useGetCompaniesLandingDataSuspenseQuery>;
export type GetCompaniesLandingDataQueryResult = Apollo.QueryResult<GetCompaniesLandingDataQuery, GetCompaniesLandingDataQueryVariables>;
export const SearchSkillsDocument = gql`
    query SearchSkills($search: String!, $skill_type: [SkillTypeEnum]!) {
  skillSearch(search: $search, skill_type: $skill_type) {
    id
    skill_type
    name
    slug
    created_at
    updated_at
  }
}
    `;

/**
 * __useSearchSkillsQuery__
 *
 * To run a query within a React component, call `useSearchSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSkillsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      skill_type: // value for 'skill_type'
 *   },
 * });
 */
export function useSearchSkillsQuery(baseOptions: Apollo.QueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables> & ({ variables: SearchSkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSkillsQuery, SearchSkillsQueryVariables>(SearchSkillsDocument, options);
      }
export function useSearchSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSkillsQuery, SearchSkillsQueryVariables>(SearchSkillsDocument, options);
        }
// @ts-ignore
export function useSearchSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchSkillsQuery, SearchSkillsQueryVariables>;
export function useSearchSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchSkillsQuery | undefined, SearchSkillsQueryVariables>;
export function useSearchSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSkillsQuery, SearchSkillsQueryVariables>(SearchSkillsDocument, options);
        }
export type SearchSkillsQueryHookResult = ReturnType<typeof useSearchSkillsQuery>;
export type SearchSkillsLazyQueryHookResult = ReturnType<typeof useSearchSkillsLazyQuery>;
export type SearchSkillsSuspenseQueryHookResult = ReturnType<typeof useSearchSkillsSuspenseQuery>;
export type SearchSkillsQueryResult = Apollo.QueryResult<SearchSkillsQuery, SearchSkillsQueryVariables>;
export const CreateSmsDocument = gql`
    mutation CreateSMS($company_id: ID!, $talent_id: ID!, $content: String) {
  createSMS(company_id: $company_id, talent_id: $talent_id, content: $content) {
    id
    content
    created_at
    delivered_at
    status
    sender_type
    error_message
    talent_phone_number
    vonage_message_id
    vonage_status
    user_id
    talent_id
    company_id
  }
}
    `;
export type CreateSmsMutationFn = Apollo.MutationFunction<CreateSmsMutation, CreateSmsMutationVariables>;

/**
 * __useCreateSmsMutation__
 *
 * To run a mutation, you first call `useCreateSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSmsMutation, { data, loading, error }] = useCreateSmsMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      talent_id: // value for 'talent_id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateSmsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSmsMutation, CreateSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSmsMutation, CreateSmsMutationVariables>(CreateSmsDocument, options);
      }
export type CreateSmsMutationHookResult = ReturnType<typeof useCreateSmsMutation>;
export type CreateSmsMutationResult = Apollo.MutationResult<CreateSmsMutation>;
export type CreateSmsMutationOptions = Apollo.BaseMutationOptions<CreateSmsMutation, CreateSmsMutationVariables>;
export const GetAllSmsConversationsDocument = gql`
    query GetAllSMSConversations($company_id: ID!, $first: Int = 20, $page: Int, $search: String, $sort: SMSSortEnum, $direction: SMSSortDirectionEnum) {
  getAllSMSConversations(
    company_id: $company_id
    first: $first
    page: $page
    search: $search
    sort: $sort
    direction: $direction
  ) {
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      talent {
        id
        first_name_abac {
          value
        }
        last_name_abac {
          value
        }
        avatar {
          avatar
        }
        talent_data {
          phone
        }
      }
      last_sms {
        id
        content
        created_at
        delivered_at
        status
        sender_type
        error_message
        talent_phone_number
        company_id
        talent_id
        user_id
      }
    }
  }
}
    `;

/**
 * __useGetAllSmsConversationsQuery__
 *
 * To run a query within a React component, call `useGetAllSmsConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSmsConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSmsConversationsQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useGetAllSmsConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables> & ({ variables: GetAllSmsConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables>(GetAllSmsConversationsDocument, options);
      }
export function useGetAllSmsConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables>(GetAllSmsConversationsDocument, options);
        }
// @ts-ignore
export function useGetAllSmsConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables>;
export function useGetAllSmsConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllSmsConversationsQuery | undefined, GetAllSmsConversationsQueryVariables>;
export function useGetAllSmsConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables>(GetAllSmsConversationsDocument, options);
        }
export type GetAllSmsConversationsQueryHookResult = ReturnType<typeof useGetAllSmsConversationsQuery>;
export type GetAllSmsConversationsLazyQueryHookResult = ReturnType<typeof useGetAllSmsConversationsLazyQuery>;
export type GetAllSmsConversationsSuspenseQueryHookResult = ReturnType<typeof useGetAllSmsConversationsSuspenseQuery>;
export type GetAllSmsConversationsQueryResult = Apollo.QueryResult<GetAllSmsConversationsQuery, GetAllSmsConversationsQueryVariables>;
export const GetTalentSmsConversationDocument = gql`
    query GetTalentSMSConversation($company_id: ID!, $talent_id: ID!, $first: Int = 50, $page: Int, $sort: SMSSortEnum, $direction: SMSSortDirectionEnum) {
  getTalentSMSConversation(
    company_id: $company_id
    talent_id: $talent_id
    first: $first
    page: $page
    sort: $sort
    direction: $direction
  ) {
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      id
      content
      created_at
      delivered_at
      status
      sender_type
      error_message
      talent_phone_number
      vonage_message_id
      vonage_status
      user_id
      talent_id
      company_id
    }
  }
}
    `;

/**
 * __useGetTalentSmsConversationQuery__
 *
 * To run a query within a React component, call `useGetTalentSmsConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentSmsConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentSmsConversationQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      talent_id: // value for 'talent_id'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useGetTalentSmsConversationQuery(baseOptions: Apollo.QueryHookOptions<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables> & ({ variables: GetTalentSmsConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables>(GetTalentSmsConversationDocument, options);
      }
export function useGetTalentSmsConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables>(GetTalentSmsConversationDocument, options);
        }
// @ts-ignore
export function useGetTalentSmsConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables>;
export function useGetTalentSmsConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GetTalentSmsConversationQuery | undefined, GetTalentSmsConversationQueryVariables>;
export function useGetTalentSmsConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables>(GetTalentSmsConversationDocument, options);
        }
export type GetTalentSmsConversationQueryHookResult = ReturnType<typeof useGetTalentSmsConversationQuery>;
export type GetTalentSmsConversationLazyQueryHookResult = ReturnType<typeof useGetTalentSmsConversationLazyQuery>;
export type GetTalentSmsConversationSuspenseQueryHookResult = ReturnType<typeof useGetTalentSmsConversationSuspenseQuery>;
export type GetTalentSmsConversationQueryResult = Apollo.QueryResult<GetTalentSmsConversationQuery, GetTalentSmsConversationQueryVariables>;
export const CancelCurrentTalentSubscriptionDocument = gql`
    mutation CancelCurrentTalentSubscription {
  cancelCurrentTalentSubscription {
    start_date
    current_period_end
    cancel_at_period_end
  }
}
    `;
export type CancelCurrentTalentSubscriptionMutationFn = Apollo.MutationFunction<CancelCurrentTalentSubscriptionMutation, CancelCurrentTalentSubscriptionMutationVariables>;

/**
 * __useCancelCurrentTalentSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelCurrentTalentSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCurrentTalentSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCurrentTalentSubscriptionMutation, { data, loading, error }] = useCancelCurrentTalentSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelCurrentTalentSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelCurrentTalentSubscriptionMutation, CancelCurrentTalentSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCurrentTalentSubscriptionMutation, CancelCurrentTalentSubscriptionMutationVariables>(CancelCurrentTalentSubscriptionDocument, options);
      }
export type CancelCurrentTalentSubscriptionMutationHookResult = ReturnType<typeof useCancelCurrentTalentSubscriptionMutation>;
export type CancelCurrentTalentSubscriptionMutationResult = Apollo.MutationResult<CancelCurrentTalentSubscriptionMutation>;
export type CancelCurrentTalentSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelCurrentTalentSubscriptionMutation, CancelCurrentTalentSubscriptionMutationVariables>;
export const CheckTalentExistsByEmailDocument = gql`
    query CheckTalentExistsByEmail($talent_email: Email!) {
  checkTalentExistsByEmail(talent_email: $talent_email)
}
    `;

/**
 * __useCheckTalentExistsByEmailQuery__
 *
 * To run a query within a React component, call `useCheckTalentExistsByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTalentExistsByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTalentExistsByEmailQuery({
 *   variables: {
 *      talent_email: // value for 'talent_email'
 *   },
 * });
 */
export function useCheckTalentExistsByEmailQuery(baseOptions: Apollo.QueryHookOptions<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables> & ({ variables: CheckTalentExistsByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables>(CheckTalentExistsByEmailDocument, options);
      }
export function useCheckTalentExistsByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables>(CheckTalentExistsByEmailDocument, options);
        }
// @ts-ignore
export function useCheckTalentExistsByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables>;
export function useCheckTalentExistsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<CheckTalentExistsByEmailQuery | undefined, CheckTalentExistsByEmailQueryVariables>;
export function useCheckTalentExistsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables>(CheckTalentExistsByEmailDocument, options);
        }
export type CheckTalentExistsByEmailQueryHookResult = ReturnType<typeof useCheckTalentExistsByEmailQuery>;
export type CheckTalentExistsByEmailLazyQueryHookResult = ReturnType<typeof useCheckTalentExistsByEmailLazyQuery>;
export type CheckTalentExistsByEmailSuspenseQueryHookResult = ReturnType<typeof useCheckTalentExistsByEmailSuspenseQuery>;
export type CheckTalentExistsByEmailQueryResult = Apollo.QueryResult<CheckTalentExistsByEmailQuery, CheckTalentExistsByEmailQueryVariables>;
export const CreateTalentProfileDocument = gql`
    mutation CreateTalentProfile($email: Email!, $general_info: TalentGeneralInfoInput!, $tags_ids: [ID!], $is_ot_pool: Boolean, $job_application_data: JobApplicationInput) {
  createTalentProfile(
    email: $email
    job_application_data: $job_application_data
    general_info: $general_info
    tags_ids: $tags_ids
    is_ot_pool: $is_ot_pool
  )
}
    `;
export type CreateTalentProfileMutationFn = Apollo.MutationFunction<CreateTalentProfileMutation, CreateTalentProfileMutationVariables>;

/**
 * __useCreateTalentProfileMutation__
 *
 * To run a mutation, you first call `useCreateTalentProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTalentProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTalentProfileMutation, { data, loading, error }] = useCreateTalentProfileMutation({
 *   variables: {
 *      email: // value for 'email'
 *      general_info: // value for 'general_info'
 *      tags_ids: // value for 'tags_ids'
 *      is_ot_pool: // value for 'is_ot_pool'
 *      job_application_data: // value for 'job_application_data'
 *   },
 * });
 */
export function useCreateTalentProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateTalentProfileMutation, CreateTalentProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTalentProfileMutation, CreateTalentProfileMutationVariables>(CreateTalentProfileDocument, options);
      }
export type CreateTalentProfileMutationHookResult = ReturnType<typeof useCreateTalentProfileMutation>;
export type CreateTalentProfileMutationResult = Apollo.MutationResult<CreateTalentProfileMutation>;
export type CreateTalentProfileMutationOptions = Apollo.BaseMutationOptions<CreateTalentProfileMutation, CreateTalentProfileMutationVariables>;
export const CurrentTalentSubscriptionDocument = gql`
    query CurrentTalentSubscription {
  currentTalentSubscription {
    start_date
    current_period_end
    cancel_at_period_end
  }
}
    `;

/**
 * __useCurrentTalentSubscriptionQuery__
 *
 * To run a query within a React component, call `useCurrentTalentSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTalentSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentTalentSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentTalentSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>(CurrentTalentSubscriptionDocument, options);
      }
export function useCurrentTalentSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>(CurrentTalentSubscriptionDocument, options);
        }
// @ts-ignore
export function useCurrentTalentSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>;
export function useCurrentTalentSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentTalentSubscriptionQuery | undefined, CurrentTalentSubscriptionQueryVariables>;
export function useCurrentTalentSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>(CurrentTalentSubscriptionDocument, options);
        }
export type CurrentTalentSubscriptionQueryHookResult = ReturnType<typeof useCurrentTalentSubscriptionQuery>;
export type CurrentTalentSubscriptionLazyQueryHookResult = ReturnType<typeof useCurrentTalentSubscriptionLazyQuery>;
export type CurrentTalentSubscriptionSuspenseQueryHookResult = ReturnType<typeof useCurrentTalentSubscriptionSuspenseQuery>;
export type CurrentTalentSubscriptionQueryResult = Apollo.QueryResult<CurrentTalentSubscriptionQuery, CurrentTalentSubscriptionQueryVariables>;
export const GetPaymentLinkForTalentDocument = gql`
    query GetPaymentLinkForTalent($talent_id: ID) {
  getPaymentLinkForTalent(talent_id: $talent_id)
}
    `;

/**
 * __useGetPaymentLinkForTalentQuery__
 *
 * To run a query within a React component, call `useGetPaymentLinkForTalentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLinkForTalentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentLinkForTalentQuery({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *   },
 * });
 */
export function useGetPaymentLinkForTalentQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>(GetPaymentLinkForTalentDocument, options);
      }
export function useGetPaymentLinkForTalentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>(GetPaymentLinkForTalentDocument, options);
        }
// @ts-ignore
export function useGetPaymentLinkForTalentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>;
export function useGetPaymentLinkForTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentLinkForTalentQuery | undefined, GetPaymentLinkForTalentQueryVariables>;
export function useGetPaymentLinkForTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>(GetPaymentLinkForTalentDocument, options);
        }
export type GetPaymentLinkForTalentQueryHookResult = ReturnType<typeof useGetPaymentLinkForTalentQuery>;
export type GetPaymentLinkForTalentLazyQueryHookResult = ReturnType<typeof useGetPaymentLinkForTalentLazyQuery>;
export type GetPaymentLinkForTalentSuspenseQueryHookResult = ReturnType<typeof useGetPaymentLinkForTalentSuspenseQuery>;
export type GetPaymentLinkForTalentQueryResult = Apollo.QueryResult<GetPaymentLinkForTalentQuery, GetPaymentLinkForTalentQueryVariables>;
export const GetPaymentLinkForMatcherDocument = gql`
    query GetPaymentLinkForMatcher($talent_id: ID, $is_hr_onboarding: Boolean) {
  getPaymentLinkForMatcher(
    talent_id: $talent_id
    is_hr_onboarding: $is_hr_onboarding
  )
}
    `;

/**
 * __useGetPaymentLinkForMatcherQuery__
 *
 * To run a query within a React component, call `useGetPaymentLinkForMatcherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLinkForMatcherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentLinkForMatcherQuery({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *      is_hr_onboarding: // value for 'is_hr_onboarding'
 *   },
 * });
 */
export function useGetPaymentLinkForMatcherQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>(GetPaymentLinkForMatcherDocument, options);
      }
export function useGetPaymentLinkForMatcherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>(GetPaymentLinkForMatcherDocument, options);
        }
// @ts-ignore
export function useGetPaymentLinkForMatcherSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>;
export function useGetPaymentLinkForMatcherSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentLinkForMatcherQuery | undefined, GetPaymentLinkForMatcherQueryVariables>;
export function useGetPaymentLinkForMatcherSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>(GetPaymentLinkForMatcherDocument, options);
        }
export type GetPaymentLinkForMatcherQueryHookResult = ReturnType<typeof useGetPaymentLinkForMatcherQuery>;
export type GetPaymentLinkForMatcherLazyQueryHookResult = ReturnType<typeof useGetPaymentLinkForMatcherLazyQuery>;
export type GetPaymentLinkForMatcherSuspenseQueryHookResult = ReturnType<typeof useGetPaymentLinkForMatcherSuspenseQuery>;
export type GetPaymentLinkForMatcherQueryResult = Apollo.QueryResult<GetPaymentLinkForMatcherQuery, GetPaymentLinkForMatcherQueryVariables>;
export const GetPaymentLinkForRecruiterDocument = gql`
    query GetPaymentLinkForRecruiter($talent_id: ID, $is_hr_onboarding: Boolean) {
  getPaymentLinkForRecruiter(
    talent_id: $talent_id
    is_hr_onboarding: $is_hr_onboarding
  )
}
    `;

/**
 * __useGetPaymentLinkForRecruiterQuery__
 *
 * To run a query within a React component, call `useGetPaymentLinkForRecruiterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLinkForRecruiterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentLinkForRecruiterQuery({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *      is_hr_onboarding: // value for 'is_hr_onboarding'
 *   },
 * });
 */
export function useGetPaymentLinkForRecruiterQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>(GetPaymentLinkForRecruiterDocument, options);
      }
export function useGetPaymentLinkForRecruiterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>(GetPaymentLinkForRecruiterDocument, options);
        }
// @ts-ignore
export function useGetPaymentLinkForRecruiterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>;
export function useGetPaymentLinkForRecruiterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentLinkForRecruiterQuery | undefined, GetPaymentLinkForRecruiterQueryVariables>;
export function useGetPaymentLinkForRecruiterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>(GetPaymentLinkForRecruiterDocument, options);
        }
export type GetPaymentLinkForRecruiterQueryHookResult = ReturnType<typeof useGetPaymentLinkForRecruiterQuery>;
export type GetPaymentLinkForRecruiterLazyQueryHookResult = ReturnType<typeof useGetPaymentLinkForRecruiterLazyQuery>;
export type GetPaymentLinkForRecruiterSuspenseQueryHookResult = ReturnType<typeof useGetPaymentLinkForRecruiterSuspenseQuery>;
export type GetPaymentLinkForRecruiterQueryResult = Apollo.QueryResult<GetPaymentLinkForRecruiterQuery, GetPaymentLinkForRecruiterQueryVariables>;
export const GetTypeformPaymentLinkCodeForMatcherDocument = gql`
    query GetTypeformPaymentLinkCodeForMatcher($talent_id: ID) {
  getTypeformPaymentLinkCodeForMatcher(talent_id: $talent_id)
}
    `;

/**
 * __useGetTypeformPaymentLinkCodeForMatcherQuery__
 *
 * To run a query within a React component, call `useGetTypeformPaymentLinkCodeForMatcherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTypeformPaymentLinkCodeForMatcherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTypeformPaymentLinkCodeForMatcherQuery({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *   },
 * });
 */
export function useGetTypeformPaymentLinkCodeForMatcherQuery(baseOptions?: Apollo.QueryHookOptions<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>(GetTypeformPaymentLinkCodeForMatcherDocument, options);
      }
export function useGetTypeformPaymentLinkCodeForMatcherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>(GetTypeformPaymentLinkCodeForMatcherDocument, options);
        }
// @ts-ignore
export function useGetTypeformPaymentLinkCodeForMatcherSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>): Apollo.UseSuspenseQueryResult<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>;
export function useGetTypeformPaymentLinkCodeForMatcherSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>): Apollo.UseSuspenseQueryResult<GetTypeformPaymentLinkCodeForMatcherQuery | undefined, GetTypeformPaymentLinkCodeForMatcherQueryVariables>;
export function useGetTypeformPaymentLinkCodeForMatcherSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>(GetTypeformPaymentLinkCodeForMatcherDocument, options);
        }
export type GetTypeformPaymentLinkCodeForMatcherQueryHookResult = ReturnType<typeof useGetTypeformPaymentLinkCodeForMatcherQuery>;
export type GetTypeformPaymentLinkCodeForMatcherLazyQueryHookResult = ReturnType<typeof useGetTypeformPaymentLinkCodeForMatcherLazyQuery>;
export type GetTypeformPaymentLinkCodeForMatcherSuspenseQueryHookResult = ReturnType<typeof useGetTypeformPaymentLinkCodeForMatcherSuspenseQuery>;
export type GetTypeformPaymentLinkCodeForMatcherQueryResult = Apollo.QueryResult<GetTypeformPaymentLinkCodeForMatcherQuery, GetTypeformPaymentLinkCodeForMatcherQueryVariables>;
export const SubmitTalentAsFreeMatcherDocument = gql`
    mutation SubmitTalentAsFreeMatcher($talent_id: ID!) {
  submitTalentAsFreeMatcher(talent_id: $talent_id)
}
    `;
export type SubmitTalentAsFreeMatcherMutationFn = Apollo.MutationFunction<SubmitTalentAsFreeMatcherMutation, SubmitTalentAsFreeMatcherMutationVariables>;

/**
 * __useSubmitTalentAsFreeMatcherMutation__
 *
 * To run a mutation, you first call `useSubmitTalentAsFreeMatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTalentAsFreeMatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTalentAsFreeMatcherMutation, { data, loading, error }] = useSubmitTalentAsFreeMatcherMutation({
 *   variables: {
 *      talent_id: // value for 'talent_id'
 *   },
 * });
 */
export function useSubmitTalentAsFreeMatcherMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTalentAsFreeMatcherMutation, SubmitTalentAsFreeMatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTalentAsFreeMatcherMutation, SubmitTalentAsFreeMatcherMutationVariables>(SubmitTalentAsFreeMatcherDocument, options);
      }
export type SubmitTalentAsFreeMatcherMutationHookResult = ReturnType<typeof useSubmitTalentAsFreeMatcherMutation>;
export type SubmitTalentAsFreeMatcherMutationResult = Apollo.MutationResult<SubmitTalentAsFreeMatcherMutation>;
export type SubmitTalentAsFreeMatcherMutationOptions = Apollo.BaseMutationOptions<SubmitTalentAsFreeMatcherMutation, SubmitTalentAsFreeMatcherMutationVariables>;
export const NotifyTalentAboutJobMatchDocument = gql`
    mutation NotifyTalentAboutJobMatch($match_id: ID!) {
  notifyTalentAboutJobMatch(match_id: $match_id)
}
    `;
export type NotifyTalentAboutJobMatchMutationFn = Apollo.MutationFunction<NotifyTalentAboutJobMatchMutation, NotifyTalentAboutJobMatchMutationVariables>;

/**
 * __useNotifyTalentAboutJobMatchMutation__
 *
 * To run a mutation, you first call `useNotifyTalentAboutJobMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyTalentAboutJobMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyTalentAboutJobMatchMutation, { data, loading, error }] = useNotifyTalentAboutJobMatchMutation({
 *   variables: {
 *      match_id: // value for 'match_id'
 *   },
 * });
 */
export function useNotifyTalentAboutJobMatchMutation(baseOptions?: Apollo.MutationHookOptions<NotifyTalentAboutJobMatchMutation, NotifyTalentAboutJobMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyTalentAboutJobMatchMutation, NotifyTalentAboutJobMatchMutationVariables>(NotifyTalentAboutJobMatchDocument, options);
      }
export type NotifyTalentAboutJobMatchMutationHookResult = ReturnType<typeof useNotifyTalentAboutJobMatchMutation>;
export type NotifyTalentAboutJobMatchMutationResult = Apollo.MutationResult<NotifyTalentAboutJobMatchMutation>;
export type NotifyTalentAboutJobMatchMutationOptions = Apollo.BaseMutationOptions<NotifyTalentAboutJobMatchMutation, NotifyTalentAboutJobMatchMutationVariables>;
export const RenewCurrentTalentSubscriptionDocument = gql`
    mutation RenewCurrentTalentSubscription {
  renewCurrentTalentSubscription {
    start_date
    current_period_end
    cancel_at_period_end
  }
}
    `;
export type RenewCurrentTalentSubscriptionMutationFn = Apollo.MutationFunction<RenewCurrentTalentSubscriptionMutation, RenewCurrentTalentSubscriptionMutationVariables>;

/**
 * __useRenewCurrentTalentSubscriptionMutation__
 *
 * To run a mutation, you first call `useRenewCurrentTalentSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewCurrentTalentSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewCurrentTalentSubscriptionMutation, { data, loading, error }] = useRenewCurrentTalentSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useRenewCurrentTalentSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RenewCurrentTalentSubscriptionMutation, RenewCurrentTalentSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewCurrentTalentSubscriptionMutation, RenewCurrentTalentSubscriptionMutationVariables>(RenewCurrentTalentSubscriptionDocument, options);
      }
export type RenewCurrentTalentSubscriptionMutationHookResult = ReturnType<typeof useRenewCurrentTalentSubscriptionMutation>;
export type RenewCurrentTalentSubscriptionMutationResult = Apollo.MutationResult<RenewCurrentTalentSubscriptionMutation>;
export type RenewCurrentTalentSubscriptionMutationOptions = Apollo.BaseMutationOptions<RenewCurrentTalentSubscriptionMutation, RenewCurrentTalentSubscriptionMutationVariables>;
export const SearchTalentsDocument = gql`
    query SearchTalents($search: String, $category_ids: [ID], $skills_ids: [ID], $max_rate: Float, $min_rate: Float, $source_type: SourceTypeEnum, $is_active: Boolean, $is_verification_required: Boolean, $first: Int = 10, $page: Int, $available_now: Boolean, $skills_boolean_filter: TalentsBooleanSkillsFilterInput) {
  talentsSearch(
    search_string: $search
    category_ids: $category_ids
    skills_ids: $skills_ids
    max_rate: $max_rate
    min_rate: $min_rate
    source_type: $source_type
    is_active: $is_active
    first: $first
    available_now: $available_now
    page: $page
    is_verification_required: $is_verification_required
    skills_boolean_filter: $skills_boolean_filter
  ) {
    custom_paginator_info {
      current_page
      last_page
      per_page
      total
    }
    data {
      highlights {
        source
        text
      }
      talent {
        id
        reminded_at
        created_at
        is_invitation_accepted
        is_verification_required
        first_name_abac {
          value
        }
        last_name_abac {
          value
        }
        address
        rate
        currency
        recent_position_title
        email_abac {
          value
        }
        available_now
        location
        is_ot_pool
        source {
          id
        }
        avatar {
          avatar
        }
        talent_data {
          phone
        }
      }
    }
  }
}
    `;

/**
 * __useSearchTalentsQuery__
 *
 * To run a query within a React component, call `useSearchTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTalentsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      category_ids: // value for 'category_ids'
 *      skills_ids: // value for 'skills_ids'
 *      max_rate: // value for 'max_rate'
 *      min_rate: // value for 'min_rate'
 *      source_type: // value for 'source_type'
 *      is_active: // value for 'is_active'
 *      is_verification_required: // value for 'is_verification_required'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      available_now: // value for 'available_now'
 *      skills_boolean_filter: // value for 'skills_boolean_filter'
 *   },
 * });
 */
export function useSearchTalentsQuery(baseOptions?: Apollo.QueryHookOptions<SearchTalentsQuery, SearchTalentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTalentsQuery, SearchTalentsQueryVariables>(SearchTalentsDocument, options);
      }
export function useSearchTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTalentsQuery, SearchTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTalentsQuery, SearchTalentsQueryVariables>(SearchTalentsDocument, options);
        }
// @ts-ignore
export function useSearchTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTalentsQuery, SearchTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTalentsQuery, SearchTalentsQueryVariables>;
export function useSearchTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTalentsQuery, SearchTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTalentsQuery | undefined, SearchTalentsQueryVariables>;
export function useSearchTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTalentsQuery, SearchTalentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTalentsQuery, SearchTalentsQueryVariables>(SearchTalentsDocument, options);
        }
export type SearchTalentsQueryHookResult = ReturnType<typeof useSearchTalentsQuery>;
export type SearchTalentsLazyQueryHookResult = ReturnType<typeof useSearchTalentsLazyQuery>;
export type SearchTalentsSuspenseQueryHookResult = ReturnType<typeof useSearchTalentsSuspenseQuery>;
export type SearchTalentsQueryResult = Apollo.QueryResult<SearchTalentsQuery, SearchTalentsQueryVariables>;
export const SearchTalentsToSendMessageDocument = gql`
    query SearchTalentsToSendMessage($category_ids: [ID], $source_type: SourceTypeEnum, $first: Int = 1000, $page: Int, $tags_ids: [ID], $country: String, $zip_codes: [String], $connection_with_company_id: ID, $is_active: Boolean, $is_static: Boolean, $is_active_or_static: Boolean) {
  talentsSearch(
    category_ids: $category_ids
    source_type: $source_type
    first: $first
    country: $country
    page: $page
    tags_ids: $tags_ids
    is_active: $is_active
    is_static: $is_static
    is_active_or_static: $is_active_or_static
    is_verification_required: false
    zip_codes: $zip_codes
    connection_with_company_id: $connection_with_company_id
  ) {
    data {
      talent {
        id
      }
    }
  }
}
    `;

/**
 * __useSearchTalentsToSendMessageQuery__
 *
 * To run a query within a React component, call `useSearchTalentsToSendMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTalentsToSendMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTalentsToSendMessageQuery({
 *   variables: {
 *      category_ids: // value for 'category_ids'
 *      source_type: // value for 'source_type'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      tags_ids: // value for 'tags_ids'
 *      country: // value for 'country'
 *      zip_codes: // value for 'zip_codes'
 *      connection_with_company_id: // value for 'connection_with_company_id'
 *      is_active: // value for 'is_active'
 *      is_static: // value for 'is_static'
 *      is_active_or_static: // value for 'is_active_or_static'
 *   },
 * });
 */
export function useSearchTalentsToSendMessageQuery(baseOptions?: Apollo.QueryHookOptions<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>(SearchTalentsToSendMessageDocument, options);
      }
export function useSearchTalentsToSendMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>(SearchTalentsToSendMessageDocument, options);
        }
// @ts-ignore
export function useSearchTalentsToSendMessageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>;
export function useSearchTalentsToSendMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTalentsToSendMessageQuery | undefined, SearchTalentsToSendMessageQueryVariables>;
export function useSearchTalentsToSendMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>(SearchTalentsToSendMessageDocument, options);
        }
export type SearchTalentsToSendMessageQueryHookResult = ReturnType<typeof useSearchTalentsToSendMessageQuery>;
export type SearchTalentsToSendMessageLazyQueryHookResult = ReturnType<typeof useSearchTalentsToSendMessageLazyQuery>;
export type SearchTalentsToSendMessageSuspenseQueryHookResult = ReturnType<typeof useSearchTalentsToSendMessageSuspenseQuery>;
export type SearchTalentsToSendMessageQueryResult = Apollo.QueryResult<SearchTalentsToSendMessageQuery, SearchTalentsToSendMessageQueryVariables>;
export const SelfDeleteTalentProfilePermanentlyDocument = gql`
    mutation SelfDeleteTalentProfilePermanently {
  selfDeleteTalentProfilePermanently
}
    `;
export type SelfDeleteTalentProfilePermanentlyMutationFn = Apollo.MutationFunction<SelfDeleteTalentProfilePermanentlyMutation, SelfDeleteTalentProfilePermanentlyMutationVariables>;

/**
 * __useSelfDeleteTalentProfilePermanentlyMutation__
 *
 * To run a mutation, you first call `useSelfDeleteTalentProfilePermanentlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfDeleteTalentProfilePermanentlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfDeleteTalentProfilePermanentlyMutation, { data, loading, error }] = useSelfDeleteTalentProfilePermanentlyMutation({
 *   variables: {
 *   },
 * });
 */
export function useSelfDeleteTalentProfilePermanentlyMutation(baseOptions?: Apollo.MutationHookOptions<SelfDeleteTalentProfilePermanentlyMutation, SelfDeleteTalentProfilePermanentlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfDeleteTalentProfilePermanentlyMutation, SelfDeleteTalentProfilePermanentlyMutationVariables>(SelfDeleteTalentProfilePermanentlyDocument, options);
      }
export type SelfDeleteTalentProfilePermanentlyMutationHookResult = ReturnType<typeof useSelfDeleteTalentProfilePermanentlyMutation>;
export type SelfDeleteTalentProfilePermanentlyMutationResult = Apollo.MutationResult<SelfDeleteTalentProfilePermanentlyMutation>;
export type SelfDeleteTalentProfilePermanentlyMutationOptions = Apollo.BaseMutationOptions<SelfDeleteTalentProfilePermanentlyMutation, SelfDeleteTalentProfilePermanentlyMutationVariables>;
export const TalentCategoriesDocument = gql`
    query TalentCategories {
  talentCategories {
    id
    name
    slug
    created_at
    updated_at
    subcategories {
      id
      name
    }
  }
}
    `;

/**
 * __useTalentCategoriesQuery__
 *
 * To run a query within a React component, call `useTalentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTalentCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<TalentCategoriesQuery, TalentCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentCategoriesQuery, TalentCategoriesQueryVariables>(TalentCategoriesDocument, options);
      }
export function useTalentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentCategoriesQuery, TalentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentCategoriesQuery, TalentCategoriesQueryVariables>(TalentCategoriesDocument, options);
        }
// @ts-ignore
export function useTalentCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentCategoriesQuery, TalentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentCategoriesQuery, TalentCategoriesQueryVariables>;
export function useTalentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentCategoriesQuery, TalentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentCategoriesQuery | undefined, TalentCategoriesQueryVariables>;
export function useTalentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentCategoriesQuery, TalentCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentCategoriesQuery, TalentCategoriesQueryVariables>(TalentCategoriesDocument, options);
        }
export type TalentCategoriesQueryHookResult = ReturnType<typeof useTalentCategoriesQuery>;
export type TalentCategoriesLazyQueryHookResult = ReturnType<typeof useTalentCategoriesLazyQuery>;
export type TalentCategoriesSuspenseQueryHookResult = ReturnType<typeof useTalentCategoriesSuspenseQuery>;
export type TalentCategoriesQueryResult = Apollo.QueryResult<TalentCategoriesQuery, TalentCategoriesQueryVariables>;
export const TalentsCountByCategoriesDocument = gql`
    query TalentsCountByCategories($category_ids: [ID]) {
  talentsCountByCategories(category_ids: $category_ids) {
    talents_count
    name
    slug
  }
}
    `;

/**
 * __useTalentsCountByCategoriesQuery__
 *
 * To run a query within a React component, call `useTalentsCountByCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentsCountByCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentsCountByCategoriesQuery({
 *   variables: {
 *      category_ids: // value for 'category_ids'
 *   },
 * });
 */
export function useTalentsCountByCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>(TalentsCountByCategoriesDocument, options);
      }
export function useTalentsCountByCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>(TalentsCountByCategoriesDocument, options);
        }
// @ts-ignore
export function useTalentsCountByCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>;
export function useTalentsCountByCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentsCountByCategoriesQuery | undefined, TalentsCountByCategoriesQueryVariables>;
export function useTalentsCountByCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>(TalentsCountByCategoriesDocument, options);
        }
export type TalentsCountByCategoriesQueryHookResult = ReturnType<typeof useTalentsCountByCategoriesQuery>;
export type TalentsCountByCategoriesLazyQueryHookResult = ReturnType<typeof useTalentsCountByCategoriesLazyQuery>;
export type TalentsCountByCategoriesSuspenseQueryHookResult = ReturnType<typeof useTalentsCountByCategoriesSuspenseQuery>;
export type TalentsCountByCategoriesQueryResult = Apollo.QueryResult<TalentsCountByCategoriesQuery, TalentsCountByCategoriesQueryVariables>;
export const TalentsCountBySubcategoriesDocument = gql`
    query TalentsCountBySubcategories($subcategory_ids: [ID]) {
  talentsCountBySubcategories(subcategory_ids: $subcategory_ids) {
    talents_count
    name
    slug
  }
}
    `;

/**
 * __useTalentsCountBySubcategoriesQuery__
 *
 * To run a query within a React component, call `useTalentsCountBySubcategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentsCountBySubcategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentsCountBySubcategoriesQuery({
 *   variables: {
 *      subcategory_ids: // value for 'subcategory_ids'
 *   },
 * });
 */
export function useTalentsCountBySubcategoriesQuery(baseOptions?: Apollo.QueryHookOptions<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>(TalentsCountBySubcategoriesDocument, options);
      }
export function useTalentsCountBySubcategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>(TalentsCountBySubcategoriesDocument, options);
        }
// @ts-ignore
export function useTalentsCountBySubcategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>;
export function useTalentsCountBySubcategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentsCountBySubcategoriesQuery | undefined, TalentsCountBySubcategoriesQueryVariables>;
export function useTalentsCountBySubcategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>(TalentsCountBySubcategoriesDocument, options);
        }
export type TalentsCountBySubcategoriesQueryHookResult = ReturnType<typeof useTalentsCountBySubcategoriesQuery>;
export type TalentsCountBySubcategoriesLazyQueryHookResult = ReturnType<typeof useTalentsCountBySubcategoriesLazyQuery>;
export type TalentsCountBySubcategoriesSuspenseQueryHookResult = ReturnType<typeof useTalentsCountBySubcategoriesSuspenseQuery>;
export type TalentsCountBySubcategoriesQueryResult = Apollo.QueryResult<TalentsCountBySubcategoriesQuery, TalentsCountBySubcategoriesQueryVariables>;
export const UpdateTalentEmailDocument = gql`
    mutation UpdateTalentEmail($email: Email!) {
  updateTalentEmail(email: $email)
}
    `;
export type UpdateTalentEmailMutationFn = Apollo.MutationFunction<UpdateTalentEmailMutation, UpdateTalentEmailMutationVariables>;

/**
 * __useUpdateTalentEmailMutation__
 *
 * To run a mutation, you first call `useUpdateTalentEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTalentEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTalentEmailMutation, { data, loading, error }] = useUpdateTalentEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateTalentEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTalentEmailMutation, UpdateTalentEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTalentEmailMutation, UpdateTalentEmailMutationVariables>(UpdateTalentEmailDocument, options);
      }
export type UpdateTalentEmailMutationHookResult = ReturnType<typeof useUpdateTalentEmailMutation>;
export type UpdateTalentEmailMutationResult = Apollo.MutationResult<UpdateTalentEmailMutation>;
export type UpdateTalentEmailMutationOptions = Apollo.BaseMutationOptions<UpdateTalentEmailMutation, UpdateTalentEmailMutationVariables>;